<template>
  <div>
    <!--弹窗模块-->
    <div v-if="isShow2" class="progress-container">

      搭建进度：
      <el-progress :percentage="uploadProgress2" :text-inside="false" :color="customColors" :stroke-width="4" />
    </div>
    <div v-if="isShow" class="progress-container2">

      上传素材进度：
      <el-progress v-if="isShow" :percentage="uploadProgress" :text-inside="false" :color="customColors"
        :stroke-width="4" />
    </div>

    <!-- 查看搭建记录 - 始终可见 -->


    <!-- 搭建记录弹窗 -->
    <el-dialog title="搭建记录（按账户维度）" :visible.sync="buildLogDialogVisible" width="90%" :close-on-click-modal="false">
      <div style="margin-bottom: 10px; display: flex; align-items: center; gap: 10px;">
        <el-select v-model="buildLogFilterAccount" placeholder="按账户筛选" clearable filterable style="width: 250px;">
          <el-option v-for="item in buildLogAccountList" :key="item" :label="item" :value="item"></el-option>
        </el-select>
        <el-button type="danger" size="small" @click="clearBuildLogs"
          :disabled="buildLogs.length === 0">清空记录</el-button>
        <span style="margin-left: auto;">
          总计：<b>{{ buildLogs.length }}</b> 条（最新在前）
        </span>
      </div>
      <el-table :data="filteredBuildLogs" border stripe style="width: 100%" max-height="500" size="small">
        <el-table-column prop="accountName" label="账户名" width="150" fixed></el-table-column>
        <el-table-column prop="accountId" label="广告主ID" width="180"></el-table-column>
        <el-table-column label="计划搭建" width="140" align="center">
          <template slot-scope="scope">
            <el-tag
              :type="scope.row.planStatus === '成功' ? 'success' : scope.row.planStatus === '失败' ? 'danger' : 'info'"
              size="small">
              {{ scope.row.planStatus }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="计划报错" min-width="180" show-overflow-tooltip>
          <template slot-scope="scope">
            <span :style="{ color: scope.row.planStatus === '失败' ? '#F56C6C' : '#909399' }">
              {{ scope.row.planMsg || '-' }}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="广告组搭建" width="140" align="center">
          <template slot-scope="scope">
            <el-tag
              :type="scope.row.groundStatus === '成功' ? 'success' : scope.row.groundStatus === '失败' ? 'danger' : 'info'"
              size="small">
              {{ scope.row.groundStatus }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="广告组报错" min-width="180" show-overflow-tooltip>
          <template slot-scope="scope">
            <span :style="{ color: scope.row.groundStatus === '失败' ? '#F56C6C' : '#909399' }">
              {{ scope.row.groundMsg || '-' }}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="广告创建" width="140" align="center">
          <template slot-scope="scope">
            <el-tag
              :type="scope.row.guanggaoStatus === '成功' ? 'success' : scope.row.guanggaoStatus === '失败' ? 'danger' : 'info'"
              size="small">
              {{ scope.row.guanggaoStatus }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="广告创建报错" min-width="200" show-overflow-tooltip>
          <template slot-scope="scope">
            <span :style="{ color: scope.row.guanggaoStatus === '失败' ? '#F56C6C' : '#909399' }">
              {{ scope.row.guanggaoMsg || '-' }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="timestamp" label="更新时间" width="180">
          <template slot-scope="scope">
            {{ formatBuildLogTime(scope.row.timestamp) }}
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>

    <!-- 弹窗 -->
    <!--    选中普通素材弹窗-->
    <el-dialog title="搭建配置" :visible.sync="countdialogVisible" width="500px" class="custom-dialog">
      <el-form label-position="left" label-width="180px" :model="countformData">
        <!-- 普通素材输入 -->
        <el-form-item label="单账户普通素材搭建数:">
          <el-input-number v-model="countformData.normalCount" :min="0" controls-position="right" placeholder="请输入数量"
            class="full-width-input"></el-input-number>
        </el-form-item>

        <!-- 撞审素材输入 -->
        <el-form-item label="撞审素材搭建数:">
          <el-input-number v-model="countformData.reviewCount" :min="0" controls-position="right" placeholder="请输入数量"
            class="full-width-input"></el-input-number>
        </el-form-item>

      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="countdialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleGetPlan" class="confirm-btn" :disabled="isLoading">
          {{ isLoading ? '处理中...' : '确 定' }}
        </el-button>
      </div>
    </el-dialog>
    <el-dialog title="选择文案" :visible.sync="sucaidialogVisible" width="900px" class="custom-dialog">


      <div>
        <el-input v-model="btgjc" style="width: 200px;" size="small">
        </el-input>
        <el-button type="primary" size="small" @click="Getbtklist" class="confirm-btn">查询</el-button>

      </div>
      <div>
        <el-table ref="multipleTable" row-key="id" :data="btkData" @selection-change="handleSelectionChange">
          <el-table-column type="selection" reserve-selection width="55">

          </el-table-column>
          <el-table-column type="index" width="50">
          </el-table-column>

          <el-table-column property="title" label="内容"></el-table-column>

        </el-table>
        <el-pagination background @current-change="handleCurrentChange" :page-size="20"
          layout="total, prev, pager, next" :total="total">
        </el-pagination>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="clonehandSelect()">取 消</el-button>
        <el-button type="primary" @click="GetmultipleSelection" class="confirm-btn">
          确 定 {{ multipleSelection.length > 0 ? multipleSelection.length : "" }}
        </el-button>
      </div>
    </el-dialog>
    <el-dialog title="选择跑量文案" :visible.sync="plsucaidialogVisible" width="900px" class="custom-dialog">
      <div>
        <el-input v-model="bltitle" style="width: 200px;" size="small">
        </el-input>
        <el-button type="primary" size="small" @click="plGetbtklist" class="confirm-btn">查询</el-button>
      </div>
      <div>
        <el-table ref="plmultipleTable" row-key="id" :data="plbtkData" @selection-change="plhandleSelectionChange">
          <el-table-column type="selection" reserve-selection width="55">

          </el-table-column>

          <el-table-column property="vltitle" label="内容"></el-table-column>
          <el-table-column property="income" width="150">
          </el-table-column>
        </el-table>
        <el-pagination background @current-change="handleCurrentChanges" :page-size="20"
          layout="total, prev, pager, next" :total="total">
        </el-pagination>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="clonehandSelects()">取 消</el-button>
        <el-button type="primary" @click="plGetmultipleSelection" class="confirm-btn">
          确 定 {{ plmultipleSelection.length > 0 ? plmultipleSelection.length : "" }}
        </el-button>
      </div>
    </el-dialog>
    <!-- 全屏弹窗 -->
    <template>
      <el-dialog v-if="showVue2" :visible.sync="showVue2" fullscreen :show-close="false"
        custom-class="fullscreen-dialog" @closed="onDialogClosed">
        <!-- 自定义标题栏 -->
        <template #title>
          <div class="dialog-header">
            <span>关闭按钮</span>
            <el-button type="danger" class="close-btn" icon="el-icon-close" @click.stop="closeDialog"
              circle></el-button>
          </div>
        </template>

        <!-- 内容容器 -->
        <div class="dialog-content-wrapper">
          <Vue2 :library="selectedLibrary" />
        </div>
      </el-dialog>
    </template>
    <el-container style="height: 2500px">

      <el-main style="height: 1000px">
        <!--搭建计划代码-->
        <el-card class="" style="padding: 20px;width: 55%">


          <div slot="header" class="clearfix">
            <div style="margin-bottom: 10px">
              <el-descriptions class="margin-top" title="微驰搭建平台" :column="3" border>
                <template slot="extra">
                  <el-dropdown @command="handleCommand">
                    <el-button type="primary" size="small"
                      :disabled="erroridslist.length === 0 && failedRequests.length === 0">
                      问题账户<i class="el-icon-arrow-down el-icon--right"></i>
                    </el-button>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item command="unbound" :disabled="erroridslist.length === 0">
                        未绑定账户 ({{ erroridslist.length }})
                      </el-dropdown-item>
                      <el-dropdown-item command="failed" :disabled="failedRequests.length === 0">
                        修改时段失败账户 ({{ failedRequests.length }})
                      </el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>



                  <el-dropdown @command="handleCommandframeSave">
                    <el-button type="primary" size="small" :disabled="videoframeSaveErrorlist.length == 0">
                      问题素材<i class="el-icon-arrow-down el-icon--right"></i>
                    </el-button>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item command="frameSave" :disabled="videoframeSaveErrorlist.length == 0">
                        生成封面失败 ({{ videoframeSaveErrorlist.length }})
                      </el-dropdown-item>
                      <!-- <el-dropdown-item command="failed" :disabled="failedRequests.length === 0">
                        修改时段失败账户 ({{ failedRequests.length }})
                      </el-dropdown-item> -->
                    </el-dropdown-menu>
                  </el-dropdown>



                  <el-dropdown @command="handleCleanCommand" trigger="click">
                    <el-button size="small" type="primary">
                      清理工具<i class="el-icon-arrow-down el-icon--right"></i>
                    </el-button>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item command="cleanTool">清理工具</el-dropdown-item>
                      <el-dropdown-item command="cleanNormal">清空普通素材</el-dropdown-item>
                      <el-dropdown-item command="cleanSpecial">清空撞审素材</el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                  <el-button type="primary" @click="templateDialogVisibleChange" size="small">历史模板</el-button>
                  <el-button type="primary" @click="saveTemplate" size="small">自定义模板</el-button>
                  <el-button type="primary" @click="countdialogVisible = true" size="small"
                    :disabled="uploading">批量搭建</el-button>
                  <el-button type="primary" @click="buildLogDialogVisible = true" size="small">
                    查看搭建记录
                    <!-- <el-badge v-if="buildLogs.length > 0" :value="buildLogs.length" :max="99" class="item" style="margin-left: 5px;" /> -->
                  </el-button>
                  <el-button type="primary" @click="goBatchUpload" size="small">批量上传</el-button>

                </template>
                <el-descriptions-item>
                  <template slot="label">
                    <i class="el-icon-user"></i>
                    账户名
                  </template>
                  <div class="block">
                    <!-- <el-select v-model="username" filterable placeholder="请选择" @change="GetRo">
                      <el-option v-for="(items, i) in listname" :key="i" :value="items.username">
                      </el-option>
                    </el-select> -->
                    <el-input type="textarea" v-model="username" style="width: 200px; text-align: left;">
                    </el-input>


                    <el-select v-model="selectedRegion" placeholder="请选择区域" style="width: 100px"
                      @change="handleRegionChange">
                      <el-option v-for="item in regionOptions" :key="item.value" :label="item.label"
                        :value="item.value" />
                    </el-select>

                    <el-button type="primary" @click="findIds()">查 询</el-button>

                  </div>
                </el-descriptions-item>
                <el-descriptions-item>
                  <!--                  <template slot="label">-->
                  <!--                    <i class="el-icon-mobile-phone"></i>-->
                  <!--                    登录二代-->
                  <!--                  </template>-->
                  <!--                  微驰-->

                  <div class="flex justify-between items-center">
                    <div>
                      <span class="text-lg font-bold">今日总搭建数量：</span>
                      <span class="text-xl text-primary">{{ advRecordTodayTotal }}</span>
                    </div>
                    <el-button type="primary" size="small" @click="openAdvRecordDetailDialog">
                      查看详情
                    </el-button>
                  </div>
                </el-descriptions-item>
                <el-descriptions-item>
                  <!-- <template slot="label">
                    <i class="el-icon-location-outline"></i>
                    账户列表
                  </template>

                  <el-select v-model="towName" filterable placeholder="请选择" @change="findIds">
                    <el-option v-for="(items, i) in two" :key="i" :value="items.twoname">
                    </el-option>
                  </el-select> -->

                </el-descriptions-item>


                <el-descriptions-item>
                  <template slot="label">
                    <i class="el-icon-office-building"></i>
                    广告主账户列表
                  </template>
                  <!--            <el-select v-model="idsname" placeholder="请选择">-->
                  <!--              <el-option-->
                  <!--                v-for="(items,i) in idsList"-->
                  <!--                :key="i"-->
                  <!--                :value="items.idsname">-->
                  <!--              </el-option>-->
                  <!--            </el-select>-->
                  <el-tag :key="i" v-for="(item, i) in idsList">{{ item.twoname }}</el-tag>
                  <el-cascader v-model="erjihangye" :options="options5" filterable @change="handleCascaderChange">
                  </el-cascader>

                  <el-checkbox v-model="isChecked" @change="handleCheckboxChange"
                    style="margin-right: 10px;margin-left: 10px">
                    启用选项
                  </el-checkbox>

                  <el-select v-model="selectedOption" :disabled="!isChecked" placeholder="请选择选项" clearable
                    style="width: 200px" @change="handleSelectChange">
                    <el-option v-for="item in dropdownOptions" :key="item.value" :label="item.label"
                      :value="item.value" />
                  </el-select>
                  <!-- <el-input type="number" v-model="erjihangyenumber" style="width: 150px; text-align: left;margin-left: 50px;" placeholder="选择第几个资质" /> -->
                </el-descriptions-item>
              </el-descriptions>

              <br>
              <!-- 查询按钮 -->


              <div style="float: left">
                <el-select v-model="selectedCategoryName" placeholder="请选择分类" @change="handleCategoryChange"
                  style="width: 200px; margin-right: 10px;">
                  <el-option v-for="category in categories" :key="category.categoryId" :label="category.categoryName"
                    :value="category.categoryName"></el-option>
                </el-select>
                <!-- 查询按钮 -->
                <el-button type="primary" @click="handleQuery">添加商品库</el-button>
                <el-button type="danger" @click="clearShangPing">清空商品数据</el-button>
                <!-- 判断list是否为空，若不为空则显示选择框 -->
                <el-select v-if="categoryList.length > 0" v-model="categoryName" @change="CategorySelectHandle"
                  placeholder="请选择" style="width: 200px; margin-right: 10px;">

                  <el-option v-for="item in categoryList" :key="item.id" :label="item.name"
                    :value="item.id"></el-option>
                </el-select>
              </div>


            </div>
            <br>


            <el-form label-position="left" :model="formLabelAlign">
              <el-form-item label="转化监测:" style="margin-bottom: 8px; text-align: left;">
                <el-radio-group v-model="formLabelAlign.conversionMonitorType">
                  <el-radio-button label="0">普通</el-radio-button>
                  <el-radio-button label="1">增效</el-radio-button>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="计划名称:" style="margin-bottom: 8px; text-align: left;">
                <el-input v-model="formLabelAlign.name" style="width: 200px; text-align: left;">
                </el-input>
              </el-form-item>
              <el-form-item label="计划预算:" style="margin-bottom: 8px;text-align: left;">
                <el-input placeholder="不填代表不限" v-model="formLabelAlign.dailyBudget"
                  style="width: 200px; text-align: left;">
                </el-input>
              </el-form-item>
              <el-form-item label="选择素材库:" style="margin-bottom: 8px;text-align: left;">
                <el-select v-model="selectedLibrary" value-key="id" placeholder="请选择素材库" filterable
                  @change="SelectionChangesucai" style="width: 20%">
                  <el-option v-for="item in libraryOptions" :key="item.id" :label="item.scName" :value="item" />
                </el-select>
              </el-form-item>
              <el-form-item label="推广目标" style="margin-bottom: 8px; text-align: left;">
                <el-radio-group v-model="beSelectAdType" style="text-align: left;">
                  <el-radio-button v-for="item in adTypeList" :key="item.value" :label="item.value" style="">
                    {{ item.label }}
                  </el-radio-button>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="投放渠道:" style="margin-bottom: 8px; text-align: left;">
                <el-radio-group v-model="formLabelAlign.mediaType" style="text-align: left;">
                  <el-radio-button v-for="item in option1" :key="item.value" :label="item.value" style="">
                    {{ item.label }}
                  </el-radio-button>
                </el-radio-group>
              </el-form-item>
              <!-- <el-form-item label="投放场景:" style="margin-bottom: 8px; text-align: left;">
                <el-radio-group v-model="formLabelAlign1.nobidBiddingStrategy" style="text-align: left;">
                  <el-radio-button v-for="item in option6" :key="item.value" :label="item.value" style="">
                    {{ item.label }}
                  </el-radio-button>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="日限额:" style="margin-bottom: 8px; text-align: left;"
                v-if="formLabelAlign1.nobidBiddingStrategy == 1">
                <el-input style="width: 100px;" v-model="formLabelAlign1.dailyBudget"></el-input>
                元
              </el-form-item> -->
              <!-- <el-form-item label="小程序id:" v-if="this.beSelectAdType==11" style="margin-bottom: 8px; text-align: left;">
                <el-input style="width: 200px;"  v-model="formLabelAlign1.appletOriginId"></el-input>
              </el-form-item>
              <el-form-item label="小程序页面路径:" v-if="this.beSelectAdType==11" style="margin-bottom: 8px; text-align: left;">
                <el-input style="width: 200px;"  v-model="formLabelAlign1.appletPath"></el-input>
              </el-form-item> -->
              <el-form-item style="margin-bottom: 8px; text-align: left;">
                <div style="display: flex; align-items: center;">
                  <div style="margin-right: 20px; display: flex; align-items: center;">
                    <span style="margin-right: 8px; font-weight: 500;">计划开关</span>
                    <el-switch v-model="flag" active-color="#13ce66" inactive-color="#ff4949">
                    </el-switch>
                  </div>
                  <div style="margin-right: 20px; display: flex; align-items: center;">
                    <span style="margin-right: 8px; font-weight: 500;">最新计划</span>
                    <el-switch v-model="newplanflag" active-color="#13ce66" inactive-color="#ff4949">
                    </el-switch>
                  </div>
                  <div style="display: flex; align-items: center;">
                    <span style="margin-right: 8px; font-weight: 500;">微信关注</span>
                    <el-switch v-model="isguanz" active-color="#13ce66" inactive-color="#ff4949">
                    </el-switch>
                  </div>

                  <div style="margin-left: 20px; display: flex; align-items: center;">
                    <span style="margin-right: 8px; font-weight: 500;">是否开启随机封面</span>
                    <el-switch v-model="videorangeFMSwitch" active-color="#13ce66" inactive-color="#ff4949">
                    </el-switch>
                  </div>
                </div>
              </el-form-item>
              <el-form-item style="margin-bottom: 8px; text-align: left;">
                <div style="display: flex; align-items: center;">
                  <div style="margin-right: 20px; display: flex; align-items: center;">
                    <span style="margin-right: 8px; font-weight: 500;">使用已存在广告组</span>
                    <el-switch v-model="newgroupflag" active-color="#13ce66" inactive-color="#ff4949">
                    </el-switch>
                  </div>
                </div>
              </el-form-item>

              <el-form-item style="margin-bottom: 8px; text-align: left;">
                <div style="display: flex; align-items: center;">

                </div>
              </el-form-item>


              <el-form-item label="已存在广告组查找方式:" style="margin-bottom: 8px; text-align: left;" v-if="newgroupflag">
                <el-select v-model="Eagoptionsvalue" placeholder="请选择">
                  <el-option v-for="item in Eagoptions" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
              <!-- <el-form-item label="广告组使用：" style="margin-bottom: 8px; text-align: left;" v-if="newgroupflag">
                <el-radio-group v-model="group_optionatus" style="text-align: left;">
                  <el-radio-button v-for="item in group_option" :key="item.value" :label="item.value" style="">
                    {{ item.label }}
                  </el-radio-button>
                </el-radio-group>
                <el-popover placement="top" trigger="hover" width="200">

                  <i slot="reference" class="el-icon-question help-icon"></i>


                  <div class="help-content">
                    1.当近七日或近一个月消耗最高不存在时会新建广告组
                    2.手选广告组在当前广告计划不存在广告组时会新建广告组
                  </div>
                </el-popover>
              </el-form-item> -->
              <el-form-item label="设置指定广告组：" style="margin-bottom: 8px; text-align: left;">
                <el-input type="number" v-model="orderexistgroup" placeholder="请输入在第几条广告组搭建"
                  style="width:250px;"></el-input>

              </el-form-item>
              <el-form-item label="时间范围选择器：" style="margin-bottom: 8px; text-align: left;" v-if="Eagoptionsvalue == 1">
                <div class="vivoexistgroup-date-range-picker">
                  <!-- 时间范围选择器 -->
                  <el-date-picker v-model="vivoexistgroupDateRange" type="daterange" align="right" unlink-panels
                    :picker-options="vivoexistgroupPickerOptions" range-separator="至" start-placeholder="开始日期"
                    end-placeholder="结束日期" value-format="yyyy-MM-dd" :default-value="vivoexistgroupDefaultDateRange"
                    @change="handleVivoexistgroupDateChange" size="medium" class="vivoexistgroup-date-picker">
                  </el-date-picker>


                </div>
              </el-form-item>
            </el-form>



            <!-- 第二个卡片内容 参数-->
            <el-form label-position="right" :model="formLabelAlign1">
              <el-form-item label="转化目标:" style="text-align: left;">
                <el-radio-group v-model="formLabelAlign1.cvType" style="text-align: left;">
                  <el-radio-button v-for="item1 in options3" :key="item1.value" :label="item1.value">
                    {{ item1.label }}
                  </el-radio-button>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="二阶出价:" style="margin-top: 20px;text-align: left;">
                <el-tag> 是否使用最新广告组出价</el-tag>
                <el-switch v-model="isoldgroupprice" active-color="#13ce66" inactive-color="#ff4949">
                </el-switch>
                <el-input style="width: 100px;" v-model="formLabelAlign1.ocpxPrice"></el-input>
                元
              </el-form-item>
              <el-form-item v-if="canDeepOpt" label="深度优化转化目标:" style="margin-top: 20px;text-align: left;">
                <el-tag> 是否开启深度优化转化目标</el-tag>
                <el-switch v-model="isDeepOpt" active-color="#13ce66" inactive-color="#ff4949">
                </el-switch>

                <transition name="el-zoom-in-top">
                  <div v-if="isDeepOpt" class="checkbox-section">
                    <div style="display: flex; align-items: center; gap: 8px; margin-bottom: 8px;">
                      <el-tag style="flex-shrink:0; text-align: right; margin: 0">
                        深度优化转化目标:
                      </el-tag>
                      <el-select v-model="formLabelAlign1.secondCvType" placeholder="请选择" style="width: 200px;">
                        <el-option v-for="item in secondCvTypeOptions" :key="item.value" :label="item.label"
                          :value="item.value"></el-option>
                      </el-select>
                    </div>
                    <div style="display: flex; align-items: center; gap: 8px;">
                      <el-tag style="flex-shrink:0; text-align: right; margin: 0">
                        深度优化出价:
                      </el-tag>
                      <el-input style="width: 100px;" v-model="formLabelAlign1.secondOcpxPrice"></el-input>
                      元
                    </div>
                  </div>
                </transition>
              </el-form-item>
              <div style="display: flex; align-items: center; gap: 8px">
                <el-tag style="flex-shrink:0; text-align: right; margin: 0">
                  人群包id(小写逗号分开):
                </el-tag>
                <el-input v-model="customList2" style="width: 200px;" size="small">
                </el-input>
              </div>
              <br>
              <div style="display: flex; align-items: center; gap: 8px">
                <el-tag style="flex-shrink:0; text-align: right; margin: 0">
                  排除人群包id(小写逗号分开):
                </el-tag>
                <el-input v-model="customListpc" style="width: 200px;" size="small">
                </el-input>
              </div>
              <el-form-item label="投放时间段:">
                <div class="time-range-container">
                  <div v-for="(range, index) in timeRanges" :key="index" class="time-range-item">
                    <el-time-select v-model="range.start" :picker-options="startOptions(index)" placeholder="起始时间"
                      :max-time="range.end" @change="handleStartChange(index)" />
                    <span class="separator">-</span>
                    <el-time-select v-model="range.end" :picker-options="endOptions(index)" placeholder="结束时间"
                      :min-time="range.start" @change="handleEndChange(index)" />
                    <el-button v-if="index === timeRanges.length - 1" type="text" icon="el-icon-plus" @click="addRange"
                      :disabled="isLastEndMax" />
                    <el-button v-if="timeRanges.length > 1" type="text" icon="el-icon-minus"
                      @click="removeRange(index)" />
                  </div>



                </div>
              </el-form-item>
              <el-form-item label="最新广告组投放时间段:" style="margin-top: 20px;text-align: left;">
                <el-tag> 是否使用最新广告组投放时间段</el-tag>
                <el-switch v-model="isoldgroupscheduleTime" active-color="#13ce66" inactive-color="#ff4949">
                </el-switch>

              </el-form-item>

              <el-form-item label="投放日期" style="text-align: left;">

                <div class="time-range-container">
                  <el-date-picker v-model="placement_time" type="daterange" range-separator="至" start-placeholder="开始日期"
                    end-placeholder="结束日期" @change="PlacementTimehange">
                  </el-date-picker>
                </div>

                <el-tag> 是否开启周期稳投</el-tag>
                <el-switch v-model="isdeliveryScene" active-color="#13ce66" inactive-color="#ff4949"></el-switch>



              </el-form-item>
              <el-form-item label="是否选择预设定向" style="text-align: left;">
                <el-switch v-model="isPreset" active-text="预设定向" inactive-text="自定义定向"></el-switch>
              </el-form-item>
              <el-form-item label="安装定向:" style="text-align: left;">
                <el-radio-group v-model="installedApp">
                  <el-radio-button label="1">不限</el-radio-button>
                  <el-radio-button label="2">未安装</el-radio-button>
                  <el-radio-button label="3">已安装</el-radio-button>
                </el-radio-group>
              </el-form-item>

              <el-form-item v-if="isPreset" label="预设定向包" style="text-align: left;">
                <el-select v-model="presetValue" placeholder="请选择预设定向包" value-key="id" @change="handlePresetChange"
                  filterable>
                  <el-option v-for="item in parsedPresetOptions" :key="item.id" :label="item.directpkgname"
                    :value="item" :class="{ 'selected-option': presetValue && presetValue.id === item.id }">
                    <span v-if="presetValue && presetValue.id === item.id" class="selected-icon">✓</span>
                    {{ item.directpkgname }}
                  </el-option>
                </el-select>
              </el-form-item>

              <template v-else>
                <el-form-item label="地域定向:" style="text-align: left;">
                  <el-radio-group v-model="regionStatus">
                    <el-radio-button :label="0">不限</el-radio-button>
                    <el-radio-button :label="1">设置</el-radio-button>
                  </el-radio-group>

                  <transition name="el-zoom-in-top">
                    <div v-if="regionStatus == 1" class="checkbox-section">
                      <el-select v-model="beSelectDiYu" filterable placeholder="请选择" @change="diYuHandleSelectionChange">
                        <el-option v-for="(item, index) in diYuOptions" :key="index" :label="item.name"
                          :value="item.name"></el-option>
                      </el-select>
                    </div>
                  </transition>
                </el-form-item>
                <el-form-item label="性别:" style="text-align: left;">
                  <el-radio-group v-model="sex">
                    <el-radio-button label="男"></el-radio-button>
                    <el-radio-button label="女"></el-radio-button>
                    <el-radio-button label="不限"></el-radio-button>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="年龄(不选即不限):" style="text-align: left;">
                  <el-checkbox-group v-model="age">
                    <el-checkbox-button v-for="(item, i) in ages" :label="i" :key="i">
                      {{ item.value }}
                    </el-checkbox-button>
                  </el-checkbox-group>
                </el-form-item>
                <el-form-item label="安卓版本:" style="text-align: left;">
                  <el-radio-group v-model="androidVersionStatus">
                    <el-radio-button :label="0">不限</el-radio-button>
                    <el-radio-button :label="1">设置</el-radio-button>
                  </el-radio-group>

                  <transition name="el-zoom-in-top">
                    <div v-if="androidVersionStatus == 1" class="checkbox-section">
                      <div class="select-all-row">
                        <el-checkbox :indeterminate="isIndeterminateVersion" v-model="checkAllVersion"
                          @change="handleCheckAllVersionChange">
                          全选
                        </el-checkbox>
                        <span class="select-count">
                          已选择 {{ selectedVersions.length }}/{{ androidVersions.length }} 个版本
                        </span>
                      </div>

                      <el-alert v-if="checkAllVersion" title="提示：全选所有安卓版本与「不限」是不同的。全选会传入所有版本 ID，不限则不传此参数。"
                        type="warning" :closable="false" show-icon style="margin: 8px 0;">
                      </el-alert>

                      <el-checkbox-group v-model="selectedVersions" @change="handleVersionChange">
                        <el-checkbox v-for="(version, index) in androidVersions" :key="version.value"
                          :label="version.value">
                          {{ version.label }}
                        </el-checkbox>
                      </el-checkbox-group>
                    </div>
                  </transition>
                </el-form-item>
                <el-form-item label="购机价格" style="text-align: left;">
                  <el-radio-group v-model="phonePriceStatus">
                    <el-radio-button :label="0">不限</el-radio-button>
                    <el-radio-button :label="1">设置</el-radio-button>
                  </el-radio-group>

                  <transition name="el-zoom-in-top">
                    <div v-if="phonePriceStatus == 1" class="checkbox-section">
                      <div class="select-all-row">
                        <el-checkbox :indeterminate="isIndeterminatePrice" v-model="checkAllPrice"
                          @change="handleCheckAllPriceChange">
                          全选
                        </el-checkbox>
                        <span class="select-count">
                          已选择 {{ selectedPrices.length }}/{{ priceRanges.length }} 个价格区间
                        </span>
                      </div>

                      <el-alert v-if="checkAllPrice" title="提示：全选所有价格区间与「不限」是不同的。全选会传入所有价格 ID，不限则不传此参数。"
                        type="warning" :closable="false" show-icon style="margin: 8px 0;">
                      </el-alert>

                      <el-checkbox-group v-model="selectedPrices" @change="handlePriceChange">
                        <el-checkbox v-for="(priceRange, index) in priceRanges" :key="priceRange.value"
                          :label="priceRange.value">
                          {{ priceRange.label }}
                        </el-checkbox>
                      </el-checkbox-group>
                    </div>
                  </transition>
                </el-form-item>
                <el-form-item label="手机系列" style="text-align: left;" prop="number2">
                  <el-radio-group v-model="phoneSeriesstatus">
                    <el-radio-button :label="0">不限</el-radio-button>
                    <el-radio-button :label="1">设置</el-radio-button>
                  </el-radio-group>

                  <!-- 设置模式下的机型选择区域 -->
                  <transition name="el-zoom-in-top">
                    <div v-if="phoneSeriesstatus == 1" class="checkbox-section">
                      <!-- 全选按钮和计数 -->
                      <div class="select-all-row">
                        <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">
                          全选
                        </el-checkbox>
                        <span class="select-count">
                          已选择 {{ phoneSeriesSSelect.length }}/{{ phoneSerieslist.length }} 个系列
                        </span>
                      </div>

                      <!-- 全选警告提示 -->
                      <el-alert
                        v-if="checkAll"
                        title="提示：全选所有机型与「不限」是不同的。全选会传入所有机型 ID，不限则不传此参数。"
                        type="warning"
                        :closable="false"
                        show-icon
                        style="margin: 8px 0;">
                      </el-alert>

                      <!-- 机型复选框组 -->
                      <el-checkbox-group v-model="phoneSeriesSSelect" @change="handlePhoneSeriesChange">
                        <el-checkbox v-for="item in phoneSerieslist" :key="item.id" :label="item.id">
                          {{ item.name }}
                        </el-checkbox>
                      </el-checkbox-group>
                    </div>
                  </transition>
                </el-form-item>
              </template>
            </el-form>
            <el-form label-position="right" :model="formLabelAlign3">
              <el-form-item label="展现形式:" style="text-align: left;">
                <el-cascader style="text-align: left;" v-model="formLabelAlign3.placeType" :options="options4"
                  filterable @change="placeTypeChange">
                </el-cascader>
                <!-- 搜索提词素材规格提示（平台要求，2026-08-26）：按所选模板展示图片数量/尺寸/格式/大小 -->
                <div v-if="storeSearchCurrentSpec"
                  style="font-size: 12px; color: #909399; line-height: 20px; margin-top: 4px;">
                  {{ storeSearchSpecTip }}
                </div>
              </el-form-item>
              <!-- 搜索提词版位（placeType=21）专属设置：仅商品/应用直投（mediaType=0）且选择搜索提词时显示 -->
              <el-form-item label="选词模式:" v-if="isStoreSearchPlacement" style="text-align: left;">
                <el-radio-group v-model="formLabelAlign3.wordChoiceModel">
                  <el-radio-button :label="1">搜索题词</el-radio-button>
                  <el-radio-button :label="2">优选词包</el-radio-button>
                </el-radio-group>
              </el-form-item>
              <!-- 标签气泡专属设置：仅模板类型=15 时显示（doc 269 常见问题：labelDesc 2-5字，labelColor 四选一） -->
              <el-form-item label="标签气泡文案:" v-if="isStoreSearchPlacement && Number(formLabelAlign3.placeType[2]) === 15"
                            style="text-align: left;">
                <el-input v-model="formLabelAlign3.labelDesc" style="width: 200px" maxlength="5"
                          placeholder="2-5个字"></el-input>
              </el-form-item>
              <el-form-item label="标签气泡颜色:" v-if="isStoreSearchPlacement && Number(formLabelAlign3.placeType[2]) === 15"
                            style="text-align: left;">
                <el-select v-model="formLabelAlign3.labelColor" placeholder="请选择" popper-class="label-color-popper"
                  class="label-color-select" style="width: 200px">
                  <el-option v-for="opt in labelColorOptions" :key="opt.value" :label="opt.label" :value="opt.value">
                    <span class="label-color-dot" :style="{ backgroundColor: opt.value }"></span>
                    <span class="label-color-name">{{ opt.label }}</span>
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="流量优选:" v-if="isStoreSearchPlacement" style="text-align: left;">
                <el-switch v-model="formLabelAlign3.generalSwitch" :active-value="1" :inactive-value="0"
                  active-text="开启" inactive-text="关闭">
                </el-switch>
              </el-form-item>
              <!-- <el-form-item label="是否开启混搭" style="text-align: left;"  prop="number">
                <el-switch v-model="mixminvalue" active-color="#13ce66" inactive-color="#ff4949">
                        </el-switch>
              </el-form-item> -->
              <el-form-item label="搭建策略" style="text-align: left;" prop="number2">
                <el-radio-group v-model="mixminvaluelate">
                  <el-radio-button label="重复"></el-radio-button>
                  <el-radio-button label="轮询"></el-radio-button>
                </el-radio-group>
              </el-form-item>


              <el-form-item label="投放位置:" style="text-align: left;" v-if="!isStoreSearchPlacement">
                <el-select v-model="virtualPositionvalue" multiple collapse-tags style="
    /* margin-left: 20px; */
    width: 100%;
    min-width: 200px;
    max-width: 300px;
  " :style="{
    'flex': '1',

  }" placeholder="请选择">
                  <el-option v-for="item in virtualPositionoptions" :key="item.virtualPositionUuid"
                    :label="item.virtualPositionName" :value="item.virtualPositionUuid">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="标题打乱(默认打开):" style="text-align: left;">
                <el-switch v-model="daluan" active-color="#13ce66" inactive-color="#ff4949" style="text-align: left;">
                </el-switch>
              </el-form-item>
              <!-- <el-form-item label="落地页" style="text-align: left;">
                <el-select v-model="beSelectDiYu" filterable placeholder="请选择" @change="luodiyeSelectionChange">
                  <el-option label="悟空建站" value="3"></el-option>
                  <el-option label="自定义URL" value="2"></el-option>

                  </el-select>
              </el-form-item> -->
              <div v-for="(product, index) in formLabelAlign3.productNames" :key="index" class="product-input">
                <el-form-item :label="'*产品名 ' + (index + 1) + ':'" style="text-align: left;">
                  <el-input v-model="formLabelAlign3.productNames[index]" style="width: 200px;"></el-input>
                  <el-button @click="addProduct" type="primary" size="small">
                    添加产品名
                  </el-button>
                  <el-button v-if="formLabelAlign3.productNames.length > 1" @click="removeProduct(index)" type="danger"
                    size="mini">
                    删除
                  </el-button>
                </el-form-item>
              </div>

              <el-form-item :label="'标题：' + formLabelAlign3.title.length + '个'" style="text-align: left;">
                <el-input type="textarea" style="width: 440px;" v-model="titlesString" placeholder="请输入标题（每行一个）"
                  :rows="9" @input="handleInput"></el-input>
                <el-button @click="selectbt(1)" type="primary" size="small">
                  选择标题
                </el-button>
                <el-button @click="selectbts(1)" type="primary" size="small">
                  跑量标题库
                </el-button>
                <div style="display: flex;">
                  <div v-for="(line, index) in linesWithLimitError" :key="index"
                    style="color: red; font-size: 12px; margin-top: 5px;">
                    第{{ index + 1 }}行超出字符限制（最多 {{ maxLength }} 字）：{{ line }}
                  </div>

                </div>
              </el-form-item>
              <el-form-item label="撞审标题/商店搜索词：" style="text-align: left;">
                <el-input type="textarea" style="width: 440px;" v-model="zstitlesString" placeholder="请输入撞审标题/商店搜索词（每行一个）"
                  :rows="9" @input="zshandleInput"></el-input>
                <el-button @click="selectbt(2)" type="primary" size="small">
                  选择撞审标题
                </el-button>
                <el-button @click="selectbts(2)" type="primary" size="small">
                  跑量撞审标题库
                </el-button>
                <div v-for="(line, index) in zslinesWithLimitError" :key="index"
                  style="color: red; font-size: 12px; margin-top: 5px;">
                  <!-- <右></右> -->
                  <div>右</div>
                  侧文案超出字符限制，最多 {{ maxLength }} 个字符：{{ line }}
                </div>
              </el-form-item>
            </el-form>


          </div>
        </el-card>
        <!--图片素材代码-->
        <!--            <el-card class="box-cards" style="height:15%;">-->
        <!--              <div slot="header" class="clearfix">-->
        <!--                <span >批量搭建任务进度</span>-->
        <!--              </div>-->
        <!--              <el-row>-->
        <!--                <el-progress style="width: 50%;margin:0 auto;" :text-inside="false" :stroke-width="26"  status="success" :percentage="percentages"></el-progress>-->
        <!--              </el-row>-->

        <!--            </el-card>-->

        <el-dialog :title="`上传图片（已选择 ${imgList.length} 张）`" :visible.sync="uploadDialogVisible" width="500px"
          :modal="false">
          <el-upload class="upload-wrapper" drag action="#" :auto-upload="false" :multiple="true" ref="upload"
            :file-list="imgList" :on-change="handleFileChange" :on-success="handleUploadSuccess"
            :before-upload="beforeUpload" :show-file-list="false">
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">
              将文件拖到此处，或<em>点击上传</em>
            </div>
            <div class="el-upload__tip" slot="tip">
              {{ storeSearchSpecTip || '支持JPEG/PNG格式' }}
            </div>
          </el-upload>

          <!-- 底部操作按钮 -->
          <template slot="footer">
            <div class="dialog-footer">
              <el-button type="danger" @click="imgReset">重 置</el-button>
              <el-button @click="uploadDialogVisible = false">取 消</el-button>
              <el-button type="primary" :loading="uploading" @click="handleConfirmUpload">
                确 定（{{ imgList.length }}）
              </el-button>
            </div>
          </template>
        </el-dialog>
        <el-tabs class="box-card" v-model="updateType">
          <el-dialog :title="`上传视频（已选择 ${videoList.length} 个）`" :visible.sync="videouploadDialogVisible" width="500px"
            :modal="false">
            <el-upload class="upload-wrapper" drag action="#" :auto-upload="false" :multiple="true" ref="upload"
              :file-list="videoList" :on-change="videohandleFileChange" :on-success="videohandleUploadSuccess"
              :show-file-list="false">
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">
                将文件拖到此处，或<em>点击上传</em>
              </div>
              <div class="el-upload__tip" slot="tip">
                支持MP4格式
              </div>
              <el-progress v-if="isShow" :percentage="uploadProgress" :text-inside="false" :color="customColors"
                :stroke-width="4" />
            </el-upload>
            <el-form class="query-form">
              <el-form-item label="上传倍数">
                <el-input-number v-model="uploadMultiple" :min="1" :max="100" :precision="0" controls-position="right"
                  style="width: 150px"></el-input-number>
                <span class="ml-10 text-gray" style="margin-left: 10px; color: #909399;">同一个视频将生成指定数量的条目</span>
              </el-form-item>
            </el-form>

            <!-- 底部操作按钮 -->
            <template slot="footer">
              <div class="dialog-footer">
                <el-button type="danger" @click="videoReset">重 置</el-button>
                <el-button @click="handleCancelUpload">取 消</el-button>
                <el-button type="primary" :loading="videouploading" @click="videohandleConfirmUpload">
                  确 定（{{ videoList.length }}）
                </el-button>
              </div>
            </template>
          </el-dialog>
          <el-tab-pane label="头像" name="first">
            <el-card class="box-card" style="height:90%;overflow: auto;">
              <div slot="header" class="clearfix" style="padding: 18px 20px;">
                <div style="position: absolute;left: 5%;top: 4%;">
                  本地上传:
                  <el-switch v-model="localselection" active-color="#13ce66" @change="swtichonchange"
                    inactive-color="#ff4949">
                  </el-switch>

                  <div style="position: absolute;right: 5%;top: 4%;">

                  </div>
                </div>
                <span style="font-weight: 500;">注意辨别是否需要头像</span>
              </div>
              <div style="padding: 0 20px;">
                <el-button type="primary" @click="txonChange" size="small" style="margin-bottom: 15px;">选择头像
                </el-button>

                <!-- 头像展示区域 -->
                <div style="width: 100%; padding: 20px 0; text-align: center;">
                  <template v-if="txfileList && txfileList.length > 0">
                    <el-image :src="getImageUrl(txfileList[0])" style="
              height: 300px;
              width: 300px;

              border: 2px solid #FFFFFF;
              box-shadow: 0 2px 12px 0 rgba(0,0,0,0.1);
              object-fit: cover;
              cursor: pointer;
              transition: all 0.3s ease;
            " @mouseover="e => e.currentTarget.style.transform = 'scale(1.05)'"
                      @mouseout="e => e.currentTarget.style.transform = 'scale(1)'"></el-image>
                  </template>
                  <div v-else style="
            color: #909399;
            font-size: 14px;
            padding: 20px;
            background: #f5f7fa;
            border-radius: 4px;
          ">暂无头像，请点击上方按钮选择
                  </div>
                </div>
              </div>
            </el-card>

          </el-tab-pane>

          <el-tab-pane label="图片" name="second">
            <el-card class="box-card" style="height:90%;overflow: auto;">
              <div slot="header" class="clearfix">
                <div style="position: absolute;left: 5%;top: 4%;">
                  本地上传:
                  <el-switch v-model="localselection" active-color="#13ce66" @change="swtichonchange"
                    inactive-color="#ff4949">
                  </el-switch>
                </div>
                <span>素材上传工作区</span>
              </div>
              <el-row>
                <div style="display:flex;align-items: center;" v-if="fileList.length > 0">
                  <div v-if="fileList.length > 0">
                    图片数量:{{ fileList.length }}
                  </div>
                  <div style="margin-left: 20px;">
                    <el-button @click="openerrorfiledlog"
                      :disabled="errorfile.length > 0 ? false : true">错误预览</el-button>
                  </div>
                </div>
                <el-upload ref="upload" :multiple="true" action="#" list-type="picture-card" :auto-upload="false"
                  :file-list="fileList" :on-remove="handleRemove" :http-request="function () { }"
                  :on-preview="handlePictureCardPreview">

                  <!-- 自定义触发按钮 -->
                  <div slot="trigger" class="upload-trigger" @click.stop="onChange">
                    <el-tag>选择图片素材</el-tag>
                  </div>

                  <!-- 自定义文件列表项 -->
                  <template slot="file" slot-scope="{ file }">
                    <div class="file-item">
                      <img class="el-upload-list__item-thumbnail"
                        :src="'https://ads-marketing-vivofs.vivo.com.cn/' + file.filePath" alt="">
                      <span class="el-upload-list__item-actions">
                        <span class="el-upload-list__item-preview" @click.stop="handlePictureCardPreview(file)">
                          <i class="el-icon-zoom-in"></i>
                        </span>
                        <span class="el-upload-list__item-delete" @click.stop="handleRemove(file)">
                          <i class="el-icon-delete"></i>
                        </span>
                      </span>
                    </div>
                  </template>
                </el-upload>

              </el-row>
            </el-card>
          </el-tab-pane>
          <el-tab-pane label="视频" name="third">
            <el-card class="box-card" style="height:90%;">
              <div slot="header" class="clearfix">
                <div style="position: absolute;left: 5%;top: 4%;">
                  本地上传:
                  <el-switch v-model="localselection" active-color="#13ce66" @change="swtichonchange"
                    inactive-color="#ff4949">
                  </el-switch>
                </div>
                <span>视频素材上传工作区</span>
              </div>
              <el-row>
                <div v-if="VideofileList.length > 0">
                  视频数量:{{ VideofileList.length }}
                </div>
                <!-- 自定义上传按钮 -->

                <div style="display: block">
                  <div>
                    <span>是否自动生成封面</span>
                    <el-switch v-model="videoFMSwitch" @change="videoFMSwitchonchang" active-color="#13ce66"
                      inactive-color="#ff4949">
                    </el-switch>
                  </div>
                  <el-button @click="onChange2">选择视频</el-button>

                </div>

                <!-- 已选列表 -->
                <div class="video-list">
                  <div v-for="(item, index) in VideofileList" :key="item.code" class="video-item">
                    <div class="video-content">
                      <span class="video-title">{{ item.title }}</span>
                      <div class="video-thumbnail">
                        <!-- <img :src="videofiletp[index]" alt=""> -->
                        <video :src="item.videourl" controls></video>
                      </div>
                      <el-button type="text" icon="el-icon-delete" @click="handleRemove2(item.code)"
                        class="delete-btn"></el-button>
                    </div>
                  </div>
                </div>
                <div style="margin-top: 20px;"></div>
              </el-row>
            </el-card>
          </el-tab-pane>
          <el-tab-pane label="撞审图片" name="fourth">
            <el-card class="box-card" style="height:90%;">
              <div slot="header" class="clearfix">
                <div style="position: absolute;left: 5%;top: 4%;">
                  本地上传:
                  <el-switch v-model="localselection" active-color="#13ce66" @change="swtichonchange"
                    inactive-color="#ff4949">
                  </el-switch>
                </div>
                <span>撞审图片素材上传工作区</span>
              </div>
              <el-row>
                <div v-if="zsfileList.length > 0">
                  撞审图片数量:{{ zsfileList.length }}
                </div>
                <el-upload ref="upload" :multiple="true" action="#" list-type="picture-card" :auto-upload="false"
                  :file-list="zsfileList" :on-remove="zshandleRemove" :http-request="function () { }"
                  :on-preview="zshandlePictureCardPreview">

                  <!-- 自定义触发按钮 -->
                  <div slot="trigger" class="upload-trigger" @click.stop="zsonChange">
                    <el-tag>选择图片素材</el-tag>
                  </div>

                  <!-- 自定义文件列表项 -->
                  <template slot="file" slot-scope="{ file }">
                    <div class="file-item">
                      <img class="el-upload-list__item-thumbnail"
                        :src="'https://ads-marketing-vivofs.vivo.com.cn/' + file.filePath" alt="">
                      <span class="el-upload-list__item-actions">
                        <span class="el-upload-list__item-preview" @click.stop="zshandlePictureCardPreview(file)">
                          <i class="el-icon-zoom-in"></i>
                        </span>
                        <span class="el-upload-list__item-delete" @click.stop="zshandleRemove(file)">
                          <i class="el-icon-delete"></i>
                        </span>
                      </span>
                    </div>
                  </template>
                </el-upload>

              </el-row>
            </el-card>
          </el-tab-pane>

          <el-tab-pane label="撞审视频" name="fifth">
            <el-card class="box-card" style="height:90%;">
              <div slot="header" class="clearfix">
                <div style="position: absolute;left: 5%;top: 4%;">
                  本地上传:
                  <el-switch v-model="localselection" active-color="#13ce66" @change="swtichonchange"
                    inactive-color="#ff4949">
                  </el-switch>
                </div>
                <span>撞审视频素材</span>
              </div>
              <el-row>
                <div v-if="zsVideofileList.length > 0">
                  撞审视频数量:{{ zsVideofileList.length }}
                </div>
                <!-- 自定义上传按钮 -->
                <div style="display: block">
                  <div>
                    <span>是否自动生成封面</span>
                    <el-switch v-model="zsvideoFMSwitch" @change="zsvideoFMSwitchonchange" active-color="#13ce66"
                      inactive-color="#ff4949">
                    </el-switch>
                  </div>
                  <el-button @click="zsonChange2">选择撞审视频</el-button>

                </div>

                <!-- 已选列表 -->
                <!-- <div class="video-list">
                  <div v-for="item in zsVideofileList" :key="item.code" class="video-item">
                    <span>{{ item.title }}</span>
                    <el-button type="text" icon="el-icon-delete" @click="zshandleRemove2(item.code)"></el-button>
                  </div>
                </div> -->
                <div class="video-list">
                  <div v-for="(item, index) in zsVideofileList" :key="item.code" class="video-item">
                    <div class="video-content">
                      <span class="video-title">{{ item.title }}</span>
                      <div class="video-thumbnail">
                        <!-- <img :src="videofiletp[index]" alt=""> -->
                        <video :src="item.videourl" controls></video>
                      </div>
                      <el-button type="text" icon="el-icon-delete" @click="zshandleRemove2(item.code)"
                        class="delete-btn"></el-button>
                    </div>
                  </div>
                </div>
              </el-row>
            </el-card>
          </el-tab-pane>
        </el-tabs>
        <el-dialog title="提示" :visible.sync="dialogVisible" width="60%" center>
          <el-image style="width: 600px; height: 600px" :src="dialogImageUrl"></el-image>
          <span slot="footer" class="dialog-footer">
            <el-button @click="centerDialogVisible = false">取 消</el-button>
            <!-- <el-button type="primary" @click="centerDialogVisible = false">确 定</el-button> -->
          </span>
        </el-dialog>

        <!-- 清理工具弹窗 -->
        <el-dialog title="修改时段失败列表" :visible.sync="failedRequestsDialogVisible" width="500px"
          @close="failedRequestsclaerfrom">
          <el-table :data="failedRequests" border stripe style="width: 100%" size="small">
            <el-table-column prop="ids" label="账户名" width="180" />
            <el-table-column prop="groupIds" label="广告id" width="180" />

          </el-table>

          <div slot="footer" class="dialog-footer">
            <el-button @click="failedRequestsDialogVisible = false">取消</el-button>

            <!--            <el-button type="primary" @click="confimuuid" >确认uuid</el-button>-->
            <el-button type="primary" @click="handlefailedRequestsDialogVisible">重试</el-button>
          </div>
        </el-dialog>
        <el-dialog title="清理工具" :visible.sync="cleanDialogVisible" width="500px" @close="resetCleanForm">
          <el-form :model="cleanForm" label-width="80px">
            <el-form-item label="选择区域" prop="hdname">
              <el-select v-model="cleanForm.hdname" placeholder="请选择区域" clearable style="width: 100%">
                <el-option label="浙江" value="浙江" />
                <el-option label="福建" value="福建" />
                <el-option label="深圳" value="深圳" />
                <el-option label="苏州" value="苏州" />
                <el-option label="广州力天" value="广州力天" />
              </el-select>
            </el-form-item>

            <!--            <el-form-item label="账号来源">-->
            <!--              <el-radio-group v-model="cleanForm.source">-->
            <!--                <el-radio label="account">搭建查询的账户</el-radio>-->
            <!--                <el-radio label="custom">自定义UUID</el-radio>-->
            <!--              </el-radio-group>-->
            <!--            </el-form-item>-->

            <el-form-item label="账户列表">
              <el-input type="textarea" v-model="cleanForm.customUuids" placeholder="每行一个账户名" :rows="5" />
            </el-form-item>

            <el-form-item label="保留日期">
              <el-date-picker v-model="cleanForm.cltime" type="date" value-format="yyyy-MM-dd" placeholder="选择日期"
                style="width: 100%" />
            </el-form-item>
          </el-form>

          <div slot="footer" class="dialog-footer">
            <el-button @click="cleanDialogVisible = false">取消</el-button>

            <!--            <el-button type="primary" @click="confimuuid" >确认uuid</el-button>-->
            <el-button type="primary" @click="handleClean" :loading="cleanLoading">确认清理</el-button>
          </div>
        </el-dialog>
        <el-dialog title="上传错误列表" :visible.sync="errorfiledlog" width="1200px" @close="errorCleanForm">
          <el-table :data="errorfile" border stripe style="width: 100%" size="small">
            <el-table-column prop="name" label="文件名" width="180" />
            <el-table-column prop="uid" label="UID" width="180" />
            <el-table-column label="预览图">
              <template slot-scope="scope">
                <img :src="'https://ads-marketing-vivofs.vivo.com.cn/' + scope.row.filePath" alt="预览图"
                  style="width: 450px; height: 450px; object-fit: contain; border-radius: 4px; background: #f0f0f0;" />
              </template>
            </el-table-column>
            <el-table-column prop="filePath" label="路径" />
          </el-table>
        </el-dialog>
        <el-dialog title="未绑定账户列表" :visible.sync="erroridsldlog" width="1200px" @close="errorCleanForm">
          <el-table :data="erroridslist" border stripe style="width: 100%" size="small">
            <el-table-column prop="ids" label="账户id" />
            <el-table-column prop="idsname" label="账户名" />


          </el-table>
        </el-dialog>

        <el-dialog title="未绑定账户列表" :visible.sync="frameSaveerroridsldlog" width="1200px" @close="errorCleanForm">
          <el-table :data="videoframeSaveErrorlists" border stripe style="width: 100%" size="small">
            <el-table-column prop="videourl" label="url" />
            <el-table-column prop="title" label="title" />
            <el-table-column prop="code" label="code" />

          </el-table>
        </el-dialog>


        <el-dialog title="模板管理" :visible.sync="templateDialogVisible" width="70%" @close="handleDialogClose">
          <el-form :inline="true" :model="queryParams" class="query-form">
            <el-form-item label="模板名称">
              <el-input v-model="queryParams.templateName" placeholder="请输入模板名称" clearable
                @keyup.enter.native="handleQuery"></el-input>
            </el-form-item>

            <el-form-item>
              <el-button type="primary" @click="handletemplateQuery">查询</el-button>
              <el-button @click="resettemplateQuery">重置</el-button>
            </el-form-item>
          </el-form>
          <el-table :data="templateList" border stripe style="width: 100%"
            @selection-change="handletemplateSelectionChange" ref="templateTable">

            <el-table-column prop="templateName" label="模板名称"></el-table-column>

            <el-table-column prop="createdAt" label="创建时间" width="180">
              <template slot-scope="scope">
                {{ formatTimestamp(scope.row.createdAt) }}
              </template>
            </el-table-column>

            <el-table-column label="操作" width="200" fixed="right">
              <template slot-scope="scope">
                <el-button size="mini" type="danger" @click="handletemplateDelete(scope.row)">删除</el-button>
                <el-button size="mini" type="success" @click="templateInfoChange(scope.row)">选中录入</el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination @size-change="handleSizeChange" @current-change="handletamplateCurrentChange"
            :current-page="queryParams.pageNum" :page-sizes="[10, 20, 50, 100]" :page-size="queryParams.pageSize"
            layout="total, sizes, prev, pager, next, jumper" :total="templatetotal" class="pagination"></el-pagination>


          <div slot="footer" class="dialog-footer">
            <el-button @click="templateDialogVisible = false">取消</el-button>
            <!-- <el-button type="primary" @click="handletemplateConfirm" :disabled="!selectedTemplate">确认选择</el-button> -->
          </div>


        </el-dialog>


        <!--        查看搭建数据弹窗-->
        <el-dialog title="搭建数量详情" :visible.sync="advRecordDetailDialogVisible" width="70%">
          <!-- 查询条件 -->
          <div class="mb-3 flex items-center">
            <el-date-picker v-model="advRecordQueryDate" type="date" value-format="yyyy-MM-dd" placeholder="选择日期"
              class="mr-2" @change="fetchAdvRecordDetailData" />
            <el-input v-model="advRecordQueryAccountName" placeholder="输入素材库名（模糊查询）" class="mr-2" clearable
              style="width: 200px" @keyup.enter.native="fetchAdvRecordDetailData" />
            <el-button type="primary" @click="fetchAdvRecordDetailData">查询</el-button>
          </div>

          <!-- 当前日期总数 -->
          <div class="mb-2">
            <span class="font-bold">该日期总搭建数量：</span>
            <span class="text-lg text-success">{{ advRecordDetailTotal }}</span>
            <span class="font-bold">浙江数量：</span>
            <span class="text-lg text-success">{{ zjadvRecordDetailTotal }}</span>
            <span class="font-bold">福建数量：</span>
            <span class="text-lg text-success">{{ fjadvRecordDetailTotal }}</span>

            <span class="font-bold">深圳数量：</span>
            <span class="text-lg text-success">{{ szadvRecordDetailTotal }}</span>
            <span class="font-bold">苏州数量：</span>
            <span class="text-lg text-success">{{ suzadvRecordDetailTotal }}</span>
            <span class="font-bold">广州力天数量：</span>
            <span class="text-lg text-success">{{ gzzadvRecordDetailTotal }}</span>

          </div>

          <!-- 表格 -->
          <el-table :data="advRecordDetailList" border style="width: 100%">
            <el-table-column prop="accountName" label="素材库名" />
            <el-table-column prop="accountCount" label="已创建数量" />
            <el-table-column prop="zjCount" label="浙江数量" />
            <el-table-column prop="fjCount" label="福建数量" />
            <el-table-column prop="statDate" label="日期" />
          </el-table>

          <!-- 分页 -->
          <div class="mt-3 flex justify-end">
            <el-pagination @current-change="handleAdvRecordPageChange" :current-page="advRecordPageNo"
              :page-size="advRecordPageSize" :total="advRecordTotalRecords" layout="prev, pager, next" />
          </div>
        </el-dialog>
      </el-main>

    </el-container>


  </div>
</template>

<script>
import axios from "axios";
import Decimal from "decimal.js";
import Vue2 from './sucaiku.vue';
import { bus } from '../../bus.js';
import Vue from 'vue';
import 'core-js/stable';
import dayjs from 'dayjs';
import { get } from '@/until/controlRequest'
import aixos from "core-js/internals/queue";

// oCPD 转化目标集合（平台枚举 100-131，出价方式为按转化目标出价，提交时 chargeType=5、价格走 price、ocpxPrice 置 0）
const OCPD_CV_TYPES = ['100', '101', '102', '103', '104', '105', '106', '107', '109', '110', '111', '113', '115', '126', '127', '128', '129', '130', '131']

// 搜索提词版位（placeType=21）的创意素材类型，搜索首位/搜索列表分开维护（模块级常量，data 与 watch 共用）
const storeSearchListTemplateTypes = [
  { value: '0', label: '无' }, { value: '3', label: '搜索三图' }, { value: '4', label: '动态icon' },
  { value: '14', label: '挂件' }, { value: '15', label: '标签气泡' }, { value: '16', label: '高亮一句话' },
  { value: '18', label: '智能秒装' }, { value: '19', label: '列表背景' }
]
const storeSearchTopTemplateTypes = [
  { value: '6', label: '基础样式-无图' }, { value: '7', label: '品牌高级样式-大图' },
  { value: '8', label: '富媒体样式-大三图' }, { value: '12', label: '品牌高级样式-氛围图' }
]
const storeSearchPlacementBranch = {
  value: '21', label: '搜索提词',
  children: [
    { value: '2', label: '搜索首位', children: storeSearchTopTemplateTypes },
    { value: '1', label: '搜索列表', children: storeSearchListTemplateTypes }
  ]
}
// 搜索提词版位素材规格（平台素材上传要求，2026-08-26 核对）：模板类型 → 图片数/尺寸(px)/大小上限/格式
// 搜索列表（displayPosition=1）：3-搜索三图 3张320*211 jpg/jpeg/png <80KB；4-动态icon 1张512*512 gif <2048KB；
//   14-挂件 1张210*210 png <150KB；19-列表背景 1张1080*228 png ≤150KB
// 搜索首位（displayPosition=2）：7-品牌高级样式-大图 1张1080*528 jpg/jpeg/png/gif <150KB；
//   8-富媒体样式-大三图 3张1080*1920 jpg/jpeg/png <150KB；12-品牌高级样式-氛围图 1张1080*528 png <150KB
// 无图模板（0/2/6/15/16/18）不在此表，无需校验
const storeSearchMaterialSpecs = {
  '3': { imgCount: 3, width: 320, height: 211, maxSize: 80 * 1024, formats: ['jpg', 'jpeg', 'png'] },
  '4': { imgCount: 1, width: 512, height: 512, maxSize: 2048 * 1024, formats: ['gif'] },
  '14': { imgCount: 1, width: 210, height: 210, maxSize: 150 * 1024, formats: ['png'] },
  '19': { imgCount: 1, width: 1080, height: 228, maxSize: 150 * 1024, formats: ['png'] },
  '7': { imgCount: 1, width: 1080, height: 528, maxSize: 150 * 1024, formats: ['jpg', 'jpeg', 'png', 'gif'] },
  '8': { imgCount: 3, width: 1080, height: 1920, maxSize: 150 * 1024, formats: ['jpg', 'jpeg', 'png'] },
  '12': { imgCount: 1, width: 1080, height: 528, maxSize: 150 * 1024, formats: ['png'] }
}

export default {
  components: { Vue2 },
  name: 'VivoexistgroupDateRangePicker',
  props: {
    // 默认区域，可以父组件传进来
    // value: {
    //   type: String,
    //   default: ""
    // }
    initialVivoexistgroupDateRange: {
      type: Array,
      default: () => ['', '']
    },
    // 默认激活的快捷选项
    defaultVivoexistgroupActiveOption: {
      type: String,
      default: 'last7days'
    }
  },
  data() {
    const currentDate = new Date();
    const cityOptions = [];
    const c1 = [
      {
        id: 25,
        value: '0-17岁'
      },
      {
        id: 26,
        value: '18-24岁'
      },
      {
        id: 27,
        value: '25-29岁'
      },
      {
        id: 28,
        value: '30-39岁'
      },
      {
        id: 29,
        value: '40-49岁'
      },
      {
        id: 30,
        value: '50岁及以上'
      },
    ]
    return {
      Eagoptionsvalue: "",
      Eagoptions: [
        {
          value: '1',
          label: '按筛选日期和消耗'
        }, {
          value: '2',
          label: '按创建时间顺序'
        },
      ],
      orderexistgroup: 1,
      vivoexistgroupDateRange: [],

      // 当前激活的快捷选项
      vivoexistgroupActiveQuickOption: this.defaultVivoexistgroupActiveOption,

      // 默认日期范围（最近7天）
      vivoexistgroupDefaultDateRange: [
        new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate() - 6),
        new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate())
      ],

      // Element UI 的 picker 配置
      vivoexistgroupPickerOptions: {
        shortcuts: [
          {
            text: '今日',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '昨日',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              end.setTime(end.getTime() - 3600 * 1000 * 24);
              start.setTime(start.getTime() - 3600 * 1000 * 24);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '最近7天',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 6);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '本月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setDate(1);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '上个月',
            onClick: (picker) => {
              const end = new Date();
              const start = new Date();
              start.setMonth(start.getMonth() - 1);
              start.setDate(1);

              // 修复：直接计算上个月最后一天
              const lastDayOfLastMonth = new Date(start.getFullYear(), start.getMonth() + 1, 0);
              end.setTime(lastDayOfLastMonth.getTime());

              picker.$emit('pick', [start, end]);
            }
          }
        ],
        // 禁用未来日期
        disabledDate(time) {
          return time.getTime() > Date.now();
        }
      },
      mixminvalue: false,
      mixminvaluelate: '轮询',
      currentIndeximg: 0,
      currentIndexvideo: 0,
      currentIndextext: 0,
      currentIndexzsvideo: 0,
      currentIndexzsimg: 0,
      erjihangyenumber: "",
      regionOptions: [
        { label: "浙江", value: "浙江" },
        { label: "福建", value: "福建" },
        { label: "深圳", value: "深圳" },
        { label: "苏州", value: "苏州" },
        { label: "广州力天", value: "广州力天" }
      ],
      selectedRegion: this.value,
      queryParams: {
        templateName: '',
        pageNum: 1,
        pageSize: 10
      },

      //搭建数据模块
      /** 今日总搭建数量 */
      advRecordTodayTotal: 0,
      advRecordTimer: null,

      /** 弹窗开关 */
      advRecordDetailDialogVisible: false,

      /** 查询条件 */
      advRecordQueryDate: "", // 查询日期
      advRecordQueryAccountName: "", // 模糊查询账号名

      /** 表格数据 */
      advRecordDetailList: [],
      advRecordDetailTotal: 0, // 当前日期总数
      zjadvRecordDetailTotal: 0, // 当前日期总数
      fjadvRecordDetailTotal: 0, // 当前日期总数
      szadvRecordDetailTotal: 0, // 当前日期总数
      suzadvRecordDetailTotal: 0, // 当前日期总数
      gzzadvRecordDetailTotal: 0,
      advRecordPageNo: 1,
      advRecordPageSize: 10,
      advRecordTotalRecords: 0,



      uploadControllers: [],
      // 预设信息
      startDate: "",
      endDate: '',
      placement_time: [],
      isPreset: false,
      AllCookieList: [],
      presetValue: null,
      presetOptions: [],
      // 其他数据
      libraryOptions: [],
      selectedLibrary: null,
      localselection: true,
      videoFMSwitch: true,
      zsvideoFMSwitch: true,
      videorangeFMSwitch: false,
      zsvideorangeFMSwitch: false,
      zsspchange: false,
      spchange: false,
      zstpchange: false,
      tpchange: false,
      txchange: false,
      currentNormalIndex: 0,
      currentReviewIndex: 0,
      txfileList: [],
      txfileCode: [],
      countdialogVisible: false,
      countformData: {
        normalCount: 0,
        reviewCount: 0
      },
      zsfileList: [],
      isoldgroupprice: false,
      oldGroupPrice: '',
      isDeepOpt: false, // 是否开启深度优化转化目标
      newplanflag: false,
      isdeliveryScene: false,
      ePlanId: '',
      linesWithLimitError: [], // 存储超出字符限制的行
      zslinesWithLimitError: [], // 存储超出字符限制的行
      maxLength: 26, // 默认最大字符数
      timeRanges: [{ start: '00:00', end: '24:00' }],
      isguanz: false,
      stopAll: false,
      titlesString: '',
      zstitlesString: '',
      zstitleList: [],

      categoryName: '',
      beSelectCategory: null,
      categoryList: [],

      cleanDialogVisible: false, // 控制弹窗显示
      cleanLoading: false,       // 清理按钮的加载状态
      cleanForm: {
        hdname: '',
        source: 'custom',
        customUuids: '',
        cltime: ''
      },
      // 可选的分类数据
      categories: [
        {
          categoryName: '星光剧场-男频',
          categoryId: 2917,
          categoryUid: 'b79d4d58dc196dd941f8',
          categoryUtoken: '43f9d1624140e71944945eb06d77dbb5739fe597148faae039887aaa9fbf0f59'
        },
        {
          categoryName: '星光剧场-女频',
          categoryId: 3148,
          categoryUid: 'b79d4d58dc196dd941f8',
          categoryUtoken: 'd7408c1fda253deabbc079a42e7e3e4590213f1a4d2cac7e786c5761ff84ab2d'
        },
        {
          categoryName: '繁花剧场',
          categoryId: 3673,
          categoryUid: 'c75e582aa13e180ab440',
          categoryUtoken: 'a20b9b0ec57a9898598361684441cdf8c7a5a81ef6689140798285f9c4521001'
        },

      ],

      sucaikus: [
        {
          uname: 'psl',
          uid: 'f6f0b505a7368e5ea402',
          utoken: '0a306397d2767ea3bf2465471bac8d15efa05f557df5d9b3142da65f73eb19d5'
        },
        {
          uname: 'lsp',
          uid: 'fa271d870eb23e2483fd',
          utoken: '0a306397d2767ea3bf2465471bac8d15efa05f557df5d9b3142da65f73eb19d5'
        },
        {
          uname: '桂小伟',
          uid: 'c786bae366b78fff1b30',
          utoken: '47a66fdfd401dfc6878ca5de83e95c52b564c0bd403976568a6d6f742af69bc0'
        },
        {
          uname: '富康',
          uid: 'eba3ec4451aecf7a1f41',
          utoken: '47a66fdfd401dfc6878ca5de83e95c52b564c0bd403976568a6d6f742af69bc0'
        },
        {
          uname: '杨康',
          uid: 'b62a84b350478d655647',
          utoken: 'c2cd372657636dab9d4e634188d88465c70da26370280712a4e4604cfa2f00b1'
        },
        {
          uname: '葛磊',
          uid: 'c35f8f61b4136b3ded15',
          utoken: 'c14066d0edba0f71984805a3ac5ad8146f64fdca09448e5092b4df732922f8b0'
        },
        {
          uname: '唐莹',
          uid: 'b510d1bf06f83682c908',
          utoken: '4fa940040985146f070b1eb8f19cc3084570842faca8bf7317e470e0d5d97149'
        },
        {
          uname: '小晴',
          uid: '27db5919944236f15760',
          utoken: '1fa0c26330fff171935f23536cffb7435c297b123fb2a1fea22f8164b42864ff'
        },
        {
          uname: '郑佳宇',
          uid: 'dc6b8813bff8b4d0b881',
          utoken: 'a0c1a838343d5afa4a229db37d552aea171d8407af32cf0da0f006da172c0da0'
        },
        {
          uname: '林俊杰',
          uid: '6de39b814c9622959709',
          utoken: 'fc6bc6e5fc86e17adb07b94067f8a1ec2622ec606573711e8fc75a7755d0ff3d'
        },
        {
          uname: 'hxz',
          uid: '03f4d7ac3f91f8369b99',
          utoken: 'fe347189c3b4f87faee5a2073edf22e8b0e794e495977bd736f649a4d6d9b867'
        },
        {
          uname: 'hxz2',
          uid: '58e9c2a1745994f07826',
          utoken: '486f4b28e581115a8553250038402b292903557a244437c935469cfb3b801c85'
        },
        {
          uname: '汪洋',
          uid: 'bd7d22c54904e1ae5e4c',
          utoken: '13c5639d4c2ac677ad09deee0e0ef4abd4f540a7eedf374b4ea328a655e6ff44'
        },
        {
          uname: '张栖宇',
          uid: '70615012fb3f73e8ba49',
          utoken: 'a4bc5a9f3ea89a29682ea6f4f7fbe1fc280e28a941312bce21dfdf423f700ccc'
        },
        {
          uname: 'cxy',
          uid: '826ac4833e1b376666d1',
          utoken: 'd0d4a903a8b88679f0b8bd9ee01dcd51dbd8383accbc1ae7d179bec1c01fdd58'
        },
        {
          uname: '陈慧',
          uid: 'a28c5beba2b6c64119e3',
          utoken: '71c85b5fac0942397e50ee71e0b7f727df69c173fab181b2b160dd477c2a822a'
        },
        {
          uname: '吴周莉',
          uid: 'd2cc94284ddfac2df59b',
          utoken: 'd822ad1012a19acfaf257523c9039d1776947197404881abf4a3578b66781dc7'
        },
        {
          uname: '周尚安',
          uid: '7cb1b105d2b29238f724 ',
          utoken: 'd822ad1012a19acfaf257523c9039d1776947197404881abf4a3578b66781dc7'
        },


      ],
      zjcookie: '',
      sucainame: '', // 存储选中的素材名称
      selectedsucaiku: null,// 存储选中的完整对象
      selectedCategoryName: '', // 存储选中的分类名称
      selectedCategory: null,// 存储选中的完整对象
      priceRanges: [
        { label: '>4500', value: 1530022 },
        { label: '4000~4500', value: 1530021 },
        { label: '3500~4000', value: 1530020 },
        { label: '3000~3500', value: 1530019 },
        { label: '2500~3000', value: 1530018 },
        { label: '2000~2500', value: 1530017 },
        { label: '1500~2000', value: 1530016 },
        { label: '1000~1500', value: 1530015 },
        { label: '0~1000', value: 1530014 }
      ],
      // 购机价格：默认"不限"（phonePriceStatus:0），初始为空，避免保存模板时误存全量
      selectedPrices: [],
      // 定义安卓版本和对应的值
      androidVersions: [
        { label: '安卓4及以下', value: 1650003 },
        { label: '安卓5', value: 1650004 },
        { label: '安卓6', value: 1650005 },
        { label: '安卓7', value: 1650006 },
        { label: '安卓8', value: 1650007 },
        { label: '安卓9', value: 1650008 },
        { label: '安卓10', value: 1650001 },
        { label: '安卓11', value: 1650002 },
        { label: '安卓12', value: 1650009 },
        { label: '安卓13', value: 1650010 },
        { label: '安卓14', value: 1650011 },
        { label: '安卓15', value: 1650012 },
        { label: '安卓16及以上', value: 1650013 }
      ],
      // 安卓版本：默认"不限"（androidVersionStatus:0），初始为空，避免保存模板时误存全量
      selectedVersions: [],

      // 安卓版本选择状态
      androidVersionStatus: 0, // 0=不限, 1=设置
      checkAllVersion: false,
      isIndeterminateVersion: false,

      // 购机价格选择状态
      phonePriceStatus: 0, // 0=不限, 1=设置
      checkAllPrice: false,
      isIndeterminatePrice: false,

      // 地域定向选择状态
      regionStatus: 0, // 0=不限, 1=设置

      androidVersionSetList: [],
      phonePriceSetList: [],
      beSelectAdType: '', // 被选中的广告类型
      adTypeList: [
        { label: '网址', value: 1 },
        { label: '应用推广', value: 2 },
        { label: '快应用', value: 8 },
        { label: '小程序', value: 11 }
      ],
      myAdType: '',
      customList2: '',
      customListpc: '',
      customListrqb: [],
      customListrqbpc: [],
      erjihangye: [],
      options5: [
        {
          value: '2300001',
          label: '引流电商',
          children: [
            {
              value: '2400016',
              label: '医药健康'
            },
            {
              value: '2400005',
              label: '家居日用'
            },


          ]
        }, {
          value: '2100008',
          label: '募捐平台',
          children: [
            {
              value: '2220033',
              label: '慈善组织募捐'
            },
            {
              value: '2220032',
              label: '互联网募捐信息平台'
            }, {
              value: '2220034',
              label: '慈善/爱心众筹'

            },




          ]
        },

        {
          value: '2100018',
          label: '电商',
          children: [{
            value: '2220145',
            label: '优惠券'
          },
          {
            value: '2220142',
            label: '综合电商平台'
          },

          ]
        },
        {
          value: '2100028',
          label: '汽车',
          children: [{
            value: '2220253',
            label: '汽车平台'
          },


          ]
        },


        {
          value: '2100024',
          label: '系统/工具',
          children: [
            {
              value: '2220196',
              label: '体育健康'
            }, {
              value: '2220202',
              label: '日常工具'
            }, {
              value: '2220200',
              label: '天气日历'
            }, {
              value: '2220195',
              label: '系统软件  '
            }, {
              value: '2220201',
              label: '浏览器  '
            },
            {
              value: '2220197',
              label: '美图摄影'
            },

          ]
        },
        {
          value: '2100025',
          label: '婚恋/社交',
          children: [
            {
              value: '2220204',
              label: '内容社区'
            }

          ]
        },

        {
          value: '2100016',
          label: '文玩收藏',
          children: [
            {
              value: '2220125',
              label: '集邮'
            },
            {
              value: '2220126',
              label: '纪念张'
            },
            {
              value: '2220127',
              label: '纪念币'
            },
            {
              value: '2220128',
              label: '退市人民币'
            },
            {
              value: '2220129',
              label: '手工制工艺品'
            },
            {
              value: '2220130',
              label: '特殊材质饰品'
            },
            {
              value: '2220131',
              label: '纪念钞'
            },
            {
              value: '2220132',
              label: '纪念章'
            },
            {
              value: '2220133',
              label: '文物经营'
            },
            {
              value: '2220134',
              label: '文物拍卖'
            },
            {
              value: '2220135',
              label: '文物复制品销售'
            },
            {
              value: '2220136',
              label: '文物商店'
            },
            {
              value: '2220137',
              label: '普通拍卖'
            },
            {
              value: '2220138',
              label: '司法拍卖平台'
            },

          ]
        },
        {
          value: '2100009',
          label: '出版经营',
          children: [{
            value: '2220037',
            label: '出版物'
          }]
        },

        {
          value: '2100019',
          label: '直营电商',
          children: [
            {
              value: '2220148',
              label: '数码家电'
            },
            {
              value: '2220158',
              label: '物品收藏'
            },
            {
              value: '2220149',
              label: '日用百货'
            },
            {
              value: '2220155',
              label: '个护美妆'
            }, {
              value: '2220156',
              label: '个护美妆（特殊）'
            },
            {
              value: '2220154',
              label: '其他'
            },
            {
              value: '2220159',
              label: '医药保健'
            },
            {
              value: '2220157',
              label: '零食饮料'
            },
            {
              value: '2220147',
              label: '服饰鞋包'
            },
            {
              value: '2220152',
              label: '钟表首饰'
            },
          ]
        },

        {
          value: '2100015',
          label: '通信服务',
          children: [
            {
              value: '2220120',
              label: '电信运营商'
            },

          ]
        },

        {
          value: '2100013',
          label: '生活服务',
          children: [{
            value: '2220099',
            label: '综合生活服务'
          }, {
            value: '2220098',
            label: '外卖平台'
          }, {
            value: '2220092',
            label: '卡券优惠'
          }]
        },
        {
          value: '2100023',
          label: '娱乐影视',
          children: [{
            value: '2220193',
            label: '小说平台'
          }, {
            value: '2220187',
            label: '视频'
          }, {
            value: '2220192',
            label: '段子漫画'
          },
          {
            value: '2220189',
            label: '音乐音频'
          },


          ]
        },
        {
          value: '2100012',
          label: '医疗服务',
          children: [
            {
              value: '2220064',
              label: '医疗器械'
            },
            {
              value: '2220072',
              label: '保健用品'
            },
            {
              value: '2220063',
              label: '医疗科室'
            },
            {
              value: '2220070',
              label: '药品'
            },
            {
              value: '2220075',
              label: '医疗线上咨询平台'
            }


          ]
        },

        {
          value: '2100021',
          label: '旅游住宿',
          children: [
            {
              value: '2220169',
              label: '旅行社'
            },
            {
              value: '2220170',
              label: '代订服务'
            },
            {
              value: '2220171',
              label: '旅游景点'
            },
            {
              value: '2220172',
              label: '旅游平台'
            },
            {
              value: '2220173',
              label: '航空/游轮旅行'
            },
            {
              value: '2220174',
              label: '酒店住宿'
            },
            {
              value: '2220175',
              label: '农家乐、渔家乐'
            },
            {
              value: '2220176',
              label: '事业单位宣传'
            },
            {
              value: '2220177',
              label: '个人游记'
            },
            {
              value: '2220178',
              label: '旅游局'
            },

          ]
        },
        {
          value: '2100020',
          label: '教育',
          children: [{
            value: '2220162',
            label: '素质教育'
          }, {
            value: '2220161',
            label: '理财培训'
          },
          {
            value: '2220167',
            label: '职业培训'
          },

          {
            value: '2220165',
            label: '语言培训'
          },

          ]
        },
        {
          value: '2100011',
          label: '食品',
          children: [{
            value: '2220046',
            label: '散装食品'
          },
          {
            value: '2220045',
            label: '包装食品饮料'
          },
          {
            value: '2220062',
            label: '保健食品'
          },
          {
            value: '2220048',
            label: '酒品'
          }, {
            value: '2220061',
            label: '有机食品'
          },]
        },
        {
          value: '2100027',
          label: '招商加盟',
          children: [{
            value: '2220239',
            label: '生活服务加盟'
          },
          ]
        },
        {
          value: '2100029',
          label: '金融',
          children: [{
            value: '2220260',
            label: '保险'
          },
          {
            value: '2220256',
            label: '证券/股票'
          },
          {
            value: '2220254',
            label: '贷款'
          },

          {
            value: '2220259',
            label: '第三方支付平台'
          },

          ]
        },



        // {
        //   value: 2220187,
        //   label: '视频',
        // },{
        //   value: 2220193,
        //   label: '小说平台',
        // },
      ],
      sex: '不限',
      customList: [1247469, 1247470, 1223942],
      age: [],
      sexList: [],

      zzIdList: [],
      ageIdList: [],
      ages: c1,
      regionCodeList: [
      ],
      flag: false,
      updateType: '',
      listname: [],
      time_list: '',
      timeList: [
        {
          value: '111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111',
          label: '全天投放'
        },
        {
          value: '000000000011111111111111111111111111111111111111000000000011111111111111111111111111111111111111000000000011111111111111111111111111111111111111000000000011111111111111111111111111111111111111000000000011111111111111111111111111111111111111000000000011111111111111111111111111111111111111000000000011111111111111111111111111111111111111',
          label: '五点'
        },
        {
          value: '000000000000111111111111111111111111111111111111000000000000111111111111111111111111111111111111000000000000111111111111111111111111111111111111000000000000111111111111111111111111111111111111000000000000111111111111111111111111111111111111000000000000111111111111111111111111111111111111000000000000111111111111111111111111111111111111',
          label: '六点'
        },
        {
          value: '000000000000001111111111111111111111111111111111000000000000001111111111111111111111111111111111000000000000001111111111111111111111111111111111000000000000001111111111111111111111111111111111000000000000001111111111111111111111111111111111000000000000001111111111111111111111111111111111000000000000001111111111111111111111111111111111',
          label: '七点'
        },
        {
          value: '000000000000000001111111111111111111111111111111000000000000000001111111111111111111111111111111000000000000000001111111111111111111111111111111000000000000000001111111111111111111111111111111000000000000000001111111111111111111111111111111000000000000000001111111111111111111111111111111000000000000000001111111111111111111111111111111',
          label: '八点半'
        },
        {
          value: '000000000000000000111111111111111111111111111111000000000000000000111111111111111111111111111111000000000000000000111111111111111111111111111111000000000000000000111111111111111111111111111111000000000000000000111111111111111111111111111111000000000000000000111111111111111111111111111111000000000000000000111111111111111111111111111111',
          label: '九点后'
        },
        {
          value: '000000000000000000011111111111111111111111111111000000000000000000011111111111111111111111111111000000000000000000011111111111111111111111111111000000000000000000011111111111111111111111111111000000000000000000011111111111111111111111111111000000000000000000011111111111111111111111111111000000000000000000011111111111111111111111111111',
          label: '九点半'
        },
        {
          value: '000000000000000000001111111111111111111111111111000000000000000000001111111111111111111111111111000000000000000000001111111111111111111111111111000000000000000000001111111111111111111111111111000000000000000000001111111111111111111111111111000000000000000000001111111111111111111111111111000000000000000000001111111111111111111111111111',
          label: '十点'
        },
        {
          value: '000000000000000000000111111111111111111111111111000000000000000000000111111111111111111111111111000000000000000000000111111111111111111111111111000000000000000000000111111111111111111111111111000000000000000000000111111111111111111111111111000000000000000000000111111111111111111111111111000000000000000000000111111111111111111111111111',
          label: '十点半'
        },
        {
          value: '000000000000000000000011111111111111111111111111000000000000000000000011111111111111111111111111000000000000000000000011111111111111111111111111000000000000000000000011111111111111111111111111000000000000000000000011111111111111111111111111000000000000000000000011111111111111111111111111000000000000000000000011111111111111111111111111',
          label: '十一点'
        }, {
          value: '000000000000000000000000000011111111111111111111000000000000000000000000000011111111111111111111000000000000000000000000000011111111111111111111000000000000000000000000000011111111111111111111000000000000000000000000000011111111111111111111000000000000000000000000000011111111111111111111000000000000000000000000000011111111111111111111',
          label: '十四点'
        },
        {
          value: '000000000000000000000000000000001111111111111111000000000000000000000000000000001111111111111111000000000000000000000000000000001111111111111111000000000000000000000000000000001111111111111111000000000000000000000000000000001111111111111111000000000000000000000000000000001111111111111111000000000000000000000000000000001111111111111111',
          label: '十六点'
        },
        {
          value: '000000000000000000000000000000000011111111111111000000000000000000000000000000000011111111111111000000000000000000000000000000000011111111111111000000000000000000000000000000000011111111111111000000000000000000000000000000000011111111111111000000000000000000000000000000000011111111111111000000000000000000000000000000000011111111111111',
          label: '十七点'
        },
        {
          value: '000000000000000000000000000000000000111111111111000000000000000000000000000000000000111111111111000000000000000000000000000000000000111111111111000000000000000000000000000000000000111111111111000000000000000000000000000000000000111111111111000000000000000000000000000000000000111111111111000000000000000000000000000000000000111111111111',
          label: '十八点'
        }],
      names: '',
      idsname: [],

      option1: [{
        value: '0',
        label: '商店'
      }, {
        value: '1',
        label: '非应用商店'
      },
      {
        value: '2',
        label: '广告联盟'
      }],
      option6: [
        {
          value: '0',
          label: '常规投放'
        },
        {
          value: '1',
          label: '最大转化投放'
        },],

      // 转化目标 - oCPC（一般场景展示）
      options3Ocpc: [
        {
          value: '4',
          label: '表单提交'
        },
        {
          value: '5',
          label: '自定义激活'
        }, {
          value: '6',
          label: '自定义注册'
        }, {
          value: '7',
          label: '添加到桌面'
        }, {
          value: '12',
          label: '自定义付费'
        },
        {
          value: '13',
          label: '自定义拉活'
        },
        {
          value: '52',
          label: '快应用/快游戏ROI1-广告变现'
        }],
      // 转化目标 - oCPD（仅应用推广+商店场景展示）
      options3Ocpd: [
        {
          value: '102',
          label: '自定义激活(oCPD)'
        },
        {
          value: '103',
          label: '自定义注册(oCPD)'
        },
        {
          value: '106',
          label: '自定义拉活(oCPD)'
        },
        {
          value: '107',
          label: '自定义付费(oCPD)'
        }],
      // 深度优化转化目标：按前置转化目标过滤（见 computed secondCvTypeOptions）
      flag1: true,
      flag2: true,
      options4: [
        {
          value: '1',
          label: '信息流',
          children: [{
            value: '62',
            label: '横板大图',
          },
          {
            value: '63',
            label: '竖版大图',
          },
          {
            value: '4',
            label: '组图',
          },
          {
            value: '3',
            label: '小图',
          }, {
            value: '61',
            label: '横板视频'
          }, {
            value: '75',
            label: '竖版视频'
          }]
        },
        {
          value: '6',
          label: '锁屏壁纸',
          children: [
            {
              value: '64',
              label: '竖版图片',
            },
            {
              value: '4',
              label: '组图',
            },
            {
              value: '75',
              label: '竖版视频'
            }]
        },

        {
          value: '2',
          label: '开屏',
          children: [
            {
              value: '35',
              label: '竖版大图（1080*1880）',
            },
            {
              value: '85',
              label: '横版大图',
            },
            {
              value: '213',
              label: '竖版大图（1080*1920）',
            },

          ]
        },
        {
          value: '5',
          label: '原生广告',
          children: [{
            value: '48',
            label: '横板大图',
          },
          {
            value: '209',
            label: '竖版大图',
          },
          {
            value: '4',
            label: '组图',
          },
          {
            value: '121',
            label: '小图',
          }
            , {
            value: '242',
            label: '竖版视频',
          },
          {
            value: '122',
            label: '横版视频',
          },

          ]
        },
        {
          value: '4',
          label: '插屏',
          children: [
            {
              value: '39',
              label: '竖版大图(780*800)',
            },
            {
              value: '208',
              label: '横版大图(1280*720)',
            },
            {
              value: '145',
              label: '竖版视频(720*1280)',
            },
            {
              value: '142',
              label: '横版视频(1280*720)',
            },
          ]
        }, {
          value: '20',
          label: '推荐列表',
          children: [
            { value: "0", label: "无" },
            { value: "3", label: "搜索三图" },
            { value: "4", label: "动态icon" },
            { value: "5", label: "顶部banner" },
            { value: "14", label: "挂件" },
            { value: "15", label: "标签气泡" },
            { value: "16", label: "高亮一句话" },
            { value: "18", label: "智能秒装" },
            { value: "19", label: "列表背景" }]
        },
        storeSearchPlacementBranch,
      ],
      virtualPositionoptions: [],
      virtualPositionvalue: [],
      accounts: '',

      daluan: true,
      value: '',
      formLabelAlign: {
        name: '',
        mediaType: '',
        dailyBudget: '',
        conversionMonitorType: 0,


      },
      formLabelAlign1: {
        name: '',
        cvType: '',
        ocpxPrice: '',
        secondCvType: '', // 深度优化转化目标
        secondOcpxPrice: '', // 深度优化出价（单位元，提交时转毫分）
        dailyBudget: 0,
        nobidBiddingStrategy: 0,
      },
      normId: [61, 4, 3],
      formLabelAlign3: {
        placeType: '',
        title: [],
        productNames: [''],
        wordChoiceModel: 1, // 搜索提词选词模式 1-搜索题词，2-优选词包
        generalSwitch: 0, // 搜索提词流量优选开关 0-关闭，1-开启
        labelDesc: '', // 标签气泡文案 2-5个字（模板类型 15 用，doc 269 常见问题）
        labelColor: '', // 标签气泡颜色（模板类型 15 用，四选一，搭建时必选）
      },
      // 标签气泡颜色选项（下拉展示色名+色点，value 为提交给平台的色值）
      labelColorOptions: [
        { label: '红色', value: '#EB4A41' },
        { label: '橙色', value: '#EF8B45' },
        { label: '绿色', value: '#5BBB8E' },
        { label: '灰紫色', value: '#686A90' }
      ],
      percentage: 0,
      percentages: 0,
      fileList: [],
      VideofileList: [],
      zsVideofileList: [],

      creativeList: [],
      arr: {},
      idsList: [
        {
          id: '',
          username: '',
          ids: '',
          twoname: '',
          url: '',
          xiaoshuourl: '',
          baoguangurl: '',
          token: '',
          idsname: '',
          planId: '',
          groundId: '',
          planName: ''
        }
      ],
      dialogImageUrl: '',
      zsdialogImageUrl: '',
      dialogVisible: false,
      zsdialogVisible: false,
      fileCode: [],
      zsfileCode: [],
      fileUrl: [], // 普通图片 filePath（与 fileCode 同序，模板 14/19 构造 imgsUrl 用）
      zsfileUrl: [], // 撞审图片 filePath（与 zsfileCode 同序）
      zsvideofileCode: [],
      videofileCode: [],
      two: [{
        id: '',
        twoname: '',
      }],
      // towToken:[],
      towName: '',
      username: '',
      advertiseQualificationId: '', // 资质id
      beSelectDiYu: '',
      beSelectMap: {},
      totalTasks: 0,
      // 存储定向的
      mapArray: [

        {
          name: "喻点点",
          map: {
            region: {

              regionCodeList: [
                130000,
                140200,
                140300,
                140400,
                140500,
                140600,
                140700,
                140800,
                140900,
                141000,
                141100,
                150000,
                210000,
                220000,
                230000,
                320200,
                320300,
                320400,
                320500,
                320600,
                320700,
                320800,
                320900,
                321000,
                321200,
                321300,
                330200,
                330300,
                330400,
                330500,
                330700,
                330800,
                330900,
                331000,
                331100,
                340000,
                350100,
                350300,
                350400,
                350500,
                350600,
                350700,
                350800,
                350900,
                360000,
                370000,
                410000,
                420200,
                420300,
                420500,
                420600,
                420700,
                420800,
                420900,
                421000,
                421100,
                421200,
                421300,
                422800,
                429078,
                429093,
                429094,
                429095,
                430000,
                440200,
                440400,
                440500,
                440600,
                440700,
                440800,
                440900,
                441200,
                441300,
                441400,
                441500,
                441600,
                441700,
                441800,
                442099,
                445100,
                445200,
                445300,
                450000,
                460000,
                510000,
                520000,
                530000,
                540000,
                610200,
                610300,
                610400,
                610500,
                610600,
                610700,
                610800,
                610900,
                611000,
                620000,
                630000,
                640000,
                650000,
                710199,
                810000,
                820000
              ], // 地区编码列表
              stayType: 2 // 停留类型
            },
          }
        },
        {
          name: "惠券多多",
          map: {
            region: {

              regionCodeList:
                [
                  120000,
                  130000,
                  140000,
                  150000,
                  210000,
                  220000,
                  230000,
                  320200,
                  320300,
                  320400,
                  320500,
                  320600,
                  320700,
                  320800,
                  320900,
                  321000,
                  321100,
                  321200,
                  321300,
                  330000,
                  340000,
                  350000,
                  360000,
                  370000,
                  410000,
                  420000,
                  430000,
                  440200,
                  440400,
                  440500,
                  440600,
                  440700,
                  440800,
                  440900,
                  441200,
                  441300,
                  441400,
                  441500,
                  441600,
                  441700,
                  441800,
                  442099,
                  445100,
                  445200,
                  445300,
                  450000,
                  460000,
                  500000,
                  510000,
                  520000,
                  530000,
                  540000,
                  610000,
                  620000,
                  630000,
                  640000,
                  650000
                ],
              stayType: 2 // 停留类型
            },
          }
        },
        {
          name: "赛诺思",
          map: {
            region: {

              regionCodeList: [
                120000,
                130000,
                140100,
                140200,
                140300,
                140400,
                140500,
                140600,
                140700,
                140800,
                141000,
                141100,
                150000,
                210000,
                220000,
                230000,
                320300,
                320500,
                320600,
                320700,
                320800,
                320900,
                321000,
                321100,
                321200,
                321300,
                330200,
                330300,
                330400,
                330600,
                330700,
                330800,
                330900,
                331000,
                331100,
                340200,
                340300,
                340400,
                340500,
                340600,
                340700,
                340800,
                341000,
                341100,
                341200,
                341300,
                341500,
                341600,
                341700,
                341800,
                350100,
                350300,
                350400,
                350500,
                350600,
                350700,
                350800,
                350900,
                360200,
                360300,
                360400,
                360500,
                360600,
                360700,
                360800,
                360900,
                361000,
                370000,
                410000,
                420200,
                420300,
                420500,
                420600,
                420700,
                420800,
                420900,
                421000,
                421100,
                421200,
                421300,
                422800,
                429078,
                429093,
                429094,
                429095,
                430200,
                430300,
                430400,
                430500,
                430600,
                430700,
                430800,
                430900,
                431000,
                431100,
                431200,
                431300,
                433100,
                440200,
                440400,
                440500,
                440700,
                440800,
                440900,
                441200,
                441300,
                441400,
                441500,
                441600,
                441700,
                441800,
                442099,
                445100,
                445200,
                445300,
                450000,
                460200,
                460399,
                460499,
                469069,
                469070,
                469071,
                469072,
                469073,
                469074,
                469075,
                469076,
                469077,
                469078,
                469092,
                469093,
                469094,
                469097,
                469098,
                510300,
                510400,
                510500,
                510600,
                510700,
                510800,
                510900,
                511000,
                511100,
                511300,
                511400,
                511500,
                511600,
                511700,
                511800,
                511900,
                512000,
                513200,
                513300,
                513400,
                520200,
                520300,
                520400,
                520500,
                520600,
                522300,
                522600,
                522700,
                530000,
                540000,
                610200,
                610300,
                610400,
                610500,
                610600,
                610700,
                610800,
                610900,
                611000,
                620000,
                630000,
                640000,
                650000,
                710199,
                810000,
                820000
              ],
              stayType: 2 // 停留类型
            },
          }
        },
        {
          name: "守恒",
          map: {
            region: {

              regionCodeList: [
                120000,
                130200,
                130300,
                130400,
                130500,
                130600,
                130700,
                130800,
                130900,
                131000,
                131100,
                140000,
                150000,
                210000,
                220000,
                230000,
                320200,
                320300,
                320400,
                320500,
                320600,
                320700,
                320800,
                320900,
                321000,
                321100,
                321200,
                321300,
                330200,
                330300,
                330400,
                330500,
                330600,
                330700,
                330800,
                330900,
                331000,
                331100,
                340200,
                340300,
                340400,
                340500,
                340600,
                340700,
                340800,
                341000,
                341100,
                341200,
                341300,
                341500,
                341600,
                341700,
                341800,
                350100,
                350300,
                350400,
                350500,
                350600,
                350700,
                350800,
                350900,
                360000,
                370000,
                410000,
                420200,
                420300,
                420500,
                420600,
                420700,
                420800,
                420900,
                421000,
                421100,
                421200,
                421300,
                422800,
                429078,
                429093,
                429094,
                429095,
                430000,
                440200,
                440400,
                440500,
                440600,
                440700,
                440800,
                440900,
                441200,
                441300,
                441400,
                441500,
                441600,
                441700,
                441800,
                442099,
                445100,
                445200,
                445300,
                450000,
                460000,
                500000,
                510300,
                510400,
                510500,
                510600,
                510700,
                510800,
                510900,
                511000,
                511100,
                511300,
                511400,
                511500,
                511600,
                511700,
                511800,
                511900,
                512000,
                513200,
                513300,
                513400,
                520000,
                530000,
                540000,
                610000,
                620000,
                630000,
                640000,
                650000,
                710199,
                810000,
                820000
              ],
              stayType: 2 // 停留类型
            },
          }
        },
        {
          name: "芒果短剧",
          map: {
            region: {

              regionCodeList: [
                120000,
                130200,
                130300,
                130400,
                130500,
                130600,
                130700,
                130800,
                130900,
                131000,
                131100,
                140000,
                150000,
                210000,
                220000,
                230000,
                320200,
                320300,
                320400,
                320500,
                320600,
                320700,
                320800,
                320900,
                321000,
                321100,
                321200,
                321300,
                330200,
                330300,
                330400,
                330500,
                330600,
                330700,
                330800,
                330900,
                331000,
                331100,
                340200,
                340300,
                340400,
                340500,
                340600,
                340700,
                340800,
                341000,
                341100,
                341200,
                341300,
                341500,
                341600,
                341700,
                341800,
                350100,
                350300,
                350400,
                350500,
                350600,
                350700,
                350800,
                350900,
                360000,
                370200,
                370300,
                370400,
                370500,
                370600,
                370700,
                370800,
                370900,
                371000,
                371100,
                371300,
                371400,
                371500,
                371600,
                371700,
                410000,
                420200,
                420300,
                420500,
                420600,
                420700,
                420800,
                420900,
                421000,
                421100,
                421200,
                421300,
                422800,
                429078,
                429093,
                429094,
                429095,
                430000,
                440200,
                440400,
                440500,
                440600,
                440700,
                440800,
                440900,
                441200,
                441300,
                441400,
                441500,
                441600,
                441700,
                441800,
                442099,
                445100,
                445200,
                445300,
                450200,
                450300,
                450400,
                450500,
                450600,
                450700,
                450800,
                450900,
                451100,
                451200,
                451300,
                451400,
                460100,
                460399,
                460499,
                469069,
                469070,
                469071,
                469072,
                469073,
                469074,
                469075,
                469076,
                469077,
                469078,
                469092,
                469093,
                469094,
                469097,
                469098,
                500000,
                510300,
                510400,
                510500,
                510600,
                510700,
                510800,
                510900,
                511000,
                511100,
                511300,
                511400,
                511500,
                511600,
                511700,
                511800,
                511900,
                512000,
                513200,
                513300,
                513400,
                520000,
                530100,
                530300,
                530400,
                530600,
                530700,
                530800,
                530900,
                532300,
                532500,
                532600,
                532800,
                532900,
                533100,
                533300,
                533400,
                540000,
                610000,
                620000,
                630000,
                640000,
                650000
              ],
              stayType: 2 // 停留类型
            },
          }
        },

        {
          name: "满芳小说",
          map: {
            region: {
              regionCodeList: [
                130000,
                140200,
                140300,
                140400,
                140500,
                140600,
                140700,
                140800,
                140900,
                141000,
                141100,
                150000,
                210000,
                220000,
                230000,
                320200,
                320300,
                320400,
                320500,
                320600,
                320700,
                320800,
                320900,
                321000,
                321200,
                321300,
                330200,
                330300,
                330400,
                330500,
                330700,
                330800,
                330900,
                331000,
                331100,
                340000,
                350100,
                350300,
                350400,
                350500,
                350600,
                350700,
                350800,
                350900,
                360000,
                370000,
                410000,
                420200,
                420300,
                420500,
                420600,
                420700,
                420800,
                420900,
                421000,
                421100,
                421200,
                421300,
                422800,
                429078,
                429093,
                429094,
                429095,
                430000,
                440200,
                440400,
                440500,
                440600,
                440700,
                440800,
                440900,
                441200,
                441300,
                441400,
                441500,
                441600,
                441700,
                441800,
                442099,
                445100,
                445200,
                445300,
                450000,
                460000,
                510000,
                520000,
                530000,
                540000,
                610200,
                610300,
                610400,
                610500,
                610600,
                610700,
                610800,
                610900,
                611000,
                620000,
                630000,
                640000,
                650000
              ],
              stayType: 2 // 停留类型
            },
          }
        },
        {
          name: "养生屏蔽tt",
          map: {
            region: {
              regionCodeList: [
                110000,
                120000,
                130000,
                140000,
                150000,
                210000,
                220000,
                230000,
                310000,
                330200,
                330300,
                330400,
                330500,
                330600,
                330700,
                330800,
                330900,
                331000,
                331100,
                340200,
                340300,
                340400,
                340500,
                340600,
                340700,
                340800,
                341000,
                341100,
                341200,
                341300,
                341500,
                341600,
                341700,
                341800,
                350000,
                360000,
                370000,
                410000,
                420000,
                430000,
                440200,
                440400,
                440500,
                440600,
                440700,
                440800,
                440900,
                441200,
                441300,
                441400,
                441500,
                441600,
                441700,
                441800,
                442099,
                445100,
                445200,
                445300,
                450000,
                460000,
                510000,
                520000,
                530000,
                540000,
                610000,
                620000,
                630000,
                640000,
                650000
              ],
              stayType: 2 // 停留类型
            },
          }
        },
        {
          name: "加粉屏蔽tt",
          map: {
            region: {
              regionCodeList: [
                120000,
                130000,
                140000,
                150000,
                210000,
                220000,
                230000,
                320200,
                320300,
                320400,
                320500,
                320600,
                320700,
                320800,
                320900,
                321000,
                321100,
                321200,
                321300,
                330200,
                330300,
                330400,
                330500,
                330600,
                330700,
                330800,
                330900,
                331000,
                331100,
                340200,
                340300,
                340400,
                340500,
                340600,
                340700,
                340800,
                341000,
                341100,
                341200,
                341300,
                341500,
                341600,
                341700,
                341800,
                350000,
                360000,
                370200,
                370300,
                370400,
                370500,
                370600,
                370700,
                370800,
                370900,
                371000,
                371100,
                371300,
                371400,
                371500,
                371600,
                371700,
                410200,
                410300,
                410400,
                410500,
                410600,
                410700,
                410800,
                410900,
                411000,
                411100,
                411200,
                411300,
                411400,
                411500,
                411600,
                411700,
                419098,
                420200,
                420300,
                420500,
                420600,
                420700,
                420800,
                420900,
                421000,
                421100,
                421200,
                421300,
                422800,
                429078,
                429093,
                429094,
                429095,
                430200,
                430300,
                430400,
                430500,
                430600,
                430700,
                430800,
                430900,
                431000,
                431100,
                431200,
                431300,
                433100,
                440200,
                440400,
                440500,
                440600,
                440700,
                440800,
                440900,
                441200,
                441300,
                441400,
                441500,
                441600,
                441700,
                441800,
                442099,
                445100,
                445200,
                445300,
                450000,
                460000,
                510000,
                520000,
                530300,
                530400,
                530500,
                530600,
                530700,
                530800,
                530900,
                532300,
                532500,
                532600,
                532800,
                532900,
                533100,
                533300,
                533400,
                540000,
                610200,
                610300,
                610400,
                610500,
                610600,
                610700,
                610800,
                610900,
                611000,
                620000,
                630000,
                640000,
                650000
              ],
              stayType: 2 // 停留类型
            },
          }
        },
        {
          name: "麒麟养生书",
          map: {
            region: {
              regionCodeList: [
                110000,
                120000,
                130000,
                140000,
                210100,
                210200,
                220200,
                230100,
                310000,
                320000,
                330200,
                330300,
                330400,
                330500,
                330600,
                330700,
                330800,
                330900,
                331000,
                331100,
                340000,
                350000,
                360000,
                370000,
                410000,
                420000,
                430000,
                440200,
                440400,
                440500,
                440600,
                440700,
                440800,
                440900,
                441200,
                441300,
                441400,
                441500,
                441600,
                441700,
                441800,
                442099,
                445100,
                445200,
                445300,
                450000,
                460000,
                510000,
                520000,
                530000,
                610000,
                640000
              ], // 地区编码列表
              stayType: 2 // 停留类型
            },
          }
        },
        {
          name: "爱读小说",
          map: {
            region: {
              regionCodeList: [
                120000,
                130000,
                140200,
                140300,
                140400,
                140500,
                140600,
                140700,
                140800,
                141000,
                141100,
                150000,
                210000,
                220000,
                230000,
                320200,
                320300,
                320400,
                320500,
                320600,
                320700,
                320800,
                320900,
                321000,
                321100,
                321200,
                321300,
                330200,
                330300,
                330400,
                330500,
                330600,
                330700,
                330800,
                330900,
                331000,
                331100,
                340000,
                350100,
                350300,
                350400,
                350500,
                350600,
                350700,
                350800,
                350900,
                360000,
                370000,
                410000,
                420000,
                430000,
                440200,
                440400,
                440500,
                440600,
                440700,
                440800,
                440900,
                441200,
                441300,
                441400,
                441500,
                441600,
                441700,
                441800,
                442099,
                445100,
                445200,
                445300,
                450000,
                460000,
                510000,
                520000,
                530000,
                540000,
                610200,
                610300,
                610400,
                610500,
                610600,
                610700,
                610800,
                610900,
                611000,
                620000,
                630000,
                640000,
                650000,
                710199,
                810000,
                820000
              ],
              stayType: 2 // 停留类型
            },
          }
        },
        {
          name: "码力连",
          map: {
            region: {

              regionCodeList: [
                120000,
                130000,
                140200,
                140300,
                140400,
                140500,
                140600,
                140700,
                140800,
                141000,
                141100,
                150000,
                210000,
                220000,
                230000,
                320200,
                320300,
                320400,
                320500,
                320600,
                320700,
                320800,
                320900,
                321000,
                321100,
                321200,
                321300,
                330200,
                330300,
                330400,
                330500,
                330600,
                330700,
                330800,
                330900,
                331000,
                331100,
                340000,
                350000,
                360000,
                370000,
                410000,
                420000,
                430000,
                440200,
                440400,
                440500,
                440600,
                440700,
                440800,
                440900,
                441200,
                441300,
                441400,
                441500,
                441600,
                441700,
                441800,
                442099,
                445100,
                445200,
                445300,
                450000,
                460000,
                510000,
                520000,
                530000,
                540000,
                610000,
                620000,
                630000,
                640000,
                650000
              ],
              stayType: 2 // 停留类型
            },
          }
        },
        {
          name: "帝江瑟瑟",
          map: {
            region: {

              regionCodeList: [
                120000,
                130000,
                140000,
                150000,
                210000,
                220000,
                230000,
                320200,
                320300,
                320400,
                320500,
                320600,
                320700,
                320800,
                320900,
                321000,
                321100,
                321200,
                321300,
                330000,
                340000,
                350100,
                350300,
                350400,
                350500,
                350600,
                350700,
                350800,
                350900,
                360000,
                370000,
                410000,
                420200,
                420300,
                420500,
                420600,
                420700,
                420800,
                420900,
                421000,
                421100,
                421200,
                421300,
                422800,
                429078,
                429093,
                429094,
                429095,
                430000,
                440200,
                440400,
                440500,
                440600,
                440700,
                440800,
                440900,
                441200,
                441400,
                441500,
                441600,
                441700,
                441800,
                442099,
                445100,
                445200,
                445300,
                450000,
                460000,
                510000,
                520000,
                530000,
                540000,
                610200,
                610300,
                610400,
                610500,
                610600,
                610700,
                610800,
                610900,
                611000,
                620000,
                630000,
                640000,
                650000
              ],
              stayType: 2 // 停留类型
            },
          }
        },
        {
          name: "爱测评投放地区xq",
          map: {
            region: {

              regionCodeList: [
                130000,
                140200,
                140300,
                140400,
                140500,
                140600,
                140700,
                140800,
                140900,
                141000,
                141100,
                150000,
                210000,
                220000,
                230000,
                320200,
                320300,
                320400,
                320500,
                320600,
                320700,
                320800,
                320900,
                321000,
                321200,
                321300,
                330200,
                330300,
                330400,
                330500,
                330700,
                330800,
                330900,
                331000,
                331100,
                340000,
                350100,
                350300,
                350400,
                350500,
                350600,
                350700,
                350800,
                350900,
                360000,
                370000,
                410000,
                420200,
                420300,
                420500,
                420600,
                420700,
                420800,
                420900,
                421000,
                421100,
                421200,
                421300,
                422800,
                429078,
                429093,
                429094,
                429095,
                430000,
                440200,
                440400,
                440500,
                440600,
                440700,
                440800,
                440900,
                441200,
                441300,
                441400,
                441500,
                441600,
                441700,
                441800,
                442099,
                445100,
                445200,
                445300,
                450000,
                460000,
                510000,
                520000,
                530000,
                540000,
                610200,
                610300,
                610400,
                610500,
                610600,
                610700,
                610800,
                610900,
                611000,
                620000,
                630000,
                640000,
                650000
              ],
              stayType: 2 // 停留类型
            },
          }
        },
        {
          name: "艾草枕批搭",
          map: {
            region: {

              regionCodeList: [
                110000,
                120000,
                130100,
                130200,
                130300,
                130800,
                130900,
                131000,
                131100,
                140100,
                140200,
                140300,
                140400,
                140500,
                140600,
                140700,
                140900,
                141000,
                141100,
                150100,
                150200,
                150300,
                150600,
                150700,
                150800,
                150900,
                310000,
                320000,
                330200,
                330300,
                330400,
                330500,
                330600,
                330700,
                330800,
                330900,
                331000,
                331100,
                340100,
                340200,
                340300,
                340500,
                340600,
                340700,
                340800,
                341000,
                341100,
                341700,
                341800,
                350000,
                360100,
                360200,
                360300,
                360400,
                360500,
                360600,
                360800,
                360900,
                361000,
                370100,
                370200,
                370300,
                370500,
                370600,
                370700,
                370800,
                370900,
                371000,
                371100,
                371400,
                371600,
                410100,
                410300,
                410600,
                411000,
                411100,
                411200,
                419098,
                420100,
                420200,
                420300,
                420500,
                420600,
                420700,
                420800,
                420900,
                421000,
                421200,
                421300,
                422800,
                429078,
                429093,
                429094,
                429095,
                430100,
                430200,
                430300,
                430400,
                430500,
                430600,
                430700,
                430800,
                430900,
                431000,
                440200,
                440400,
                440500,
                440600,
                440700,
                440800,
                440900,
                441200,
                441300,
                441400,
                441500,
                441600,
                441700,
                441800,
                442099,
                445100,
                445200,
                445300,
                450100,
                450200,
                450300,
                450400,
                450500,
                450600,
                450700,
                451400,
                460000,
                510100,
                510300,
                510400,
                510600,
                510700,
                510900,
                511100,
                511400,
                511500,
                511600,
                511800,
                520100,
                520300,
                530100,
                530300,
                530400,
                530500,
                530700,
                530900,
                610100,
                610200,
                610300,
                610400,
                610500,
                610600,
                610800,
                620100,
                620299,
                620300,
                620900,
                630100,
                640100,
                640200,
                640300,
                650100
              ],
              stayType: 2 // 停留类型
            },
          }
        },
        {
          name: "悠漫步",
          map: {
            region: {
              regionCodeList: [
                120000,
                130000,
                140000,
                150000,
                210000,
                220000,
                230000,
                320200,
                320300,
                320500,
                320600,
                320700,
                320800,
                320900,
                321000,
                321100,
                321200,
                321300,
                330200,
                330300,
                330400,
                330500,
                330600,
                330700,
                330800,
                330900,
                331000,
                331100,
                340000,
                350300,
                350400,
                350500,
                350600,
                350700,
                350900,
                360000,
                370000,
                410000,
                420200,
                420300,
                420500,
                420600,
                420700,
                420800,
                420900,
                421000,
                421100,
                421200,
                421300,
                422800,
                429078,
                429093,
                429094,
                429095,
                430000,
                440200,
                440400,
                440500,
                440600,
                440700,
                440800,
                440900,
                441200,
                441300,
                441400,
                441500,
                441600,
                441700,
                441800,
                442099,
                445100,
                445200,
                445300,
                450000,
                460000,
                510300,
                510400,
                510500,
                510600,
                510700,
                510800,
                510900,
                511000,
                511100,
                511300,
                511400,
                511500,
                511600,
                511700,
                511800,
                511900,
                512000,
                513200,
                513300,
                513400,
                520000,
                530000,
                540000,
                610200,
                610300,
                610400,
                610500,
                610600,
                610700,
                610800,
                610900,
                611000,
                620000,
                630000,
                640000,
                650000
              ],// 地区编码列表
              stayType: 2 // 停留类型
            },
          }
        },
        {
          name: "追书",
          map: {
            region: {
              regionCodeList: [
                130000,
                140200,
                140300,
                140400,
                140500,
                140600,
                140700,
                140800,
                140900,
                141000,
                141100,
                150000,
                210000,
                220000,
                230000,
                320300,
                320400,
                320600,
                320700,
                320900,
                321000,
                321100,
                321200,
                321300,
                330200,
                330300,
                330400,
                330500,
                330600,
                330700,
                330800,
                330900,
                331000,
                331100,
                340000,
                350300,
                350400,
                350500,
                350600,
                350700,
                350800,
                350900,
                360000,
                370000,
                410000,
                420200,
                420300,
                420500,
                420600,
                420700,
                420800,
                420900,
                421000,
                421100,
                421200,
                421300,
                422800,
                429078,
                429093,
                429094,
                429095,
                430100,
                430200,
                430300,
                430400,
                430500,
                430600,
                430700,
                430800,
                430900,
                431000,
                431100,
                431200,
                431300,
                440200,
                440500,
                440600,
                440700,
                440800,
                440900,
                441200,
                441300,
                441400,
                441500,
                441600,
                441700,
                441800,
                442099,
                445100,
                445200,
                445300,
                450000,
                460000,
                510300,
                510400,
                510500,
                510600,
                510700,
                510800,
                510900,
                511000,
                511100,
                511300,
                511400,
                511500,
                511600,
                511700,
                511800,
                511900,
                512000,
                513200,
                513300,
                513400,
                520100,
                520200,
                520300,
                520400,
                520500,
                522300,
                522600,
                522700,
                530000,
                540000,
                610200,
                610300,
                610400,
                610500,
                610600,
                610700,
                610800,
                610900,
                611000,
                620000,
                630000,
                640000,
                650000
              ], // 地区编码列表
              stayType: 1 // 停留类型
            },
          }
        },

        {
          name: "诸云",
          map: {
            region: {
              regionCodeList: [
                130100,
                130200,
                130300,
                130400,
                130500,
                130600,
                130700,
                130800,
                130900,
                131100,
                140000,
                150000,
                210000,
                220000,
                230000,
                320200,
                320300,
                320500,
                320700,
                320800,
                320900,
                321000,
                321200,
                321300,
                330200,
                330300,
                330400,
                330500,
                330600,
                330700,
                330800,
                330900,
                331000,
                331100,
                340100,
                340300,
                340400,
                340500,
                340600,
                340700,
                340800,
                341000,
                341100,
                341200,
                341300,
                341500,
                341600,
                341700,
                341800,
                350300,
                350400,
                350500,
                350600,
                350700,
                350900,
                360000,
                370000,
                410000,
                420000,
                430000,
                440200,
                440400,
                440500,
                440700,
                440800,
                440900,
                441200,
                441300,
                441400,
                441500,
                441600,
                441700,
                441800,
                442099,
                445100,
                445200,
                445300,
                450000,
                460000,
                500000,
                510300,
                510400,
                510500,
                510600,
                510700,
                510800,
                510900,
                511000,
                511100,
                511300,
                511400,
                511500,
                511600,
                511700,
                511800,
                511900,
                512000,
                513200,
                513300,
                513400,
                520000,
                530000,
                540000,
                610200,
                610300,
                610400,
                610500,
                610600,
                610700,
                610800,
                610900,
                611000,
                620000,
                630000,
                640000,
                650000
              ], // 地区编码列表
              stayType: 1 // 停留类型
            },
          }
        },
        {
          name: "繁花剧场",
          map: {
            region: {
              regionCodeList: [
                110000,
                120000,
                130000,
                140000,
                150000,
                210000,
                220000,
                230000,
                310000,
                320000,
                330000,
                340000,
                350000,
                360000,
                370000,
                410000,
                420000,
                430000,
                440000,
                450000,
                460000,
                500000,
                510000,
                520000,
                530000,
                540000,
                610000,
                620000,
                630000,
                640000,
                650000
              ], // 地区编码列表
              stayType: 1 // 停留类型
            },
          }
        },
        {
          name: "肥猫小说",
          map: {
            region: {
              regionCodeList: [
                120000,
                130000,
                140000,
                150000,
                210000,
                220000,
                230000,
                320200,
                320300,
                320400,
                320500,
                320600,
                320700,
                320800,
                320900,
                321000,
                321100,
                321200,
                321300,
                330200,
                330300,
                330400,
                330500,
                330600,
                330700,
                330800,
                330900,
                331000,
                331100,
                340000,
                350100,
                350300,
                350400,
                350500,
                350600,
                350700,
                350800,
                350900,
                360000,
                370000,
                410000,
                420000,
                430000,
                440200,
                440400,
                440500,
                440600,
                440700,
                440800,
                440900,
                441200,
                441300,
                441400,
                441500,
                441600,
                441700,
                441800,
                442099,
                445100,
                445200,
                445300,
                450000,
                460000,
                510300,
                510400,
                510500,
                510600,
                510700,
                510800,
                510900,
                511000,
                511100,
                511300,
                511400,
                511500,
                511600,
                511700,
                511800,
                511900,
                512000,
                513200,
                513300,
                513400,
                520000,
                530000,
                540000,
                610200,
                610300,
                610400,
                610500,
                610600,
                610700,
                610800,
                610900,
                611000,
                620000,
                630000,
                640000,
                650000,
                710199,
                810000,
                820000
              ], // 地区编码列表
              stayType: 1 // 停留类型
            },
          }
        },

        {
          name: "火苗",
          map: {
            region: {
              regionCodeList: [
                120000,
                130000,
                140000,
                150000,
                210000,
                220000,
                230000,
                320200,
                320300,
                320500,
                320600,
                320700,
                320800,
                320900,
                321000,
                321100,
                321300,
                330200,
                330300,
                330400,
                330500,
                330600,
                330700,
                330800,
                330900,
                331000,
                331100,
                340000,
                350100,
                350300,
                350400,
                350500,
                350600,
                350700,
                350800,
                350900,
                360100,
                360200,
                360300,
                360500,
                360600,
                360700,
                360800,
                360900,
                361000,
                370100,
                370200,
                370400,
                370500,
                370600,
                370700,
                370800,
                371000,
                371300,
                371400,
                371500,
                371600,
                371700,
                410000,
                420000,
                430100,
                430200,
                430300,
                430400,
                430500,
                430600,
                430700,
                430900,
                431000,
                431100,
                431200,
                431300,
                433100,
                440200,
                440400,
                440500,
                440600,
                440700,
                440800,
                440900,
                441200,
                441300,
                441400,
                441500,
                441600,
                441700,
                441800,
                442099,
                445100,
                445200,
                445300,
                450000,
                460000,
                510300,
                510400,
                510500,
                510600,
                510700,
                510800,
                510900,
                511100,
                511300,
                511400,
                511500,
                511600,
                511700,
                511800,
                511900,
                512000,
                513200,
                513300,
                513400,
                520000,
                530000,
                540000,
                610200,
                610300,
                610400,
                610500,
                610600,
                610700,
                610800,
                610900,
                611000,
                620000,
                630000,
                640000,
                650000,
                710199,
                810000,
                820000
              ]
              ,// 地区编码列表
              stayType: 1 // 停留类型
            },
          }
        },

        {
          name: "四组城市屏蔽",
          map: {
            region: {
              regionCodeList: [
                120000,
                130000,
                140200,
                140300,
                140400,
                140500,
                140600,
                140700,
                140800,
                140900,
                141000,
                141100,
                150000,
                210000,
                220000,
                230000,
                310000,
                320000,
                330200,
                330300,
                330400,
                330500,
                330600,
                330700,
                330800,
                330900,
                331000,
                331100,
                340000,
                350100,
                350300,
                350400,
                350500,
                350600,
                350700,
                350800,
                350900,
                360000,
                370000,
                410000,
                420200,
                420300,
                420500,
                420600,
                420700,
                420800,
                420900,
                421000,
                421100,
                421200,
                421300,
                422800,
                429078,
                429093,
                429094,
                429095,
                430000,
                440200,
                440400,
                440500,
                440600,
                440700,
                440800,
                440900,
                441200,
                441300,
                441400,
                441500,
                441600,
                441700,
                441800,
                442099,
                445100,
                445200,
                445300,
                450000,
                460000,
                500000,
                510000,
                520000,
                530000,
                540000,
                610000,
                620000,
                630000,
                640000,
                650000
              ]
              ,// 地区编码列表
              stayType: 1 // 停留类型
            },
          }
        },
        {
          name: "趣点",
          map: {
            region: {
              regionCodeList: [
                130000,
                140000,
                150000,
                210000,
                220000,
                230000,
                320300,
                320500,
                320700,
                320800,
                320900,
                321000,
                321200,
                321300,
                330200,
                330300,
                330400,
                330500,
                330600,
                330700,
                330800,
                330900,
                331000,
                331100,
                340000,
                350300,
                350400,
                350500,
                350600,
                350700,
                350900,
                360000,
                370000,
                410000,
                420200,
                420300,
                420500,
                420600,
                420700,
                420800,
                420900,
                421000,
                421100,
                421200,
                421300,
                422800,
                429078,
                429093,
                429094,
                429095,
                430000,
                440200,
                440400,
                440500,
                440700,
                440800,
                440900,
                441200,
                441300,
                441400,
                441500,
                441600,
                441700,
                441800,
                442099,
                445100,
                445200,
                445300,
                450000,
                460000,
                500000,
                510300,
                510400,
                510500,
                510600,
                510700,
                510800,
                510900,
                511000,
                511100,
                511300,
                511400,
                511500,
                511600,
                511700,
                511800,
                511900,
                512000,
                513200,
                513300,
                513400,
                520000,
                530000,
                540000,
                610200,
                610300,
                610400,
                610500,
                610600,
                610700,
                610800,
                610900,
                611000,
                620000,
                630000,
                640000,
                650000
              ],// 地区编码列表
              stayType: 1 // 停留类型
            },
          }
        },
        {
          name: "春河小说",
          map: {
            region: {
              regionCodeList: [
                130000,
                140000,
                150000,
                210000,
                220000,
                230000,
                320200,
                320400,
                320500,
                320600,
                320700,
                320800,
                321000,
                321100,
                321200,
                321300,
                330200,
                330300,
                330400,
                330500,
                330600,
                330700,
                330800,
                330900,
                331000,
                331100,
                350200,
                350300,
                350400,
                350500,
                350600,
                350700,
                350800,
                350900,
                360200,
                360300,
                360400,
                360500,
                360600,
                360700,
                360800,
                360900,
                361000,
                370200,
                370300,
                370400,
                370500,
                370600,
                370700,
                370800,
                370900,
                371000,
                371100,
                371400,
                371500,
                371600,
                410200,
                410300,
                410400,
                410500,
                410600,
                410800,
                410900,
                411000,
                411100,
                411200,
                411300,
                411400,
                411500,
                411600,
                411700,
                419098,
                420200,
                420300,
                420500,
                420600,
                420700,
                420800,
                420900,
                421000,
                421100,
                421200,
                421300,
                422800,
                429078,
                429093,
                429094,
                429095,
                430200,
                430300,
                430400,
                430500,
                430600,
                430700,
                430800,
                430900,
                431000,
                431100,
                431200,
                431300,
                433100,
                440200,
                440400,
                440500,
                440600,
                440700,
                440800,
                440900,
                441200,
                441300,
                441400,
                441500,
                441600,
                441700,
                441800,
                442099,
                445100,
                445200,
                445300,
                450000,
                460000,
                510300,
                510400,
                510500,
                510600,
                510700,
                510800,
                510900,
                511000,
                511100,
                511300,
                511400,
                511500,
                511600,
                511700,
                511800,
                511900,
                512000,
                513200,
                513300,
                513400,
                520000,
                530300,
                530400,
                530500,
                530600,
                530700,
                530800,
                530900,
                532300,
                532500,
                532600,
                532800,
                532900,
                533100,
                533300,
                533400,
                540000,
                610200,
                610300,
                610400,
                610500,
                610600,
                610700,
                610900,
                611000,
                620000,
                630000,
                640000,
                650000
              ]
              ,// 地区编码列表
              stayType: 1 // 停留类型
            },
          }
        },

        {
          name: "呱呱",
          map: {
            region: {
              regionCodeList: [
                130000,
                140000,
                150000,
                210000,
                220000,
                230000,
                320200,
                320300,
                320400,
                320600,
                320700,
                320800,
                320900,
                321000,
                321100,
                321200,
                321300,
                330300,
                330400,
                330500,
                330700,
                330800,
                330900,
                331000,
                331100,
                340200,
                340300,
                340400,
                340500,
                340600,
                340700,
                340800,
                341000,
                341100,
                341200,
                341300,
                341500,
                341600,
                341700,
                341800,
                350100,
                350300,
                350400,
                350500,
                350600,
                350700,
                350800,
                350900,
                360000,
                370300,
                370400,
                370500,
                370600,
                370700,
                370800,
                370900,
                371000,
                371100,
                371300,
                371400,
                371500,
                371600,
                371700,
                410000,
                420000,
                430200,
                430300,
                430400,
                430500,
                430600,
                430700,
                430800,
                430900,
                431000,
                431100,
                431200,
                431300,
                433100,
                440200,
                440400,
                440500,
                440700,
                440800,
                440900,
                441200,
                441300,
                441400,
                441500,
                441600,
                441700,
                441800,
                442099,
                445100,
                445200,
                445300,
                450000,
                460000,
                510300,
                510400,
                510500,
                510600,
                510700,
                510800,
                510900,
                511000,
                511100,
                511300,
                511400,
                511500,
                511600,
                511700,
                511800,
                511900,
                512000,
                513200,
                513300,
                513400,
                520000,
                530000,
                540000,
                610200,
                610300,
                610400,
                610500,
                610600,
                610700,
                610800,
                610900,
                611000,
                620000,
                630000,
                640000,
                650000,
                710199,
                810000,
                820000
              ]
              ,// 地区编码列表
              stayType: 1 // 停留类型
            },
          }
        },


        {
          name: "飞鱼",
          map: {
            region: {
              regionCodeList: [
                120000,
                130000,
                140000,
                150000,
                210000,
                220000,
                230000,
                320200,
                320300,
                320400,
                320500,
                320600,
                320700,
                320800,
                320900,
                321000,
                321100,
                321200,
                321300,
                330000,
                340000,
                350100,
                350300,
                350400,
                350500,
                350600,
                350700,
                350800,
                350900,
                360000,
                370000,
                410000,
                420200,
                420300,
                420500,
                420600,
                420700,
                420800,
                420900,
                421000,
                421100,
                421200,
                421300,
                422800,
                429078,
                429093,
                429094,
                429095,
                430000,
                440200,
                440400,
                440500,
                440600,
                440700,
                440800,
                440900,
                441200,
                441400,
                441500,
                441600,
                441700,
                441800,
                442099,
                445100,
                445200,
                445300,
                450000,
                460000,
                510000,
                520000,
                530000,
                540000,
                610200,
                610300,
                610400,
                610500,
                610600,
                610700,
                610800,
                610900,
                611000,
                620000,
                630000,
                640000,
                650000
              ]
              ,// 地区编码列表
              stayType: 1 // 停留类型
            },
          }
        },

        {
          name: "惟阅免费小说",
          map: {
            region: {
              regionCodeList: [
                130000,
                140000,
                150000,
                210000,
                220000,
                230000,
                320200,
                320300,
                320400,
                320600,
                320700,
                320800,
                320900,
                321000,
                321200,
                321300,
                330300,
                330400,
                330500,
                330700,
                330800,
                330900,
                331000,
                331100,
                340200,
                340300,
                340400,
                340500,
                340600,
                340700,
                340800,
                341000,
                341100,
                341200,
                341300,
                341500,
                341600,
                341700,
                341800,
                350100,
                350300,
                350400,
                350500,
                350600,
                350700,
                350800,
                350900,
                360000,
                370000,
                410000,
                420200,
                420300,
                420500,
                420600,
                420700,
                420800,
                420900,
                421000,
                421100,
                421200,
                421300,
                422800,
                429078,
                429093,
                429094,
                429095,
                430000,
                440200,
                440400,
                440700,
                440800,
                440900,
                441200,
                441300,
                441400,
                441500,
                441600,
                441700,
                441800,
                442099,
                445100,
                445200,
                445300,
                450000,
                460000,
                510300,
                510400,
                510500,
                510600,
                510700,
                510800,
                510900,
                511000,
                511100,
                511300,
                511400,
                511500,
                511600,
                511700,
                511800,
                511900,
                512000,
                513200,
                513300,
                513400,
                520000,
                530000,
                540000,
                610200,
                610300,
                610400,
                610500,
                610600,
                610700,
                610800,
                610900,
                611000,
                620000,
                630000,
                640000,
                650000,
                710199,
                810000,
                820000
              ]
              ,// 地区编码列表
              stayType: 1 // 停留类型
            },

          }
        },

      ],
      checkAll: false,
      isIndeterminate: false,
      phoneSeriesSSelect: [],
      phoneSeriesstatus: 0,
      installedApp: 1,
      phoneSerieslist: [
        { id: 1530002, name: "i系列" },
        { id: 1530001, name: "E系列" },
        { id: 1530003, name: "K系列" },
        { id: 1530004, name: "NEX系列" },
        { id: 1530005, name: "S系列" },
        { id: 1530006, name: "V系列" },
        { id: 1530007, name: "Y系列" },
        { id: 1530008, name: "Z系列" },
        { id: 1530009, name: "iQOO系列" },
        { id: 1530010, name: "X系列" },
        { id: 1530011, name: "Xplay系列" },
        { id: 1530012, name: "U系列" }
      ],
      successhisstory_list: [],
      showVue2: false,  // 控制 Vue2 显示/隐藏
      receivedData: null, // 存储从 Vue2 返回的数据

      uploadDialogVisible: false,
      videouploadDialogVisible: false,
      uploadType: 'image',
      uploadUrl: '/api/upload/image',
      acceptType: 'image/*',
      imgList: [],
      videoList: [],
      uploading: false,  // 上传状态
      videouploading: false,  // 上传状态
      // 文件夹和素材相关
      activeFolder: null,
      libraries: [
        {
          "id": 1,
          "name": "先创建文件夹"
        }
      ],
      filteredItemscopylist: [],
      sucaidialogVisible: false,
      btklist: [],
      btgjc: "",
      btkData: [],
      plbtkData: [],
      btkSelection: [],
      multipleSelection: [],
      pageSize: 20,
      pageIndex: 1,
      total: null,
      templatetotal: null,
      zsbtstatus: false,
      btstatus: false,
      sucTypeList: [
        { label: '网址', value: 1 },
        { label: '快应用', value: 8 }
      ],
      // isShow: false,
      isShow: false, // 控制进度条显示
      isShow2: false,//进度条显示
      uploadProgress: 0, // 上传进度百分比
      uploadProgress2: 0,
      customColors: [
        { color: '#f56c6c', percentage: 20 },
        { color: '#e6a23c', percentage: 40 },
        { color: '#5cb87a', percentage: 60 },
        { color: '#1989fa', percentage: 80 },
        { color: '#6f7ad3', percentage: 100 }
      ],
      bltitle: '',
      plsucaidialogVisible: false,
      plmultipleSelection: [],
      videofiletp: [],
      uploadingCanceled: false,
      errorfile: [],
      errorfiledlog: false,
      erroridslist: [],
      erroridsldlog: false,
      failedRequests: [],
      failedRequestsDialogVisible: false,
      templateDialogVisible: false,
      templateList: [],
      selectedTemplate: '',

      videoframeSaveErrorlist: [],
      videoframeSaveErrorlists: [],
      frameSaveerroridsldlog: false,
      isLoading: false,
      lastGetPlanTime: 0,
      /** 搭建记录 */
      buildLogs: [], // 搭建记录列表
      buildLogDialogVisible: false, // 搭建记录弹窗
      buildLogFilterAccount: "", // 按账户筛选
      buildLogFilterStep: "", // 按步骤筛选
      buildLogFilterStatus: "", // 按状态筛选
      timeeditlist: [],
      newgroupflag: false,
      group_optionatus: 1,
      group_option: [{
        value: '1',
        label: '近七日消耗最高'
      },
      {
        value: '2',
        label: '近一个月消耗最高'
      }, {
        value: '3',
        label: '手选'
      }],
      showOrderError: false,
      artistName: "",
      isChecked: false,
      dropdownOptions: [],
      selectedOption: '',
      uploadMultiple: 1,
      oldGroupscheduleTime: "",
      isoldgroupscheduleTime: false,
      errorMaterialsList: []
    };
  },
  watch: {  // 新增监听器
    orderexistgroup(newVal) {
      const numValue = Number(newVal)

      if (isNaN(numValue) || numValue < 1) {
        this.orderexistgroup = 1
        this.showOrderError = true

        setTimeout(() => {
          this.showOrderError = false
        }, 3000)
      } else {
        // 确保是整数
        this.orderexistgroup = Math.floor(numValue)
      }
    },
    result(newVal) {
      this.time_list = newVal
    },
    value(newVal) {
      this.selectedRegion = newVal;

    },
    // 监听手机系列状态变化，重置选择
    phoneSeriesstatus(newVal) {
      if (this._loadingTemplate) return;
      if (newVal === 0) {
        // 切换到"不限"时清空选择
        this.phoneSeriesSSelect = [];
        this.checkAll = false;
        this.isIndeterminate = false;
      }
    },
    // 监听安卓版本状态变化，重置选择
    androidVersionStatus(newVal) {
      if (this._loadingTemplate) return;
      if (newVal === 0) {
        this.selectedVersions = [];
        this.checkAllVersion = false;
        this.isIndeterminateVersion = false;
      } else {
        // 切换到"设置"时，初始化为当前默认值
        this.selectedVersions = [1650001, 1650002, 1650003, 1650004, 1650005, 1650006, 1650007, 1650008, 1650009, 1650010, 1650011, 1650012, 1650013];
        this.checkAllVersion = true;
        this.isIndeterminateVersion = false;
      }
    },
    // 监听购机价格状态变化，重置选择
    phonePriceStatus(newVal) {
      if (this._loadingTemplate) return;
      if (newVal === 0) {
        this.selectedPrices = [];
        this.checkAllPrice = false;
        this.isIndeterminatePrice = false;
      } else {
        // 切换到"设置"时，初始化为当前默认值
        this.selectedPrices = [1530014, 1530022, 1530021, 1530020, 1530019, 1530018, 1530017, 1530016, 1530015];
        this.checkAllPrice = true;
        this.isIndeterminatePrice = false;
      }
    },
    // 监听地域定向状态变化，切到"不限"时清空选择
    regionStatus(newVal) {
      if (newVal === 0) {
        this.beSelectDiYu = '';
        this.beSelectMap = {};
      }
    },
    // 监听转化目标变化：新目标无合法深度目标、或已选深度目标不在新目标可选范围内时重置深度优化选择
    // （覆盖 5/6/13 组内互切、oCPC→oCPD 切换等场景，避免残留旧深度目标提交非法组合）
    'formLabelAlign1.cvType'(newVal) {
      if (!this.canDeepOpt || !this.secondCvTypeOptions.some(o => String(o.value) === String(this.formLabelAlign1.secondCvType))) {
        this.isDeepOpt = false;
        this.formLabelAlign1.secondCvType = '';
        this.formLabelAlign1.secondOcpxPrice = '';
      }
    },
    // 推广目标变化：应用推广+商店仅展示 oCPD 目标，其他场景仅展示 oCPC 目标，切换后重置不在新集合内的转化目标
    beSelectAdType() {
      this.syncCvTypeOptions();
    },
    // 媒体类型变化：mediaType=0（商品/应用直投）时补充“搜索提词”版位选项，其他媒体类型移除
    'formLabelAlign.mediaType': {
      immediate: true,
      handler(newVal) {
        if (String(newVal) === '0') {
          if (!this.options4.some(item => String(item.value) === '21')) {
            this.options4.push(storeSearchPlacementBranch)
          }
        } else {
          const idx = this.options4.findIndex(item => String(item.value) === '21')
          if (idx > -1) {
            this.options4.splice(idx, 1)
            this.formLabelAlign3.placeType = []
            this.formLabelAlign3.wordChoiceModel = 1
            this.formLabelAlign3.generalSwitch = 0
          }
        }
        // 媒体类型切换：当前转化目标不在新场景可选范围内时重置
        this.syncCvTypeOptions();
      }
    },
    initialVivoexistgroupDateRange: {
      immediate: true,
      handler(newVal) {
        if (newVal && newVal.length === 2 && newVal[0] && newVal[1]) {
          this.vivoexistgroupDateRange = [...newVal];
        }
      }
    }
  },
  computed: {

    // 搜索提词版位（placeType=21）判断：placeType[0] === '21'
    isStoreSearchPlacement() {
      const pt = this.formLabelAlign3.placeType;
      return Array.isArray(pt) && pt.length >= 1 && String(pt[0]) === '21';
    },

    // 当前搜索提词模板的素材规格（未选模板/无图模板返回 null）
    storeSearchCurrentSpec() {
      if (!this.isStoreSearchPlacement || this.formLabelAlign3.placeType.length < 3) return null
      return storeSearchMaterialSpecs[String(this.formLabelAlign3.placeType[2])] || null
    },
    // 当前模板的素材规格提示文案（模板下拉与上传对话框共用）
    storeSearchSpecTip() {
      const spec = this.storeSearchCurrentSpec
      if (!spec) return ''
      return `平台要求：${spec.imgCount} 张 ${spec.width}*${spec.height}px，${spec.formats.join('/')}，每张不超过 ${Math.ceil(spec.maxSize / 1024)}KB`
    },

    parsedPresetOptions() {
      return this.presetOptions.map(option => {
        // 需要解析的字段列表
        const arrayFields = ['regionList', 'ageList', 'androidList', 'phonepriceList', 'phoneseriesList'];

        // 创建新对象避免修改原始数据
        const parsedOption = { ...option };

        // 解析每个数组字段
        arrayFields.forEach(field => {
          if (parsedOption[field]) {
            try {
              // 安全解析JSON字符串
              parsedOption[field] = JSON.parse(parsedOption[field].trim());

              // 确保解析后是数组类型
              if (!Array.isArray(parsedOption[field])) {
                console.warn(`字段 ${field} 解析后不是数组`, parsedOption[field]);
                parsedOption[field] = [];
              }
            } catch (e) {
              console.error(`解析字段 ${field} 失败:`, e);
              parsedOption[field] = [];
            }
          } else {
            parsedOption[field] = [];
          }
        });

        return parsedOption;
      });
    },
    // 地域定向（定向下拉）选项：不含"不限"，"不限"由单选按钮控制
    diYuOptions() {
      return this.mapArray.filter(item => item.name !== '不限');
    },
    // 转化目标列表：应用推广(beSelectAdType=2)+商店(mediaType=0)场景仅展示 oCPD 目标，其他场景仅展示 oCPC 目标
    options3() {
      if (String(this.beSelectAdType) === '2' && String(this.formLabelAlign.mediaType) === '0') {
        return this.options3Ocpd;
      }
      return this.options3Ocpc;
    },
    // 深度优化转化目标枚举：按前置转化目标过滤
    // 5 自定义激活(oCPC) → 8 ocpc次留；13 自定义拉活 → 27/53；102 自定义激活(oCPD) → 104 ocpd次留；其余目标无合法深度目标
    secondCvTypeOptions() {
      const cv = String(this.formLabelAlign1.cvType || '');
      if (cv === '5') return [{ value: 8, label: 'ocpc次留' }];
      if (cv === '13') return [
        { value: 27, label: '拉活自定义次留' },
        { value: 53, label: '拉活-自定义付费' }
      ];
      if (cv === '102') return [{ value: 104, label: 'ocpd次留' }];
      return [];
    },
    // 是否有合法深度优化转化目标（由过滤结果决定，避免 6 自定义注册等无深度目标时仍可开启）
    canDeepOpt() {
      return this.secondCvTypeOptions.length > 0;
    },
    result() {
      const bits = new Array(48).fill(0)
      this.timeRanges.forEach(range => {
        const start = this.timeToIndex(range.start)
        const end = this.timeToIndex(range.end)
        for (let i = start; i < end && i < 48; i++) {
          bits[i] = 1
        }
      })
      const resultStr = bits.join('');
      this.time_list = resultStr.repeat(7);
      console.log(this.time_list)
    },

    isLastEndMax() {
      const last = this.timeRanges[this.timeRanges.length - 1]
      return this.timeToIndex(last.end) >= 47
    },
    /** 搭建记录 - 按账户去重列表 */
    buildLogAccountList() {
      const accounts = [];
      const seen = {};
      this.buildLogs.forEach(log => {
        const key = log.accountName + '_' + log.accountId;
        if (!seen[key]) {
          seen[key] = true;
          accounts.push(log.accountName + '(' + log.accountId + ')');
        }
      });
      return accounts;
    },
    /** 搭建记录 - 筛选后的记录 */
    filteredBuildLogs() {
      let list = this.buildLogs;
      if (this.buildLogFilterAccount) {
        const accountName = this.buildLogFilterAccount.split('(')[0];
        if (accountName) {
          list = list.filter(l => l.accountName === accountName);
        }
      }
      if (this.buildLogFilterStep) {
        list = list.filter(l => l.step === this.buildLogFilterStep);
      }
      if (this.buildLogFilterStatus) {
        list = list.filter(l => l.status === this.buildLogFilterStatus);
      }
      return list;
    },





  },


  mounted() {
    this.initVivoexistgroupDefaultDateRange();


    this.fetchAdvRecordTodayTotal();
    // 每 30 秒刷新一次今日总数
    const now = new Date();
    const yyyy = now.getFullYear();
    const mm = String(now.getMonth() + 1).padStart(2, "0");
    const dd = String(now.getDate()).padStart(2, "0");

    // 判断是否在 18:00 以后
    if (now.getHours() >= 18) {
      // 日期加一天
      const tomorrow = new Date(now);
      tomorrow.setDate(now.getDate() + 1);

      const yyyy2 = tomorrow.getFullYear();
      const mm2 = String(tomorrow.getMonth() + 1).padStart(2, "0");
      const dd2 = String(tomorrow.getDate()).padStart(2, "0");

      this.advRecordQueryDate = `${yyyy2}-${mm2}-${dd2}`;
    } else {
      this.advRecordQueryDate = `${yyyy}-${mm}-${dd}`;
    }

    this.advRecordTimer = setInterval(() => {
      this.fetchAdvRecordTodayTotal();
    }, 30000);
    // 监听事件总线的数据传递事件
    this.placement_time = this.getTodayRange();

    bus.$on('data-selected', async (data) => {
      console.log("-----------------");
      console.log(data);
      console.log(this.selectedLibrary);
      this.receivedData = data;
      this.selectedLibrary = data.sucaiku
      if (this.txchange) {
        if (data.img.length > 0) {
          this.txfileList = data.img
          this.txfileCode[0] = data.img[0].code
        } else {
          this.$message.warning('请选择头像');
        }
        this.txchange = false
      } else if (this.tpchange) {
        if (data.img.length > 0) {
          console.log(data.img);

          // this.fileList = data.img
          // this.fileCode = data.img.map(item => item.code);
          data.img.map(item => {
            Vue.set(this, 'fileList', [...this.fileList, item])
            this.fileCode = [...this.fileCode, item.code];
            // 素材库 item 自带 filePath，与 fileCode 保持同序（模板 14/19 构造 imgsUrl 用）
            this.fileUrl = [...this.fileUrl, item.filePath];
          });
        } else {
          this.$message.warning('请至少选择一个图片素材');
        }
        this.tpchange = false
      } else if (this.zstpchange) {
        if (data.img.length > 0) {
          // this.zsfileList = data.img
          // this.zsfileCode = data.img.map(item => item.code);
          data.img.map(item => {
            Vue.set(this, 'zsfileList', [...this.zsfileList, item])
            this.zsfileCode = [...this.zsfileCode, item.code];
            // 素材库 item 自带 filePath，与 zsfileCode 保持同序（模板 14/19 撞审构造 imgsUrl 用）
            this.zsfileUrl = [...this.zsfileUrl, item.filePath];
          });
        } else {
          this.$message.warning('请至少选择一个图片素材');
        }
        this.zstpchange = false
      } else if (this.spchange) {
        if (data.video.length > 0) {
          // console.log("8888888888888888888888888888888888888");
          // this.VideofileList = data.video
          if (this.videoFMSwitch) {
            // 自动封面：等待所有 frameSave（带重试）完成后再关闭素材库，确保 videofileCode 就绪，避免搭建时取不到素材 id
            let failCount = 0;
            await Promise.all(data.video.map(async item => {
              const params = {};
              if (!this.videorangeFMSwitch) {
                params.randomIndexFlag = true;
              }
              const coverRes = await this.getFrameSaveWithRetry(item.code, params);
              if (!coverRes) {
                failCount++;
                return;
              }
              const covercode = coverRes.data.data ? coverRes.data.data.code : null;
              Vue.set(this, 'VideofileList', [...this.VideofileList, {
                videourl: item.video.fileUrl,
                title: item.title,
                code: item.code,
                videocode: item.code,
              }]);
              this.videofileCode = [...this.videofileCode, { videocode: item.code, videocovercode: covercode }];
            }));
            if (failCount > 0) {
              this.$message.warning(`有 ${failCount} 个视频封面生成失败，未加入素材列表，请重新选择`);
            }
          } else {
            if (this.fileCode.length < (this.VideofileList.length + data.video.length)) {
              this.$message.info('封面数量少于视频数量');
              return;
            }
            data.video.map(async (item, index) => {


              const obj = {
                videourl: item.video.fileUrl,
                title: item.title,
                code: item.code,
                covercode: this.fileCode[this.VideofileList.length + index],

              };

              Vue.set(this, 'VideofileList', [...this.VideofileList, {

                videourl: item.video.fileUrl,
                title: item.title,
                code: item.code,
                videocode: item.code,
                // code: item.code,
              }])

              this.videofileCode = [...this.videofileCode, { videocode: obj.code, videocovercode: obj.covercode }];
            });
          }

          // this.videofileCode = data.video.map(item => item.code);
        } else {
          this.$message.warning('请至少选择一个视频素材');
        }
        this.spchange = false
      } else if (this.zsspchange) {
        if (data.video.length > 0) {
          // this.zsVideofileList = data.video
          // this.zsvideofileCode = data.video.map(item => item.code);
          if (this.zsvideoFMSwitch) {
            // 自动封面：等待所有 frameSave（带重试）完成后再关闭素材库，确保 zsvideofileCode 就绪
            let failCount = 0;
            await Promise.all(data.video.map(async item => {
              const coverRes = await this.getFrameSaveWithRetry(item.code, {});
              if (!coverRes) {
                failCount++;
                return;
              }
              const covercode = coverRes.data.data ? coverRes.data.data.code : null;
              Vue.set(this, 'zsVideofileList', [...this.zsVideofileList, {
                // 重新组装数据，这里只取了部分属性，你可以根据需求添加或修改
                videourl: item.video.fileUrl,
                title: item.title,
                code: item.code,
                videocode: item.code,
              }]);
              this.zsvideofileCode = [...this.zsvideofileCode, { videocode: item.code, videocovercode: covercode }];
            }));
            if (failCount > 0) {
              this.$message.warning(`有 ${failCount} 个撞审视频封面生成失败，未加入素材列表，请重新选择`);
            }
          } else {
            if (this.zsfileCode.length < (this.zsVideofileList.length + data.video.length)) {
              this.$message.info('封面数量少于视频数量');
              return;
            }
            data.video.map(async (item, index) => {

              const obj = {
                videourl: item.video.fileUrl,
                title: item.title,
                code: item.code,
                covercode: this.zsfileCode[this.zsVideofileList.length + index]
              };



              Vue.set(this, 'zsVideofileList', [...this.zsVideofileList, {
                // 重新组装数据，这里只取了部分属性，你可以根据需求添加或修改
                videourl: item.video.fileUrl,
                title: item.title,
                code: item.code,
                videocode: item.code,
              }])
              this.zsvideofileCode = [...this.zsvideofileCode, { videocode: obj.code, videocovercode: obj.covercode }];
              // this.zsvideofileCode = [...this.zsvideofileCode, item.code];
            });
          }

        } else {
          this.$message.warning('请至少选择一个视频素材');
        }
        this.zsspchange = false
      }
      this.showVue2 = false; // 关闭 Vue2
      this.$refs.Vue2.$destroy(); // 确保你的组件有ref="myComponent"
    });
  },
  beforeDestroy() {
    if (this.countdownTimer) {
      clearInterval(this.countdownTimer);
    }
    // 组件销毁前移除事件监听
    bus.$off('data-selected');

  },
  methods: {
    showErrorSummary() {
      if (this.errorMaterialsList.length === 0) return;
      const h = this.$createElement;
      const items = this.errorMaterialsList.map(err => {
        return h('div', { style: 'margin-bottom: 8px;' }, [
          h('span', { style: 'color: #F56C6C; font-weight: bold;' }, `【${err.type}】`),
          h('span', ` ${err.name} `),
          h('span', { style: 'color: #909399;' }, `(${err.code})`),
          h('div', { style: 'font-size: 12px; color: #E6A23C; margin-top: 2px;' }, err.message)
        ]);
      });
      this.$alert(h('div', items), '以下素材创建失败', {
        confirmButtonText: '知道了',
        dangerouslyUseHTMLString: false, // 使用 VNode 更安全
        type: 'warning'
      });

    },
    // 场景切换联动：推广目标/媒体类型变化导致可选转化目标集合变化时，重置不在新集合内的目标及关联出价/深度优化
    syncCvTypeOptions() {
      const cur = String(this.formLabelAlign1.cvType || '');
      if (cur && !this.options3.some(o => String(o.value) === cur)) {
        this.formLabelAlign1.cvType = '';
        this.formLabelAlign1.ocpxPrice = '';
        this.isDeepOpt = false;
        this.formLabelAlign1.secondCvType = '';
        this.formLabelAlign1.secondOcpxPrice = '';
      }
    },
    initVivoexistgroupDefaultDateRange() {
      if (!this.vivoexistgroupDateRange || this.vivoexistgroupDateRange.length === 0) {
        const endDate = this.formatVivoexistgroupDate(new Date());
        const startDate = this.formatVivoexistgroupDate(new Date(new Date().setDate(new Date().getDate() - 6)));

        this.vivoexistgroupDateRange = [startDate, endDate];
        this.emitVivoexistgroupDateChange();
      }
    },

    /**
     * 处理日期选择变化
     */
    handleVivoexistgroupDateChange(value) {
      console.log('vivoexistgroup 日期范围变化:', value);
      this.vivoexistgroupDateRange = value

    },



    /**
     * 格式化日期为 YYYY-MM-DD
     */
    formatVivoexistgroupDate(date) {
      if (!date) return '';

      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');

      return `${year}-${month}-${day}`;
    },

    /**
     * 触发日期变化事件
     */
    emitVivoexistgroupDateChange() {
      const startDate = this.vivoexistgroupDateRange[0] || '';
      const endDate = this.vivoexistgroupDateRange[1] || '';

      // 发送事件给父组件
      this.$emit('vivoexistgroup-date-change', {
        startDate,
        endDate,
        dateRange: [...this.vivoexistgroupDateRange],
        activeQuickOption: this.vivoexistgroupActiveQuickOption
      });

      console.log(`vivoexistgroup 发送日期范围: ${startDate} 至 ${endDate}`);
      this.callVivoexistgroupApi(startDate, endDate);
    },

    callVivoexistgroupApi(startDate, endDate) {
      console.log(`vivoexistgroup 调用API，参数: startDate=${startDate}, endDate=${endDate}`);
    },

    /**
     * 获取月份的天数
     */
    getMonthDays(year, month) {
      return new Date(year, month, 0).getDate();
    },

    /**
     * 重置日期选择
     */
    resetVivoexistgroupDateRange() {
      this.vivoexistgroupDateRange = [];
      this.vivoexistgroupActiveQuickOption = 'last7days';
      this.initVivoexistgroupDefaultDateRange();
    },

    /**
     * 获取当前日期范围
     */
    getVivoexistgroupCurrentDateRange() {
      return {
        startDate: this.vivoexistgroupDateRange[0] || '',
        endDate: this.vivoexistgroupDateRange[1] || '',
        activeQuickOption: this.vivoexistgroupActiveQuickOption
      };
    },
    handleCheckAllChange(val) {
      if (val) {
        // 全选
        this.phoneSeriesSSelect = this.phoneSerieslist.map(item => item.id);
      } else {
        // 全不选
        this.phoneSeriesSSelect = [];
      }
      this.isIndeterminate = false;
    },

    // 复选框变化时更新全选状态
    handlePhoneSeriesChange(selectedIds) {
      const totalCount = this.phoneSerieslist.length;
      const selectedCount = selectedIds.length;

      this.checkAll = selectedCount === totalCount;
      this.isIndeterminate = selectedCount > 0 && selectedCount < totalCount;

      console.log('选中的系列ID:', selectedIds);
    },

    // 安卓版本全选
    handleCheckAllVersionChange(val) {
      if (val) {
        this.selectedVersions = this.androidVersions.map(item => item.value);
      } else {
        this.selectedVersions = [];
      }
      this.isIndeterminateVersion = false;
    },

    // 安卓版本复选框变化时更新全选状态
    handleVersionChange(selectedValues) {
      const totalCount = this.androidVersions.length;
      const selectedCount = selectedValues.length;

      this.checkAllVersion = selectedCount === totalCount;
      this.isIndeterminateVersion = selectedCount > 0 && selectedCount < totalCount;
    },

    // 购机价格全选
    handleCheckAllPriceChange(val) {
      if (val) {
        this.selectedPrices = this.priceRanges.map(item => item.value);
      } else {
        this.selectedPrices = [];
      }
      this.isIndeterminatePrice = false;
    },

    // 购机价格复选框变化时更新全选状态
    handlePriceChange(selectedValues) {
      const totalCount = this.priceRanges.length;
      const selectedCount = selectedValues.length;

      this.checkAllPrice = selectedCount === totalCount;
      this.isIndeterminatePrice = selectedCount > 0 && selectedCount < totalCount;
    },

    handleRegionChange(val) {
      // 双向绑定，通知父组件更新 v-model
      this.$emit("input", val);
      this.$emit("change", val);
      console.log(this.selectedRegion)
    },
    /** 打开详情弹窗 */
    openAdvRecordDetailDialog() {
      this.advRecordDetailDialogVisible = true;
      this.advRecordPageNo = 1; // 重置页码
      this.fetchAdvRecordDetailData();
    },

    /** 获取今日总数 */
    async fetchAdvRecordTodayTotal() {
      try {
        const res = await axios.get("https://control.zjwec.cn/api/creative-counts/today-total");
        if (res.data && res.data.code === "0") {
          this.advRecordTodayTotal = res.data.data.total;
          // this.zjadvRecordDetailTotal = res.data.data.zjTotal;
          // this.fjadvRecordDetailTotal = res.data.data.fjTotal;
        }
      } catch (e) {
        this.$message.error("获取今日总数失败");
      }
    },

    /** 获取详情数据 */
    async fetchAdvRecordDetailData() {
      try {
        const res = await axios.get("https://control.zjwec.cn/api/creative-counts/page", {
          params: {
            date: this.advRecordQueryDate,
            accountNameLike: this.advRecordQueryAccountName,
            pageNo: this.advRecordPageNo,
            pageSize: this.advRecordPageSize,
          },
        });

        if (res.data && res.data.code === '0') {
          const pageData = res.data.data;
          this.advRecordDetailList = pageData.records || [];
          this.advRecordTotalRecords = pageData.total || 0;

          // 累加当前页的总数量（也可改为后端返回该日期总和）
          this.advRecordDetailTotal = pageData.daySum
          this.zjadvRecordDetailTotal = pageData.zjSum
          this.fjadvRecordDetailTotal = pageData.fjSum
          this.szadvRecordDetailTotal = pageData.szSum
          this.suzadvRecordDetailTotal = pageData.jsSum
          this.gzzadvRecordDetailTotal = pageData.gzltSum
        }
      } catch (e) {
        this.$message.error("获取详情数据失败");
      }
    },

    /** 分页切换 */
    handleAdvRecordPageChange(newPage) {
      this.advRecordPageNo = newPage;
      this.fetchAdvRecordDetailData();
    },

    // 判断两个素材库是否为同一个（优先按 scId，其次按 id）
    isSameLibrary(a, b) {
      if (!a && !b) return true;
      if (!a || !b) return false;
      const ka = a.scId != null ? a.scId : a.id;
      const kb = b.scId != null ? b.scId : b.id;
      return String(ka) === String(kb);
    },
    // 清空所有已上传的素材（图片/视频/撞审/文字创意）
    clearAllMaterials() {
      this.txfileList = [];
      this.txfileCode = [];
      this.fileList = [];
      this.fileCode = [];
      this.fileUrl = [];
      this.zsfileList = [];
      this.zsfileCode = [];
      this.zsfileUrl = [];
      this.VideofileList = [];
      this.videofileCode = [];
      this.zsVideofileList = [];
      this.zsvideofileCode = [];
    },



    async templateInfoChange(row) {
      let loading = null;
      loading = this.$loading({
        lock: true,
        text: '正在录入...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      console.log(row);
      // 回填期间跳过定向 watch，避免其用全量硬编码值覆盖模板中的真实选择（不限/部分勾选）
      this._loadingTemplate = true;
      let res = this.deepParseObject(row)
      console.log(res);

      //回填
      // this.idsList = res.idsList;

      this.username = res.idsList;
      this.findIds()
      this.erjihangye = res.industry;
      this.selectedCategoryName = res.productLibrary;
      this.formLabelAlign.name = res.planName;
      this.formLabelAlign.dailyBudget = res.planBudget;

      // material：对比模板素材库与当前素材库
      const tplLibrary = (res.material && res.material.material) ? res.material.material : null;
      if (this.isSameLibrary(tplLibrary, this.selectedLibrary)) {
        // 素材库一致：本地已上传素材保持不变，只做素材库切换
        // 当前 selectedLibrary 为本次会话最新选择（token 更新），保持一致时不覆盖，避免用模板里的旧 token
      } else {
        // 素材库不一致：提示需要重新传输素材
        try {
          await this.$confirm('素材库不一致，需要重新传输素材，是否继续？', '提示', {
            confirmButtonText: '确认',
            cancelButtonText: '取消',
            type: 'warning'
          });
          // 确认：清空已上传素材并切换素材库
          this.clearAllMaterials();
          this.selectedLibrary = tplLibrary;
        } catch (e) {
          // 取消：保持当前素材库与已上传素材不变
        }
      }

      if (res.installedApp) this.installedApp = res.installedApp

      this.beSelectAdType = res.promotionGoal;
      this.formLabelAlign.mediaType = res.deliveryChannel.toString();
      this.flag = res.planSwitch;
      this.newplanflag = res.latestPlan;
      this.isguanz = res.wechatFollow;
      this.formLabelAlign1.cvType = res.conversionGoal;
      this.formLabelAlign1.ocpxPrice = res.secondBid;
      this.formLabelAlign1.secondCvType = res.secondCvType || '';
      this.formLabelAlign1.secondOcpxPrice = res.secondOcpxPrice || '';
      this.isDeepOpt = res.isDeepOpt || false;
      this.customList2 = res.audiencePackage;
      this.customListpc = res.excludeAudiencePackage;
      this.timeRanges = res.deliveryTime;

      let today = new Date().toISOString().slice(0, 10);
      this.placement_time = [...res.deliveryDate];
      this.placement_time[0] = today;
      console.log(this.placement_time);


      // geoTargeting
      this.beSelectDiYu = res.geoTargeting.geoTargeting;
      // 根据加载的数据设置地域定向状态：不限或不传时，不传地域参数
      this.regionStatus = (this.beSelectDiYu && this.beSelectDiYu !== '不限') ? 1 : 0;
      if (this.regionStatus === 0) {
        this.beSelectDiYu = '';
        this.beSelectMap = {};
      } else {
        this.diYuHandleSelectionChange();
      }
      this.isPreset = res.geoTargeting.isstat;
      this.presetValue = res.geoTargeting.presetValue;
      this.sex = res.geoTargeting.sex;
      this.age = res.geoTargeting.age;
      this.selectedVersions = res.geoTargeting.selectedVersions || [];
      this.selectedPrices = res.geoTargeting.selectedPrices || [];
      console.log("ccccccccccccccccccccccccccccccsssssssssssssssssssssss");
      if (res.geoTargeting.phoneseriesList) {
        this.phoneSeriesSSelect = res.geoTargeting.phoneseriesList.length > 0 ? res.geoTargeting.phoneseriesList : []
      }

      // 根据加载的数据设置状态
      this.androidVersionStatus = this.selectedVersions.length > 0 ? 1 : 0;
      this.phonePriceStatus = this.selectedPrices.length > 0 ? 1 : 0;
      this.phoneSeriesstatus = this.phoneSeriesSSelect.length > 0 ? 1 : 0;

      // 更新全选状态
      this.checkAllVersion = this.selectedVersions.length === this.androidVersions.length;
      this.isIndeterminateVersion = this.selectedVersions.length > 0 && this.selectedVersions.length < this.androidVersions.length;
      this.checkAllPrice = this.selectedPrices.length === this.priceRanges.length;
      this.isIndeterminatePrice = this.selectedPrices.length > 0 && this.selectedPrices.length < this.priceRanges.length;
      this.checkAll = this.phoneSeriesSSelect.length === this.phoneSerieslist.length;
      this.isIndeterminate = this.phoneSeriesSSelect.length > 0 && this.phoneSeriesSSelect.length < this.phoneSerieslist.length;

      // console.log(res.geoTargeting);


      this.formLabelAlign3.placeType = res.displayForm;
      // 模板回填：搜索提词版位的选词模式与流量优选（缺省按默认值）
      this.formLabelAlign3.wordChoiceModel = (res.wordChoiceModel != null && res.wordChoiceModel !== '') ? Number(res.wordChoiceModel) : 1;
      this.formLabelAlign3.generalSwitch = (res.generalSwitch != null && res.generalSwitch !== '') ? Number(res.generalSwitch) : 0;
      try {
        await this.findIds()
        await this.placeTypeChange(this.formLabelAlign3.placeType)
      } catch (e) {
        // 任意一步报错都要关闭 loading 并提示，避免一直卡在“正在录入”加载画面
        console.error('模板录入过程出错:', e);
        this.$message.error('模板录入失败：' + ((e && e.message) || '未知错误'));
      }
      this.formLabelAlign3.productNames = res.productName;
      this.daluan = res.titleShuffle;
      this.titlesString = res.title;
      this.handleInput()
      this.zstitlesString = res.subtitle;
      // 待本轮 watch 触发完毕后恢复，使加载忠实回显模板数据
      this.$nextTick(() => { this._loadingTemplate = false; });
      loading.close();
      this.templateDialogVisible = false
      // this.getimgvivolist()
    },
    shallowStringifyAll(obj) {
      const result = {};

      // 遍历对象的所有自有属性
      for (const key in obj) {
        if (obj.hasOwnProperty(key)) {
          const value = obj[key];

          // 处理null和undefined
          if (value === null || value === undefined) {
            result[key] = '';
          }
          // 处理数组和对象（包括嵌套对象和数组）
          else if (typeof value === 'object') {
            result[key] = JSON.stringify(value);
          }
          // 处理基本类型
          else {
            result[key] = String(value);
          }
        }
      }

      return result;
    },
    deepParseObject(obj) {
      // 如果不是对象或数组，直接返回
      if (typeof obj !== 'object' || obj === null) return obj;

      // 遍历对象的每个 key
      Object.keys(obj).forEach(key => {
        let value = obj[key];

        // 如果是字符串，尝试 JSON.parse
        if (typeof value == 'string') {
          console.log(1);
          try {
            const parsed = JSON.parse(value);
            obj[key] = parsed // 递归解析
          } catch (e) {
            // 不是 JSON 字符串，保持原值
            obj[key] = value;
          }
        }
        // 如果是对象或数组，递归解析
        else if (typeof value === 'object' && value !== null) {
          obj[key] = deepParseObject(value);
        }
      });

      return obj;
    },

    handleSizeChange(val) {
      this.queryParams.pageSize = val;
      this.fetchData();
    },

    // 当前页变化
    handletamplateCurrentChange(val) {
      this.queryParams.pageNum = val;
      this.fetchData();
    },
    handletemplateQuery() {
      this.queryParams.pageNum = 1; // 重置页码
      this.fetchData();
    },

    // 重置查询
    resettemplateQuery() {
      this.queryParams = {
        templateName: '',
        pageNum: 1,
        pageSize: 10
      };
      this.fetchData();
    },
    async handletemplateDelete(row) {
      this.$confirm('确定删除该模板吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const res = await axios.delete(`https://control.zjwec.cn/vivoAdModel/delete/${row.id}`);
        console.log(res);
        if (res.data.code == 0) {
          this.$message.success('删除成功');
          this.fetchData()
        } else {
          this.$message.info('删除失败');
        }

      }).catch(() => {
        this.$message.info('已取消删除');
      });
    },

    // 确认选择
    handletemplateConfirm() {
      if (this.selectedTemplate) {
        this.$emit('select', this.selectedTemplate);
        this.templateDialogVisible = false;
      }
    },

    // 加载模板列表
    async fetchData() {
      try {
        const res = await axios.get('https://control.zjwec.cn/vivoAdModel/page', {
          params: this.queryParams
        });
        console.log(res);
        this.templateList = res.data.data.records || [];
        this.templatetotal = res.data.data.total || 0;
      } catch (error) {
        this.$message.error('获取数据失败');
        console.error(error);
      }

    },
    handletemplateSelectionChange(selection) {
      if (selection.length > 0) {
        this.selectedTemplate = selection[0];
        // 清除其他选择，确保只选一个
        this.$refs.templateTable.clearSelection();
        this.$refs.templateTable.toggleRowSelection(selection[0]);
      } else {
        this.selectedTemplate = null;
      }
    },
    handleDialogClose() {
      this.selectedTemplate = null;
      this.$refs.templateTable.clearSelection();
    },
    handleCheckboxChange(val) {
      console.log('复选框状态:', val)

      // 如果取消勾选，清空下拉框选中的值
      if (!val) {
        this.selectedOption = ''
      }
    },

    // 下拉框变化处理
    handleSelectChange(val) {
      console.log('选择的下拉值:', val)
    },
    handleCascaderChange(value) {
      console.log('选择的值:', value)  // 输出选中的值数组
      console.log('最后一级选中的值:', value[value.length - 1])  // 输出最后一级的值

      // 在这里处理你的业务逻辑
      this.doSomething(value)
    },
    async doSomething(value) {
      // 你的业务逻辑
      console.log('处理业务:', value)


      // 更安全的判断方式
      if (!(this.idsList[0].id)) {
        this.$message.warning(`请输入账户`)
        this.erjihangye = []
        return
      }
      let res = await this.GetZZData2(this.idsList[0].ids, this.idsList[0].token)
      console.log(res);
      if (res.length > 0) {
        const dropdownOptions = res.map(item => ({
          label: item.productName,
          value: item.productName
        }))
        this.dropdownOptions = dropdownOptions
      }

    },

    handleCleanCommand(command) {
      switch (command) {
        case 'cleanTool':
          this.showCleanDialog();
          break;
        case 'cleanNormal':
          this.delectsucai();
          break;
        case 'cleanSpecial':
          this.delectsucai2();
          break;
        default:
          console.log('未知命令:', command);
      }
    },
    handleCommand(command) {
      if (command === 'unbound') {
        this.errorIdslDlogFun();
      } else if (command === 'failed') {
        this.failedRequestserrorIdslDlogFun();
      }
    },
    handleCommandframeSave(command) {
      if (command == 'frameSave') {
        this.frameSaveerroridsldlogFun()

      }
    },
    frameSaveerroridsldlogFun() {
      this.frameSaveerroridsldlog = true
      // this.videoframeSaveErrorlist.map(item=>{

      // })
      const foundItems = this.videoframeSaveErrorlist.map(errorItem => {
        return this.VideofileList.find(fileItem =>
          fileItem.code === errorItem
        );
      });
      console.log(foundItems);
      this.videoframeSaveErrorlists = foundItems
    },
    errorIdslDlogFun() {
      this.erroridsldlog = true
    },
    openerrorfiledlog() {
      this.errorfiledlog = true
    },
    errorCleanForm() {
      this.errorfiledlog = false
    },
    errorCleanForm2() {
      this.frameSaveerroridsldlog = false
    },
    beforeUpload(file) {
      const isImage = file.type === 'image/jpeg' || file.type === 'image/png';
      const isLt100KB = file.size / 1024 < 100;

      if (!isImage) {
        this.$message.error('只能上传 JPG/PNG 格式的图片！');
        return false;
      }

      // if (!isLt100KB) {
      //   this.$message.error('图片大小不能超过 100KB！');
      //   return false;
      // }

      return true;
    },
    getTodayRange() {
      const today = new Date();
      let start = new Date(today.setHours(0, 0, 0, 0)); // 今天 00:00:00
      start = dayjs(start).format('YYYY-MM-DD')
      let end = '2038-01-19'; // 今天 00:00:00
      this.startDate = start
      this.endDate = '2038-01-19'
      return [start, end];
    },
    PlacementTimehange(time) {
      if (time && time.length === 2) {
        const formatted = time.map(date => dayjs(date).format('YYYY-MM-DD'));
        console.log('格式化后:', formatted); // ['2038-01-19', '2038-01-25'] 之类
        // 如果你想保存
        // this.formattedPlacementTime = formatted;
        this.startDate = formatted[0]
        this.endDate = formatted[1]
      } else {
        console.log('未选择日期');
      }
    },
    // 选中的定向数据
    handlePresetChange(selectedOption) {
      // 跳过 status watch，避免其用全量硬编码值覆盖预设包内自定义的列表
      this._loadingTemplate = true;
      console.log("选中的预设包对象:", selectedOption);

      // 处理手机系列
      if (selectedOption.phoneseriesList && selectedOption.phoneseriesList.length > 0) {
        this.phoneSeriesstatus = 1;
        this.phoneSeriesSSelect = selectedOption.phoneseriesList;
        this.checkAll = this.phoneSeriesSSelect.length === this.phoneSerieslist.length;
        this.isIndeterminate = this.phoneSeriesSSelect.length > 0 && this.phoneSeriesSSelect.length < this.phoneSerieslist.length;
      } else {
        this.phoneSeriesstatus = 0;
        this.phoneSeriesSSelect = [];
      }

      // 处理安卓版本
      if (selectedOption.androidList && selectedOption.androidList.length > 0) {
        this.androidVersionStatus = 1;
        this.selectedVersions = selectedOption.androidList;
        this.checkAllVersion = this.selectedVersions.length === this.androidVersions.length;
        this.isIndeterminateVersion = this.selectedVersions.length > 0 && this.selectedVersions.length < this.androidVersions.length;
      } else {
        this.androidVersionStatus = 0;
        this.selectedVersions = [];
      }

      // 处理购机价格
      if (selectedOption.phonepriceList && selectedOption.phonepriceList.length > 0) {
        this.phonePriceStatus = 1;
        this.selectedPrices = selectedOption.phonepriceList;
        this.checkAllPrice = this.selectedPrices.length === this.priceRanges.length;
        this.isIndeterminatePrice = this.selectedPrices.length > 0 && this.selectedPrices.length < this.priceRanges.length;
      } else {
        this.phonePriceStatus = 0;
        this.selectedPrices = [];
      }
      // 待本轮 watch 触发完毕后恢复，保留预设包定义的列表
      this.$nextTick(() => { this._loadingTemplate = false; });
    },
    videoFMSwitchonchang(val) {
      console.log(val);
      this.videoFMSwitch = val
    },
    videoFMvideorangeFMSwitchchang(val) {
      console.log(val);
      this.videorangeFMSwitch = val
    },
    zsvideoFMSwitchonchange(val) {
      this.zsvideoFMSwitch = val
    },
    centerDialogVisible() {
      this.dialogImageUrl = "";
      this.dialogVisible = false;
    },
    delectsucai() {
      // this.txfileList = []
      // this.txfileCode = []
      // this.zsfileCode = []
      this.fileCode = []
      this.fileUrl = []
      // this.zsfileList = []
      this.fileList = []
      this.VideofileList = []
      this.videofileCode = []

      // this.zsVideofileList = []
    },
    delectsucai2() {
      // this.txfileList = []
      // this.txfileCode = []
      this.zsfileCode = []
      this.zsfileUrl = []
      this.zsfileList = []
      // this.fileCode = []
      // this.zsfileList = []
      // this.fileList = []
      // this.VideofileList = []
      this.zsvideofileCode = []
      this.zsVideofileList = []
    },
    GetmultipleSelection() {
      console.log(this.multipleSelection);
      if (this.btstatus) {
        this.titlesString = this.multipleSelection.map(item => item.title).join('\n');
        this.formLabelAlign3.title = this.multipleSelection.map(item => item.title)
        console.log(this.formLabelAlign3.title);
      } else if (this.zsbtstatus) {
        this.zstitlesString = this.multipleSelection.map(item => item.title).join('\n');
        this.zstitleList = this.multipleSelection.map(item => item.title);
        console.log(this.zstitleList);
      }
      this.toggleSelection()
      this.multipleSelection = []
      this.zsbtstatus = false
      this.btstatus = false
      this.sucaidialogVisible = false
    },
    plGetmultipleSelection() {
      console.log(this.plmultipleSelection);
      if (this.btstatus) {
        this.titlesString = this.plmultipleSelection.map(item => item.vltitle).join('\n');
        this.formLabelAlign3.title = this.plmultipleSelection.map(item => item.vltitle)
        console.log(this.formLabelAlign3.vltitle);
      } else if (this.zsbtstatus) {
        this.zstitlesString = this.plmultipleSelection.map(item => item.vltitle).join('\n');
        this.zstitleList = this.plmultipleSelection.map(item => item.vltitle);
        console.log(this.zstitleList);
      }
      this.pltoggleSelection()
      this.plmultipleSelection = []
      this.zsbtstatus = false
      this.btstatus = false
      this.plsucaidialogVisible = false
    },
    // GetmultipleSelection2(){
    //   console.log(this.multipleSelection);
    //   this.zstitlesString = this.multipleSelection.map(item => item.title).join('\n');
    //   this.toggleSelection()
    //   this.multipleSelection=[]
    //   // this.zstitlesString=this.multipleSelection.map(item => item.title).join('\n');
    //   this.sucaidialogVisible = false
    // },
    pltoggleSelection(rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.plmultipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.plmultipleTable.clearSelection();
      }
    },
    toggleSelection(rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    // pltoggleSelection

    clonehandSelect() {
      this.toggleSelection()
      this.multipleSelection = []
      this.btgjc = ""
      this.sucaidialogVisible = false
    },
    clonehandSelects() {
      // this.toggleSelection()
      // this.multipleSelection = []
      this.bltitle = ""
      this.plsucaidialogVisible = false
    },
    handleSelectionChange(val) {
      console.log(val);
      this.multipleSelection = val;
    },
    plhandleSelectionChange(val) {
      this.plmultipleSelection = val
    },
    handleCurrentChange(val) {
      console.log(val);
      this.pageIndex = val
      this.Getbtklist2(val)
    },
    handleCurrentChanges(val) {
      console.log(val);
      this.pageIndex = val
      this.Getbtklist3(val)
    },
    Getbtklist() {
      console.log("11");
      this.toggleSelection()
      this.multipleSelection = []
      let obj = {
        keyword: this.btgjc,
        cookie: this.zjcookie + ";b_marketing_subid=" + this.selectedLibrary.scId,
        pageIndex: 1,
        pageSize: this.pageSize
      }
      const queryString = Object.keys(obj)
        .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(obj[key])}`)
        .join('&');

      const urlWithParams = `${'https://control.zjwec.cn/api/vivo/titleQuery'}?${queryString}`;

      axios.get(urlWithParams)
        .then(response => {
          console.log(response.data.data);
          this.btkData = response.data.data.list
          this.total = response.data.data.total
          // 处理响应数据
        })
        .catch(error => {
          // 处理错误
        });
      // this.$axios.get('https://control.zjwec.cn/api/vivo/titleQuery'
      // ).then(res => {
      //   console.log(res.data);
      // })
    },
    plGetbtklist() {
      console.log("11");
      this.pltoggleSelection()
      this.plmultipleSelection = []
      let obj = {
        keyword: this.selectedLabels[1],
        pageIndex: 1,
        pageSize: this.pageSize,
        title: this.bltitle
      }
      const queryString = Object.keys(obj)
        .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(obj[key])}`)
        .join('&');

      const urlWithParams = `${'https://control.zjwec.cn/vltitlelib/pageSearch'}?${queryString}`;

      axios.get(urlWithParams)
        .then(response => {
          console.log(response.data.records);
          this.plbtkData = response.data.records
          this.total = response.data.total
          // 处理响应数据
        })
        .catch(error => {
          // 处理错误
        });
      // this.$axios.get('https://control.zjwec.cn/api/vivo/titleQuery'
      // ).then(res => {
      //   console.log(res.data);
      // })
    },
    Getbtklist2(val) {
      let obj = {
        keyword: this.btgjc,
        cookie: this.zjcookie + ";b_marketing_subid=" + this.selectedLibrary.scId,
        pageIndex: val,
        pageSize: 20
      }
      const queryString = Object.keys(obj)
        .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(obj[key])}`)
        .join('&');

      const urlWithParams = `${'https://control.zjwec.cn/api/vivo/titleQuery'}?${queryString}`;

      axios.get(urlWithParams)
        .then(response => {
          console.log(response.data.data);
          this.btkData = response.data.data.list
          this.total = response.data.data.total
          // 处理响应数据
        })
        .catch(error => {
          // 处理错误
        });
      // this.$axios.get('https://control.zjwec.cn/api/vivo/titleQuery'
      // ).then(res => {
      //   console.log(res.data);
      // })
    },
    Getbtklist3(val) {
      this.selectedLabels = [];
      const findLabels = (options, values) => {
        for (const option of options) {
          if (option.value === values[0]) {
            this.selectedLabels.push(option.label);
            if (values.length > 1) {
              return findLabels(option.children, values.slice(1));
            }
            return;
          } else if (option.children) {
            const subLabels = findLabels(option.children, values);
            if (subLabels) {
              return subLabels;
            }
          }
        }
        return null;
      };
      findLabels(this.options5, this.erjihangye)
      console.log(this.selectedLabels);

      let obj = {
        keyword: this.selectedLabels[1],
        pageIndex: val,
        pageSize: this.pageSize,
        title: this.bltitle
      }
      const queryString = Object.keys(obj)
        .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(obj[key])}`)
        .join('&');

      const urlWithParams = `${'https://control.zjwec.cn/vltitlelib/pageSearch'}?${queryString}`;

      axios.get(urlWithParams)
        .then(response => {
          console.log(response.data.records);
          this.plbtkData = response.data.records
          this.total = response.data.total
          // 处理响应数据
        })
        .catch(error => {
          // 处理错误
        });
    },
    selectbt(number) {
      if (!this.selectedLibrary) {
        this.$message({
          message: '请选择素材库后操作!',
          type: 'warning'
        });
        return
      }
      // this.Getbtklist()
      let obj = {
        keyword: this.btgjc,
        cookie: this.zjcookie + ";b_marketing_subid=" + this.selectedLibrary.scId,
        pageIndex: 1,
        pageSize: this.pageSize
      }
      const queryString = Object.keys(obj)
        .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(obj[key])}`)
        .join('&');

      const urlWithParams = `${'https://control.zjwec.cn/api/vivo/titleQuery'}?${queryString}`;

      axios.get(urlWithParams)
        .then(response => {
          console.log(response.data.data);
          this.btkData = response.data.data.list
          this.total = response.data.data.total
          // 处理响应数据
        })
        .catch(error => {
          // 处理错误
        });
      this.sucaidialogVisible = true
      if (number == 1) {
        this.btstatus = true
      } else if (number == 2) {
        this.zsbtstatus = true
      }

    },
    templateDialogVisibleChange() {
      this.templateDialogVisible = true
      this.fetchData()
    },
    selectbts(number) {
      if (!this.erjihangye.length > 0) {
        this.$message({
          message: '请选择行业后操作!',
          type: 'warning'
        });
        return
      }
      this.plsucaidialogVisible = true
      this.selectedLabels = [];
      const findLabels = (options, values) => {
        for (const option of options) {
          if (option.value === values[0]) {
            this.selectedLabels.push(option.label);
            if (values.length > 1) {
              return findLabels(option.children, values.slice(1));
            }
            return;
          } else if (option.children) {
            const subLabels = findLabels(option.children, values);
            if (subLabels) {
              return subLabels;
            }
          }
        }
        return null;
      };
      findLabels(this.options5, this.erjihangye)
      console.log(this.selectedLabels);

      let obj = {
        keyword: this.selectedLabels[1],
        pageIndex: 1,
        pageSize: this.pageSize,
        title: this.bltitle
      }
      const queryString = Object.keys(obj)
        .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(obj[key])}`)
        .join('&');

      const urlWithParams = `${'https://control.zjwec.cn/vltitlelib/pageSearch'}?${queryString}`;

      axios.get(urlWithParams)
        .then(response => {
          console.log(response.data.records);
          this.plbtkData = response.data.records
          this.total = response.data.total
          // 处理响应数据
        })
        .catch(error => {
          // 处理错误
        });
      if (number == 1) {
        this.btstatus = true
      } else if (number == 2) {
        this.zsbtstatus = true
      }

    },
    swtichonchange(value) {

      this.localselection = value
      console.log(value);
    },
    // 定义查找函数
    findCookieByName(targetName) {
      if (!targetName) return null;
      // 精确匹配优先(如「浙江」「福建」「广州力天」)
      const exact = this.AllCookieList.find(item => item.hdname === targetName);
      if (exact) return exact.hdcookie;
      // 精确匹配失败时按包含关系兜底(如「深圳」匹配「深圳星火」、「苏州」匹配「苏州跃盟」),要求唯一避免误配
      const fuzzy = this.AllCookieList.filter(item => item.hdname.includes(targetName));
      return fuzzy.length === 1 ? fuzzy[0].hdcookie : null;
    },

    async fetchHdCookieData() {
      const pageNum = 1;
      const uid = 1;
      const role = 1;
      const pageSize = 10;
      const name = ''; // 根据需要修改此参数
      const url = `https://control.zjwec.cn/api/hdcookie/page?pageNum=${pageNum}&uid=${uid}&role=${role}&pageSize=${pageSize}&name=${encodeURIComponent(name)}`;
      try {
        const response = await axios.get(url);
        console.log('数据获取成功:', response.data);
        this.AllCookieList = response.data.data.records;
        this.zjcookie = response.data.data.records[0].hdcookie
        this.$store.commit('updatescookile', response.data.data.records[0].hdcookie);

        // 这里可以处理返回的数据，例如更新到状态管理或组件
      } catch (error) {
        console.error('错误:', error);
      }
    },
    async SelectionChangesucai(data) {
      console.log(data);
      try {
        // 清空素材列表
        this.txfileList = []
        this.txfileCode = []
        this.zsfileList = []
        this.fileList = []
        this.VideofileList = []
        this.zsVideofileList = []

        // 检查用户名
        if (!this.username) {
          this.$message.warning('请选择账户在进行后续操作!')
          this.selectedLibrary = ""
          return
        }

        // 检查广告账户是否选中
        if (!this.idsList[0].id) {
          this.$message.warning('请选择在查询广告账户后操作!')
          this.selectedLibrary = ""
          return
        }

        // 更新 selectedLibrary（要在 id 赋值前）
        this.selectedLibrary = data
        const id = this.selectedLibrary.scId
        this.fetchHdCookieData()

        // 获取文件夹列表
        const res = await this.$axios.post('https://control.zjwec.cn/api/sucaiku/getFolder', {
          cookie: this.zjcookie + ";b_marketing_subid=" + id
        })

        let folders = res.data.data.folders || []
        this.libraries = folders.length > 0 ? folders : []

        // 查找“本地文件夹”
        let localFolder = folders.find(f => f.name === '本地文件夹')

        if (!localFolder) {
          // 如果没有“本地文件夹”，则创建
          const createRes = await this.$axios.post('https://control.zjwec.cn/api/sucaiku/addFold', {
            cookie: this.zjcookie + ";b_marketing_subid=" + id,
            name: "本地文件夹",
            parentId: null
          })

          this.$message.success('创建“本地文件夹”成功')

          // 重新获取文件夹列表
          const refetchRes = await this.$axios.post('https://control.zjwec.cn/api/sucaiku/getFolder', {
            cookie: this.zjcookie + ";b_marketing_subid=" + id
          })

          folders = refetchRes.data.data.folders || []
          this.libraries = folders
          localFolder = folders.find(f => f.name === '本地文件夹')
          if (!localFolder) throw new Error('创建失败：本地文件夹仍未找到')
        }

        // 尝试查找当前用户命名的子文件夹
        const userFolder = folders.find(f => f.name === this.idsList.at(-1).username)

        if (userFolder) {
          this.activeFolder = userFolder
        } else {
          // 创建用户子文件夹
          const addUserFolderRes = await this.$axios.post('https://control.zjwec.cn/api/sucaiku/addFold', {
            cookie: this.zjcookie + ";b_marketing_subid=" + id,
            name: this.idsList.at(-1).username,
            parentId: localFolder.id
          })
          console.log(addUserFolderRes);
          if (addUserFolderRes.data.retcode == '409313') {
            this.$message.error('创建子文件夹失败: ' + addUserFolderRes.data.message)
            return
          }
          this.$message.success('创建子文件夹成功')

          // 重新拉取文件夹，获取新创建的子文件夹
          const finalFoldersRes = await this.$axios.post('https://control.zjwec.cn/api/sucaiku/getFolder', {
            cookie: this.zjcookie + ";b_marketing_subid=" + id
          })

          const newUserFolder = finalFoldersRes.data.data.folders.find(f => f.name === this.idsList.at(-1).username)
          this.activeFolder = newUserFolder || null
        }

        console.log("最终选中的文件夹", this.activeFolder)

      } catch (error) {
        console.error("选择素材库失败", error)
        this.$message.error(`操作失败：${error.message}`)
      }
    },

    getFolder() {
      // console.log( this.selectedLibrary)
      this.$axios.post('https://control.zjwec.cn/api/sucaiku/getFolder', {
        cookie: this.zjcookie + ";b_marketing_subid=" + this.selectedLibrary.scId,

      }).then(res => {

        console.log(res)
        if (res.data.data.folders.length > 0) {
          this.activeFolder = res.data.data.folders.filter(item => item.name === '本地文件夹')
          console.log(this.activeFolder);
        } else {
          this.libraries = []
        }


      })
    },
    handleCancelUpload() {
      this.uploadingCanceled = true;
      this.videouploadDialogVisible = false;
      this.uploadControllers.forEach(controller => controller.abort()); // 中断所有
      this.uploadControllers = []; // 清空
      this.videouploading = false;
      this.$message.info('已取消所有上传');
    },
    videoReset() {
      this.videoList = []
      this.videouploading = false

    },
    videohandleFileChange(file, videoList) {
      const MAX_VIDEO_SIZE = 51200 * 1024; // 51200KB = 50MB

      // 判断当前上传的视频是否超过大小限制
      if (file.raw && file.raw.size > MAX_VIDEO_SIZE) {
        console.log(this.formLabelAlign3.placeType);
        this.$message.warning(`视频 "${file.name}" 超过了 50MB 大小限制`);

        // 手动移除该视频文件
        this.videoList = videoList.filter(f => f.uid !== file.uid);
        return;
      }

      // 正常更新列表（去除 status 为 removed 的）
      this.videoList = videoList.filter(f => f.status !== 'removed');
    },
    uploadFile(img) {

      const params = {
        access_token: this.selectedLibrary.scToken,
        advertiser_id: this.selectedLibrary.scId,
        timestamp: Date.now(),
        nonce: Math.round(Math.random() * 1e11)
      };

      var formData = new FormData();
      formData.append('file', img.raw);

      return axios.post(
        'api/openapi/v1/upload/file/image?' + Object.keys(params)
          .map((key) => {
            return encodeURIComponent(key) + '=' + encodeURIComponent(params[key])
          }).join('&'),
        formData,
        { headers: { 'Content-Type': 'multipart/form-data' } }
      ).then((res) => {
        console.log(res.data.data.fileCode);
        console.log(this.txchange);
        if (this.txchange) {
          if (res.data.data.fileCode) {

            this.txfileList = [res.data.data.filePath];
            Vue.set(this.txfileCode, 0, res.data.data.fileCode);
            console.log(this.txfileList);
            console.log(this.txfileCode);
          }
          // this.txchange = false
        } else if (this.tpchange) {
          // console.log("222222222222");
          if (res.data.data.fileCode) {
            console.log(res.data.data);
            let imgoj = {
              name: img.name,
              uid: res.data.data.fileCode,
              filePath: res.data.data.filePath
            }

            Vue.set(this, 'fileList', [...this.fileList, imgoj])

            this.fileCode = [...this.fileCode, res.data.data.fileCode]
            this.fileUrl = [...this.fileUrl, res.data.data.filePath]

          }
          // this.tpchange = false
        } else if (this.zstpchange) {
          console.log("3333333333333");
          if (res.data.data.fileCode) {
            let imgoj = {
              name: res.data.data.sourceFileName,
              uid: res.data.data.fileCode,
              filePath: res.data.data.filePath
            }
            Vue.set(this, 'zsfileList', [...this.zsfileList, imgoj])
            // this.zsfileList = [...this.zstpchange,imgoj]
            this.zsfileCode = [...this.zsfileCode, res.data.data.fileCode]
            this.zsfileUrl = [...this.zsfileUrl, res.data.data.filePath]
          }
          // this.zstpchange = false
        }

        return res.data.data.fileCode;
      });
    },
    uploadCoverFile(img) {
      // console.log(this.selectedLibrary);
      // console.log("开始前先看看fileList");
      // console.log(this.fileList);
      const params = {
        access_token: this.selectedLibrary.scToken,
        advertiser_id: this.selectedLibrary.scId,
        timestamp: Date.now(),
        nonce: Math.round(Math.random() * 1e11)
      };

      var formData = new FormData();
      formData.append('file', img);

      return axios.post(
        'api/openapi/v1/upload/file/image?' + Object.keys(params)
          .map((key) => {
            return encodeURIComponent(key) + '=' + encodeURIComponent(params[key])
          }).join('&'),
        formData,
        { headers: { 'Content-Type': 'multipart/form-data' } }
      )


    },
    uploadVideoFile(video) {//上传视频
      const controller = new AbortController();
      this.uploadControllers.push(controller); // 统一保存用于取消.

      const params = {
        access_token: this.selectedLibrary.scToken,
        advertiser_id: this.selectedLibrary.scId,
        timestamp: Date.now(),
        nonce: Math.round(Math.random() * 1e11)
      };

      const formData = new FormData();
      formData.append('file', video.raw);

      const url = 'api/openapi/v1/upload/file/video?' +
        Object.keys(params)
          .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
          .join('&');

      // 不加固定超时:带宽紧张时上传会慢到几分钟,墙钟超时会把正在传的文件误杀
      return axios.post(url, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
        signal: controller.signal
      })
        .then(async (res) => {
          const data = res.data.data;
          if (!data || !data.fileCode) {
            throw new Error('上传响应异常');
          }
          // console.log(data);
          // const cookie = this.zjcookie + ";b_marketing_subid=" + this.selectedLibrary.scId;
          // const coverRes = await axios.get(`https://control.zjwec.cn/api/vivo/frameSave`, {
          //   params: { videoCode:data.fileCode, cookie }
          // });
          // console.log(coverRes);
          // if (res.data.retcode == -1) {
          //     return null
          // }
          const obj = {
            code: data.fileCode,
            title: video.name,
            videourl: data.fileFullPath,
            file: video
            // covercode:coverRes.data.message=="操作成功"?coverRes.data.data.code:null
          };
          console.log("视频打印");
          console.log(obj);

          console.log(this.spchange);
          console.log(this.zsspchange);
          if (this.spchange || this.zsspchange) {
            return obj;
          }

          return data.fileCode;
        });
    },

    async refreshVideoMaterialData() {
      try {
        await this.fetchMaterials();
        await this.fetchMaterialsVideo();
      } catch (e) {
        console.error('视频数据刷新失败:', e);
      }
    },
    bindMaterial(codeString) {
      // console.log(this.activeFolder);
      console.log(this.activeFolder);
      if (!this.activeFolder) return;
      console.log("dddddddddddddddddddssssssssssccccccccccc");
      return this.$axios.post('https://control.zjwec.cn/api/sucaiku/bindFold', {
        cookie: this.zjcookie + ";b_marketing_subid=" + this.selectedLibrary.scId,
        imgCode: codeString,
        folderId: this.activeFolder.id,
        type: 1
      }, {
        timeout: 15000,
        validateStatus: function (status) {
          return status === 200;
        }
      });
    },
    // 确认上传
    async handleConfirmUpload() {
      console.log(this.imgList.length);
      if (this.imgList.length === 0) {
        this.$message.warning('请先选择要上传的文件');
        return;
      }
      // 搜索提词版位：按模板要求校验图片数量，不足则拦截（三图模板轮转取图会重复素材，需满张数）
      if (this.isStoreSearchPlacement) {
        const spec = this.storeSearchCurrentSpec
        if (spec && this.imgList.length < spec.imgCount) {
          this.$message.warning(`当前模板需 ${spec.imgCount} 张图片，已选 ${this.imgList.length} 张，请补齐后再上传`);
          return;
        }
      }
      // this.

      try {
        this.uploading = true;
        const successCodes = [];
        const failedFiles = [];

        console.log(this.imgList);
        // 第一阶段：上传所有文件
        for (let i = 0; i < this.imgList.length; i++) {
          const img = this.imgList[i];
          try {
            this.$message.info("正在上传第 " + (i + 1) + "/" + this.imgList.length + " 个文件...");

            // 执行文件上传
            // console.log('------------------');
            console.log(this.fileList);
            // console.log('------------------');
            const fileCode = await this.uploadFile(img);
            // console.log("第二次检查fileList");
            console.log(this.fileList);
            if (!this.username) {
              this.$message({
                message: '请在姓名列表中选择姓名',
                type: 'warning'
              });
              return
            }
            await this.bindMaterial(fileCode);
            console.log("第三次检查fileListqudian");
            console.log(fileCode);
            // console.log(this.fileList);
            successCodes.push(fileCode);

            this.$message.success("文件 " + (i + 1) + " 上传成功");
            console.log("第四次检查fileList");
            console.log(this.fileList);
          } catch (uploadError) {
            console.error("文件 " + (i + 1) + " 上传失败:", uploadError);
            failedFiles.push(i + 1);
            const errorMessage = uploadError.message ? uploadError.message.slice(0, 30) : '未知错误';
            this.$message.error("文件 " + (i + 1) + " 上传失败: " + errorMessage);
          }
        }
        if (this.txchange) {
          this.txchange = false
        } else if (this.tpchange) {
          this.tpchange = false
        } else if (this.zstpchange) {
          this.zstpchange = false
        }
        console.log(this.imgList);

        // 第二阶段：统一绑定
        if (successCodes.length > 0) {

          try {
            this.$message.info("开始绑定 " + successCodes.length + " 个素材...");
            const codeString = successCodes.join(',');

            // 执行批量绑定
            // await this.bindMaterial(codeString);

            this.$message.success("成功绑定 " + successCodes.length + " 个素材");
          } catch (bindError) {
            console.error('批量绑定失败:', bindError);
            const bindErrMsg = bindError.message ? bindError.message.slice(0, 50) : '请联系管理员';
            this.$message.error("素材上传成功但绑定失败: " + bindErrMsg);

          }
        }

        // 第三阶段：最终处理
        if (failedFiles.length > 0) {

          this.$message.warning("完成处理，成功 " + successCodes.length + " 个，失败 " + failedFiles.length + " 个");

        }

        this.refreshMaterialData();
        this.resetUploadState();
      } catch (error) {
        console.error('流程异常:', error);
        const errMsg = error.message ? error.message.slice(0, 50) : '未知错误';
        this.$message.error("操作中断: " + errMsg);
      } finally {
        this.uploading = false;
      }
    },
    getCurrentDate() {
      const date = new Date();
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0'); // 月份从0开始
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
    async allSettled(promises) {
      const results = await Promise.all(
        promises.map(p =>
          Promise.resolve(p)
            .then(value => ({ status: 'fulfilled', value }))
            .catch(reason => ({ status: 'rejected', reason }))
        )
      );

      // 只返回成功的结果数组，过滤失败的
      return results
        .filter(item => item.status === 'fulfilled' && item.value)
        .map(item => item.value);
    },
    bindVideoMaterial(codeString) {
      if (!this.activeFolder || !this.activeFolder.id || !this.selectedLibrary || !this.selectedLibrary.scId) return
      return this.$axios.post('https://control.zjwec.cn/api/sucaiku/bindFold', {
        cookie: this.zjcookie + ";b_marketing_subid=" + this.selectedLibrary.scId,
        imgCode: codeString,
        folderId: this.activeFolder.id,
        type: 2  // 注意这里类型改为2表示视频
      }, {
        timeout: 20000,  // 视频绑定超时延长到20秒
        validateStatus: function (status) {
          return status === 200;
        }
      });
    },
    imgReset() {
      this.imgList = []
    },
    closeDialog() {
      this.showVue2 = false;
    },
    async videohandleConfirmUpload() {
      this.uploadingCanceled = false
      console.log(this.spchange);
      if (this.videoList.length === 0) {
        this.$message.warning('请先选择要上传的视频文件');
        return;
      }

      try {
        // this.videouploading = true;
        // const successCodes = [];
        // const failedFiles = [];

        // // 第一阶段：上传所有视频
        // for (let i = 0; i < this.videoList.length; i++) {
        //   const video = this.videoList[i];
        //   try {
        //     this.$message.info("正在上传第 " + (i + 1) + "/" + this.videoList.length + " 个视频...");

        //     // 执行视频上传
        //     const fileCode = await this.uploadVideoFile(video);
        //     await this.bindVideoMaterial(fileCode);
        //     successCodes.push(fileCode);

        //     this.$message.success("视频 " + (i + 1) + " 上传成功");
        //   } catch (uploadError) {
        //     console.error("视频 " + (i + 1) + " 上传失败:", uploadError);
        //     failedFiles.push(i + 1);
        //     const errorMessage = uploadError.message ? uploadError.message.slice(0, 30) : '未知错误';
        //     this.$message.error("视频 " + (i + 1) + " 上传失败: " + errorMessage);
        //   }
        // }
        // if (this.spchange) {
        //   this.spchange = false
        // } else if (this.zsspchange) {
        //   this.zsspchange = false
        // }
        // let messageTimer;

        this.videouploading = true;
        this.isShow = true; // 开始上传时显示进度条
        const successCodes = [];
        const failedFiles = [];
        const batchSize = 10;
        const totalVideos = this.videoList.length;
        let completedVideos = 0;
        let notStartedVideos = totalVideos;

        const updateProgress = () => {
          const progress = (completedVideos / totalVideos) * 100;
          // 保留两位小数
          const formattedProgress = parseFloat(progress.toFixed(2));
          // 更新进度条的百分比
          this.uploadProgress = formattedProgress;
          showMessageWithDelay(`视频上传进度: ${formattedProgress}%`, 'info');
          showMessageWithDelay(`上传成功: ${successCodes.length} 条, 上传失败: ${failedFiles.length} 条, 未开始: ${notStartedVideos} 条`, 'info');
        };

        // 消息显示间隔时间（毫秒）
        const messageInterval = 1000;

        const showMessageWithDelay = (message, type) => {
          // if (messageTimer) {
          //   clearTimeout(messageTimer);
          // }
          let messageTimer = setTimeout(() => {
            switch (type) {
              case 'success':
                this.$message.success(message);
                break;
              case 'error':
                this.$message.error(message);
                break;
              default:
                this.$message.info(message);
            }
          }, 0);
          // if (messageTimer) {
          //   clearTimeout(messageTimer);
          // }

        };
        console.log(this.spchange);
        if (totalVideos <= batchSize) {
          const uploadPromises = this.videoList.map((video, index) => {
            if (this.uploadingCanceled) {
              this.$message.info('上传已中断，剩余任务已取消');
              return;
            }
            const videoIndex = index + 1;
            showMessageWithDelay(`正在上传第 ${videoIndex}/${totalVideos} 个视频...`, 'info');
            notStartedVideos--;

            return this.uploadVideoFile(video, index)
              .then(async (fileCode) => {
                await this.bindVideoMaterial(fileCode.code);
                successCodes.push(fileCode);
                showMessageWithDelay(`视频 ${videoIndex} 上传成功`, 'success');
                completedVideos++;
                updateProgress();
                return fileCode;
              })
              .catch((uploadError) => {
                console.error(`视频 ${videoIndex} 上传失败:`, uploadError);
                failedFiles.push(videoIndex);
                const errorMessage = uploadError.message ? uploadError.message.slice(0, 30) : '未知错误';
                showMessageWithDelay(`视频 ${videoIndex} 上传失败: ${errorMessage}`, 'error');
                completedVideos++;
                updateProgress();
                return null;
              });
          });
          console.log(this.spchange);

          let a = await this.allSettled(uploadPromises);
          console.log(this.spchange);
          console.log("sssssssssssscccccccccccccc");
          console.log(a);
          if (this.videoFMSwitch && this.videoList.length > 0) {
            a.forEach(item => {
              // if (this.uploadMultiple == 1) {
              //   if (this.spchange) {
              //     this.$set(this.VideofileList, this.VideofileList.length, { videocode: item.code, ...item });
              //     this.$set(this.videofileCode, this.videofileCode.length, { videocode: item.code });
              //   } else if (this.zsspchange) {
              //     this.$set(this.zsVideofileList, this.zsVideofileList.length, { videocode: item.code, ...item });
              //     this.$set(this.zsvideofileCode, this.zsvideofileCode.length, { videocode: item.code });
              //   }
              // }else{
              //   if (this.spchange) {
              //     this.$set(this.VideofileList, this.VideofileList.length, { videocode: item.code, ...item });
              //     this.$set(this.videofileCode, this.videofileCode.length, { videocode: item.code });
              //   } else if (this.zsspchange) {
              //     this.$set(this.zsVideofileList, this.zsVideofileList.length, { videocode: item.code, ...item });
              //     this.$set(this.zsvideofileCode, this.zsvideofileCode.length, { videocode: item.code });
              //   }
              // }
              if (this.uploadMultiple == 1) {
                if (this.spchange) {
                  this.$set(this.VideofileList, this.VideofileList.length, { videocode: item.code, ...item });
                  this.$set(this.videofileCode, this.videofileCode.length, { videocode: item.code });
                } else if (this.zsspchange) {
                  this.$set(this.zsVideofileList, this.zsVideofileList.length, { videocode: item.code, ...item });
                  this.$set(this.zsvideofileCode, this.zsvideofileCode.length, { videocode: item.code });
                }
              } else {
                for (let m = 0; m < this.uploadMultiple; m++) {
                  if (this.spchange) {
                    this.$set(this.VideofileList, this.VideofileList.length, { videocode: item.code, ...item });
                    this.$set(this.videofileCode, this.videofileCode.length, { videocode: item.code });
                  } else if (this.zsspchange) {
                    this.$set(this.zsVideofileList, this.zsVideofileList.length, { videocode: item.code, ...item });
                    this.$set(this.zsvideofileCode, this.zsvideofileCode.length, { videocode: item.code });
                  }
                }
              }

            });

          } else if (this.zsvideoFMSwitch && this.zsfileList.length > 0) {
            a.forEach(item => {
              // if (this.spchange) {
              //   this.$set(this.VideofileList, this.VideofileList.length, { videocode: item.code, ...item });
              //   this.$set(this.videofileCode, this.videofileCode.length, { videocode: item.code });
              // } else if (this.zsspchange) {
              //   this.$set(this.zsVideofileList, this.zsVideofileList.length, { videocode: item.code, ...item });
              //   this.$set(this.zsvideofileCode, this.zsvideofileCode.length, { videocode: item.code });
              // }
              if (this.uploadMultiple == 1) {
                if (this.spchange) {
                  this.$set(this.VideofileList, this.VideofileList.length, { videocode: item.code, ...item });
                  this.$set(this.videofileCode, this.videofileCode.length, { videocode: item.code });
                } else if (this.zsspchange) {
                  this.$set(this.zsVideofileList, this.zsVideofileList.length, { videocode: item.code, ...item });
                  this.$set(this.zsvideofileCode, this.zsvideofileCode.length, { videocode: item.code });
                }
              } else {
                for (let m = 0; m < this.uploadMultiple; m++) {
                  if (this.spchange) {
                    this.$set(this.VideofileList, this.VideofileList.length, { videocode: item.code, ...item });
                    this.$set(this.videofileCode, this.videofileCode.length, { videocode: item.code });
                  } else if (this.zsspchange) {
                    this.$set(this.zsVideofileList, this.zsVideofileList.length, { videocode: item.code, ...item });
                    this.$set(this.zsvideofileCode, this.zsvideofileCode.length, { videocode: item.code });
                  }
                }
              }
            });
          } else {
            console.log("else的this.zsvideoFMSwitch && this.zsfileList.length > 0");
            for (const [index, item] of a.entries()) {
              if (!item) continue;

              if (this.spchange) {
                if (this.fileCode.length < a.length) {
                  this.$message.info('封面数量少于视频数量');
                  return;
                }
                for (let m = 0; m < this.uploadMultiple; m++) {
                  this.$set(this.VideofileList, this.VideofileList.length, { videocode: item.code, ...item });
                  this.$set(this.videofileCode, this.videofileCode.length, {
                    videocode: item.code,
                    videocovercode: this.fileCode[index]
                  });
                }
              } else if (this.zsspchange) {
                if (this.zsfileCode.length < a.length) {
                  this.$message.info('撞审封面数量少于视频数量');
                  return;
                }
                for (let m = 0; m < this.uploadMultiple; m++) {
                  this.$set(this.zsVideofileList, this.zsVideofileList.length, { videocode: item.code, ...item });
                  this.$set(this.zsvideofileCode, this.zsvideofileCode.length, {
                    videocode: item.code,
                    videocovercode: this.zsfileCode[index]
                  });
                }
              }
            }
          }



          console.log(a);
        } else {
          for (let start = 0; start < totalVideos; start += batchSize) {
            if (this.uploadingCanceled) {
              this.$message.info('上传已中断，剩余任务已取消');
              return;
            }
            const end = Math.min(start + batchSize, totalVideos);
            const currentBatch = this.videoList.slice(start, end);

            const uploadPromises = currentBatch.map((video, index) => {
              const videoIndex = start + index + 1;
              showMessageWithDelay(`正在上传第 ${videoIndex}/${totalVideos} 个视频...`, 'info');
              notStartedVideos--;

              return this.uploadVideoFile(video)
                .then(async (fileCode) => {
                  await this.bindVideoMaterial(fileCode.code);
                  successCodes.push(fileCode);
                  showMessageWithDelay(`视频 ${videoIndex} 上传成功`, 'success');
                  completedVideos++;
                  updateProgress();
                  return fileCode;
                })
                .catch((uploadError) => {
                  console.error(`视频 ${videoIndex} 上传失败:`, uploadError);
                  failedFiles.push(videoIndex);
                  const errorMessage = uploadError.message ? uploadError.message.slice(0, 30) : '未知错误';
                  showMessageWithDelay(`视频 ${videoIndex} 上传失败: ${errorMessage}`, 'error');
                  completedVideos++;
                  updateProgress();
                  return null;
                });
            });

            let a = await this.allSettled(uploadPromises);
            console.log(this.spchange);
            console.log("sssssssssssscccccccccccccc");
            console.log(a);
            if (this.videoFMSwitch && this.videoList.length > 0) {
              a.forEach(item => {
                // if (this.spchange) {
                //   this.$set(this.VideofileList, this.VideofileList.length, { videocode: item.code, ...item });
                //   this.$set(this.videofileCode, this.videofileCode.length, { videocode: item.code });
                // } else if (this.zsspchange) {
                //   this.$set(this.zsVideofileList, this.zsVideofileList.length, { videocode: item.code, ...item });
                //   this.$set(this.zsvideofileCode, this.zsvideofileCode.length, { videocode: item.code });
                // }
                if (this.uploadMultiple == 1) {
                  if (this.spchange) {
                    this.$set(this.VideofileList, this.VideofileList.length, { videocode: item.code, ...item });
                    this.$set(this.videofileCode, this.videofileCode.length, { videocode: item.code });
                  } else if (this.zsspchange) {
                    this.$set(this.zsVideofileList, this.zsVideofileList.length, { videocode: item.code, ...item });
                    this.$set(this.zsvideofileCode, this.zsvideofileCode.length, { videocode: item.code });
                  }
                } else {
                  for (let m = 0; m < this.uploadMultiple; m++) {
                    if (this.spchange) {
                      this.$set(this.VideofileList, this.VideofileList.length, { videocode: item.code, ...item });
                      this.$set(this.videofileCode, this.videofileCode.length, { videocode: item.code });
                    } else if (this.zsspchange) {
                      this.$set(this.zsVideofileList, this.zsVideofileList.length, { videocode: item.code, ...item });
                      this.$set(this.zsvideofileCode, this.zsvideofileCode.length, { videocode: item.code });
                    }
                  }
                }
              });

            } else if (this.zsvideoFMSwitch && this.zsfileList.length > 0) {
              a.forEach(item => {
                // if (this.spchange) {
                //   this.$set(this.VideofileList, this.VideofileList.length, { videocode: item.code, ...item });
                //   this.$set(this.videofileCode, this.videofileCode.length, { videocode: item.code });
                // } else if (this.zsspchange) {
                //   this.$set(this.zsVideofileList, this.zsVideofileList.length, { videocode: item.code, ...item });
                //   this.$set(this.zsvideofileCode, this.zsvideofileCode.length, { videocode: item.code });
                // }
                if (this.uploadMultiple == 1) {
                  if (this.spchange) {
                    this.$set(this.VideofileList, this.VideofileList.length, { videocode: item.code, ...item });
                    this.$set(this.videofileCode, this.videofileCode.length, { videocode: item.code });
                  } else if (this.zsspchange) {
                    this.$set(this.zsVideofileList, this.zsVideofileList.length, { videocode: item.code, ...item });
                    this.$set(this.zsvideofileCode, this.zsvideofileCode.length, { videocode: item.code });
                  }
                } else {
                  for (let m = 0; m < this.uploadMultiple; m++) {
                    if (this.spchange) {
                      this.$set(this.VideofileList, this.VideofileList.length, { videocode: item.code, ...item });
                      this.$set(this.videofileCode, this.videofileCode.length, { videocode: item.code });
                    } else if (this.zsspchange) {
                      this.$set(this.zsVideofileList, this.zsVideofileList.length, { videocode: item.code, ...item });
                      this.$set(this.zsvideofileCode, this.zsvideofileCode.length, { videocode: item.code });
                    }
                  }
                }
              });
            } else {
              console.log("else的this.zsvideoFMSwitch && this.zsfileList.length > 0");
              for (const [index, item] of a.entries()) {
                if (!item) continue;

                // if (this.spchange) {
                //   if (this.fileCode.length < a.length) {
                //     this.$message.info('封面数量少于视频数量');
                //     return;
                //   }
                //   this.$set(this.VideofileList, this.VideofileList.length, { videocode: item.code, ...item });
                //   this.$set(this.videofileCode, this.videofileCode.length, {
                //     videocode: item.code,
                //     videocovercode: this.fileCode[index]
                //   });
                // } else if (this.zsspchange) {
                //   if (this.zsfileCode.length < a.length) {
                //     this.$message.info('撞审封面数量少于视频数量');
                //     return;
                //   }
                //   this.$set(this.zsVideofileList, this.zsVideofileList.length, { videocode: item.code, ...item });
                //   this.$set(this.zsvideofileCode, this.zsvideofileCode.length, {
                //     videocode: item.code,
                //     videocovercode: this.zsfileCode[index]
                //   });
                // }

                if (this.spchange) {
                  if (this.fileCode.length < a.length) {
                    this.$message.info('封面数量少于视频数量');
                    return;
                  }
                  for (let m = 0; m < this.uploadMultiple; m++) {
                    this.$set(this.VideofileList, this.VideofileList.length, { videocode: item.code, ...item });
                    this.$set(this.videofileCode, this.videofileCode.length, {
                      videocode: item.code,
                      videocovercode: this.fileCode[index]
                    });
                  }
                } else if (this.zsspchange) {
                  if (this.zsfileCode.length < a.length) {
                    this.$message.info('撞审封面数量少于视频数量');
                    return;
                  }
                  for (let m = 0; m < this.uploadMultiple; m++) {
                    this.$set(this.zsVideofileList, this.zsVideofileList.length, { videocode: item.code, ...item });
                    this.$set(this.zsvideofileCode, this.zsvideofileCode.length, {
                      videocode: item.code,
                      videocovercode: this.zsfileCode[index]
                    });
                  }
                }
              }
            }


          }
        }


        if (this.spchange) {
          console.log("先执行了");
          this.spchange = false
        } else if (this.zsspchange) {
          this.zsspchange = false
        }

        // await this.getVideoFM()


        // 第二阶段：统一绑定？
        if (successCodes.length > 0) {
          try {
            this.$message.info(`开始绑定 ${successCodes.length} 个视频素材...`);
            const codeString = successCodes.join(',');


            // await this.bindVideoMaterial(codeString);

            this.$message.success(`成功绑定 ${successCodes.length} 个视频素材`);
          } catch (bindError) {
            console.error('视频批量绑定失败:', bindError);
            const bindErrMsg = bindError.message.slice(0, 50) || '请联系管理员';
            this.$message.error(`视频上传成功但绑定失败: ${bindErrMsg}`);
          }
        }


        if (failedFiles.length > 0) {
          this.$message.warning(`视频处理完成，成功 ${successCodes.length} 个，失败 ${failedFiles.length} 个`);
        }

        await this.refreshVideoMaterialData();
        this.resetVideoUploadState();
      } catch (error) {
        console.error('视频流程异常:', error);
        const errMsg = error.message ? error.message.slice(0, 50) : '未知错误';
        this.$message.error("视频操作中断: " + errMsg);
      } finally {
        this.videouploading = false;
        // this.videouploading = false;
        // this.isShow = false; // 上传完成后隐藏进度条
        // this.isShow = false;
        // this.uploadProgress = 0;
        // 清除定时器

      }
    },
    //     async extractFrameFromVideoFile(videoItem, index) {
    //     console.log(videoItem);
    //     return new Promise((resolve, reject) => {
    //         const video = document.createElement('video');
    //         const canvas = document.createElement('canvas');
    //         const ctx = canvas.getContext('2d');

    //         // 获取视频文件
    //         const videoFile = videoItem.raw;

    //         if (!videoFile || !videoFile.type.startsWith('video/')) {
    //             reject(new Error('不是有效的视频文件'));
    //             return;
    //         }

    //         const videoURL = URL.createObjectURL(videoFile);
    //         video.src = videoURL;
    //         video.muted = true;
    //         video.playsInline = true;
    //         video.crossOrigin = 'anonymous';

    //         video.addEventListener('loadeddata', () => {
    //             canvas.width = video.videoWidth || 640;
    //             canvas.height = video.videoHeight || 360;
    //             video.currentTime = 0.1;
    //         });

    //         video.addEventListener('seeked', () => {
    //             try {
    //                 ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

    //                 // 递归函数来压缩图片直到小于150KB
    //                 const compressImage = (quality = 0.85, attempt = 1) => {
    //                     canvas.toBlob((blob) => {
    //                         if (!blob) {
    //                             reject(new Error('Canvas转换失败'));
    //                             return;
    //                         }

    //                         // 检查文件大小
    //                         const fileSizeKB = blob.size / 1024;
    //                         console.log(`图片大小: ${fileSizeKB.toFixed(2)}KB, 质量: ${quality}`);

    //                         if (fileSizeKB > 150 && quality > 0.3 && attempt < 5) {
    //                             // 如果大于150KB且还有压缩空间，继续压缩
    //                             const newQuality = Math.max(0.3, quality - 0.15);
    //                             compressImage(newQuality, attempt + 1);
    //                         } else if (fileSizeKB > 150) {
    //                             // 如果压缩到最低质量仍然大于150KB，调整图片尺寸
    //                             console.log('通过压缩无法达到150KB，调整图片尺寸');
    //                             resizeAndCompressImage();
    //                         } else {
    //                             // 图片大小符合要求
    //                             const frameFile = new File([blob], `封面_${videoFile.name.replace(/\.[^/.]+$/, "")}.jpg`, {
    //                                 type: 'image/jpeg',
    //                                 lastModified: Date.now()
    //                             });

    //                             URL.revokeObjectURL(videoURL);
    //                             resolve(frameFile);
    //                         }

    //                     }, 'image/jpeg', quality);
    //                 };

    //                 // 调整图片尺寸并压缩的函数
    //                 const resizeAndCompressImage = () => {
    //                     const maxWidth = 800; // 最大宽度
    //                     const maxHeight = 600; // 最大高度

    //                     let newWidth = canvas.width;
    //                     let newHeight = canvas.height;

    //                     // 等比例缩放
    //                     if (newWidth > maxWidth) {
    //                         newHeight = (newHeight * maxWidth) / newWidth;
    //                         newWidth = maxWidth;
    //                     }
    //                     if (newHeight > maxHeight) {
    //                         newWidth = (newWidth * maxHeight) / newHeight;
    //                         newHeight = maxHeight;
    //                     }

    //                     // 创建新的canvas进行缩放
    //                     const resizedCanvas = document.createElement('canvas');
    //                     const resizedCtx = resizedCanvas.getContext('2d');
    //                     resizedCanvas.width = newWidth;
    //                     resizedCanvas.height = newHeight;

    //                     // 使用高质量缩放
    //                     resizedCtx.imageSmoothingEnabled = true;
    //                     resizedCtx.imageSmoothingQuality = 'high';
    //                     resizedCtx.drawImage(canvas, 0, 0, newWidth, newHeight);

    //                     // 生成压缩后的blob
    //                     resizedCanvas.toBlob((blob) => {
    //                         if (!blob) {
    //                             reject(new Error('Canvas转换失败'));
    //                             return;
    //                         }

    //                         const frameFile = new File([blob], `封面_${videoFile.name.replace(/\.[^/.]+$/, "")}.jpg`, {
    //                             type: 'image/jpeg',
    //                             lastModified: Date.now()
    //                         });

    //                         URL.revokeObjectURL(videoURL);
    //                         resolve(frameFile);
    //                     }, 'image/jpeg', 0.7);
    //                 };

    //                 // 开始压缩过程
    //                 compressImage();

    //             } catch (error) {
    //                 URL.revokeObjectURL(videoURL);
    //                 reject(error);
    //             }
    //         });

    //         video.addEventListener('error', (e) => {
    //             URL.revokeObjectURL(videoURL);
    //             reject(new Error(`视频加载失败: ${e.message}`));
    //         });

    //         setTimeout(() => {
    //             URL.revokeObjectURL(videoURL);
    //             reject(new Error('视频帧提取超时'));
    //         }, 15000);
    //     });
    // },
    resetVideoUploadState() {
      this.videoList = [];
      this.videouploadDialogVisible = false;
      // clearTimeout(messageTimer);
    },
    // 获取素材列表
    fetchMaterials() {
      if (!this.activeFolder) return

      this.loading = true
      // 修改请求方式为GET
      this.$axios.get('https://control.zjwec.cn/api/sucaiku/selectFold', {
        params: {
          folderId: this.activeFolder.id,
          cookie: this.zjcookie + ";b_marketing_subid=" + this.selectedLibrary.scId,
          pageIndex: this.pageIndex,
          pageSize: this.pageSize
        }
      }).then(res => {
        // 适配新的响应结构
        // 降序排序（Z-A）
        this.materialList = res.data.data.list.slice().sort(function (a, b) {
          // 处理空值情况
          var titleA = a.title || '';
          var titleB = b.title || '';
          // 中文排序
          return titleB.localeCompare(titleA, 'zh-Hans-CN');
        });

        this.totalCount = res.data.data.total;
      }).finally(() => {
        this.loading = false
      })
    },
    // 刷新数据方法
    refreshMaterialData() {

      this.fetchMaterials()
      this.fetchMaterialsVideo()

    },

    // 重置状态方法
    resetUploadState() {
      this.imgList = [];
      this.uploadDialogVisible = false;
    },
    goBatchUpload() {
      const routeData = this.$router.resolve({ path: '/vivo/batchUpload' });
      window.open(routeData.href, '_blank');
    },
    fetchMaterialsVideo() {
      if (!this.activeFolder) return

      this.loading = true
      // 修改请求方式为GET
      this.$axios.get('https://control.zjwec.cn/api/sucaiku/selectFoldVideo', {
        params: {
          folderId: this.activeFolder.id,
          cookie: this.zjcookie + ";b_marketing_subid=" + this.selectedLibrary.scId,
          pageIndex: this.pageIndex,
          pageSize: this.pageSize
        }
      }).then(res => {
        // 适配新的响应结构
        // this.VmaterialList = res.data.data.list;
        this.VmaterialList = res.data.data.list.slice().sort(function (a, b) {
          // 处理空值情况
          const titleA = a.title || '';
          const titleB = b.title || '';
          // 中文排序
          return titleB.localeCompare(titleA, 'zh-Hans-CN');
        });
        this.videototalCount = res.data.data.total;
      }).finally(() => {
        this.loading = false
      })
    },
    handleUploadSuccess() {
      // console.log();
      this.uploadDialogVisible = false
      this.fetchMaterials()
      this.$message.success('上传成功')
    },

    videohandleUploadSuccess() {
      this.videouploadDialogVisible = false
      this.fetchMaterialsVideo()
      this.$message.success('上传成功')
    },
    handleFileChange(file, imgList) {
      console.log(this.formLabelAlign3.placeType[0]);
      console.log(this.formLabelAlign3.placeType[0] == 2);

      // 搜索提词版位：按平台素材规格校验格式/大小/尺寸（尺寸异步读图），不符则移除并提示，避免脏素材流入批量搭建
      if (this.isStoreSearchPlacement) {
        const spec = this.storeSearchCurrentSpec
        if (!spec) {
          // 未选模板（placeType 不足 3 段）与无图模板（0/2/6/15/16/18 不在规格表）分别提示
          const msg = this.formLabelAlign3.placeType.length < 3
            ? '请先在"展现形式"中选择搜索提词的具体模板类型'
            : '当前模板类型无需上传图片，已移除';
          this.$message.warning(msg);
          this.imgList = imgList.filter(f => f.uid !== file.uid);
          return;
        }
        if (file.raw) {
          const ext = (file.name.split('.').pop() || '').toLowerCase()
          if (!spec.formats.includes(ext)) {
            this.$message.warning(`文件 "${file.name}" 格式为 ${ext || '未知'}，需 ${spec.formats.join('/')}，已移除`);
            this.imgList = imgList.filter(f => f.uid !== file.uid);
            return;
          }
          if (file.raw.size > spec.maxSize) {
            this.$message.warning(`文件 "${file.name}" 超过了 ${Math.ceil(spec.maxSize / 1024)}KB 大小限制，已移除`);
            this.imgList = imgList.filter(f => f.uid !== file.uid);
            return;
          }
          // 格式/大小通过：先同步进待上传列表（尺寸校验异步完成，不符再按 uid 移除）
          this.imgList = imgList.filter(f => f.status !== 'removed');
          // 尺寸校验异步：读图完成后不符再移除（gif 动态icon 同样可读宽高）
          this.checkImageSize(file, spec)
          return;
        }
        this.imgList = imgList.filter(f => f.status !== 'removed');
        return;
      }

      // 动态设置最大文件大小：当 placeType[0] 等于 2 时为 300KB，否则为 100KB
      const MAX_SIZE = this.formLabelAlign3.placeType[0] == 2 ? 300 * 1024 : 100 * 1024;

      // 如果当前上传的文件超过限制
      if (file.raw && file.raw.size > MAX_SIZE && this.formLabelAlign3.placeType[0] != 6) {
        console.log(this.formLabelAlign3.placeType);
        this.$message.warning(`文件 "${file.name}" 超过了 ${MAX_SIZE / 1024}KB 大小限制`);

        // 手动从 imgList 中移除该文件
        this.imgList = imgList.filter(f => f.uid !== file.uid);
        return;
      }
      console.log(file);
      console.log(imgList);
      this.imgList = imgList.filter(f => f.status !== 'removed');
    },
    // 本地图片尺寸校验（平台素材规格，2026-08-26）：读图宽高与规格不符则从待上传列表移除
    checkImageSize(file, spec) {
      const reader = new FileReader()
      reader.onload = (e) => {
        const image = new Image()
        image.onload = () => {
          if (image.width !== spec.width || image.height !== spec.height) {
            this.$message.warning(`文件 "${file.name}" 尺寸为 ${image.width}*${image.height}px，需 ${spec.width}*${spec.height}px，已移除`);
            // 从当前列表按 uid 移除，避免多文件并发校验时用旧快照覆盖已通过的文件
            this.imgList = this.imgList.filter(f => f.uid !== file.uid);
          }
        }
        image.src = e.target.result
      }
      reader.readAsDataURL(file.raw)
    },
    // 显示素材库选择对话框
    showLibrarySelector() {
      this.$axios.get('https://control.zjwec.cn/api/sucaiku/getAll').then(res => {
        this.libraryOptions = res.data
        this.libraryDialogVisible = true
      })
    },
    getImageUrl(item) {
      console.log(item);
      console.log(item.previewUrl == undefined);

      if (item.previewUrl != undefined) {
        console.log("11");
        var base = 'https://ads-marketing-vivofs.vivo.com.cn/'
        console.log(base + (item.previewUrl || '').replace(/^\//, ''));
        return base + (item.previewUrl || '').replace(/^\//, '')
      } else {
        console.log("12");
        var base = 'https://ads-marketing-vivofs.vivo.com.cn/'
        console.log(base + (item || '').replace(/^\//, ''));
        return base + (item || '').replace(/^\//, '')
      }

    },
    getImageUrl2(item) {
      var base = 'https://ads-marketing-vivofs.vivo.com.cn/'
      return base + (item.filePath || '').replace(/^\//, '')
    },
    handleInput() {
      // 根据 mediaType 判断每行最大字符数
      this.maxLength = this.formLabelAlign.mediaType === '1' ? 26 : 15;

      // 将文本域的内容按行分割并过滤掉空行
      this.formLabelAlign3.title = this.titlesString.split('\n').filter(line => line.trim());
      console.log(this.formLabelAlign3.title);

      // 检查每一行是否超过字符限制，并保存超出限制的行
      this.linesWithLimitError = this.formLabelAlign3.title
        .map((line, index) => ({
          line: line,
          index: index + 1,
          length: line.length,
        }))
        .filter(item => item.length > this.maxLength) // 过滤掉没有超出限制的行
        .map(item => item.line); // 仅返回超出限制的行文本


      // 如果存在超出字符数的行，更新提示信息
    },
    zshandleInput() {
      // 根据 mediaType 判断每行最大字符数
      this.maxLength = this.formLabelAlign.mediaType === '1' ? 26 : 15;

      // 将文本域的内容按行分割并过滤掉空行
      this.zstitleList = this.zstitlesString.split('\n').filter(line => line.trim());
      console.log(this.zstitleList);

      // 检查每一行是否超过字符限制，并保存超出限制的行
      this.zslinesWithLimitError = this.zstitleList
        .map((line, index) => ({
          line: line,
          index: index + 1,
          length: line.length,
        }))
        .filter(item => item.length > this.maxLength) // 过滤掉没有超出限制的行
        .map(item => item.line); // 仅返回超出限制的行文本


      // 如果存在超出字符数的行，更新提示信息
    },
    timeToIndex(time) {
      if (time === '24:00') return 48
      const [h, m] = time.split(':').map(Number)
      return h * 2 + (m === 30 ? 1 : 0)
    },

    indexToTime(index) {
      if (index === 48) return '24:00'
      const hours = Math.floor(index / 2)
      const mins = index % 2 === 0 ? '00' : '30'
      return `${String(hours).padStart(2, '0')}:${mins}`
    },

    startOptions(index) {
      const minTime = index === 0
        ? '00:00'
        : this.timeRanges[index - 1].end
      const maxTime = index < this.timeRanges.length - 1
        ? this.timeRanges[index + 1].start
        : '24:00'

      const times = []
      let startIndex = this.timeToIndex(minTime)
      const endIndex = this.timeToIndex(maxTime)

      while (startIndex <= endIndex) {
        times.push(this.indexToTime(startIndex))
        startIndex++
      }

      return {
        start: '00:00',
        end: '24:00',
        step: '00:30',
        selectableRange: times.join(' - ')
      }
    },

    endOptions(index) {
      const startIndex = this.timeToIndex(this.timeRanges[index].start)
      const times = []

      for (let i = startIndex; i <= 48; i++) {
        times.push(this.indexToTime(i))
      }

      return {
        start: '00:00',
        end: '24:00',
        step: '00:30',
        selectableRange: times.join(' - ')
      }
    },

    addRange() {
      const last = this.timeRanges[this.timeRanges.length - 1]
      this.timeRanges.push({
        start: last.end,
        end: '24:00'
      })
    },

    removeRange(index) {
      if (this.timeRanges.length <= 1) return
      this.timeRanges.splice(index, 1)
    },

    handleStartChange(index) {
      const current = this.timeRanges[index]
      // 确保结束时间 >= 开始时间
      if (this.timeToIndex(current.start) > this.timeToIndex(current.end)) {
        this.$set(current, 'end', current.start)
      }
      // 更新后续时间段的开始时间
      if (index < this.timeRanges.length - 1) {
        const next = this.timeRanges[index + 1]
        this.$set(next, 'start', current.end)
        // 检查后续时间段是否有效
        if (this.timeToIndex(next.end) < this.timeToIndex(next.start)) {
          this.$set(next, 'end', next.start)
          this.handleEndChange(index + 1)
        }
      }
    },

    handleEndChange(index) {
      const current = this.timeRanges[index]
      // 更新后续时间段的开始时间
      if (index < this.timeRanges.length - 1) {
        const next = this.timeRanges[index + 1]
        this.$set(next, 'start', current.end)
        // 检查后续时间段是否有效
        if (this.timeToIndex(next.end) < this.timeToIndex(next.start)) {
          this.$set(next, 'end', next.start)
          this.handleEndChange(index + 1)
        }
      }
      // 确保开始时间 <= 结束时间
      if (this.timeToIndex(current.start) > this.timeToIndex(current.end)) {
        this.$set(current, 'start', current.end)
      }
    },

    sckhb() {
      const params = new URLSearchParams();
      // let idsString = this.idsList.map(item => item.ids).join(',');
      let idsString = [...new Set(this.idsList.map(item => item.ids))].join(',');

      console.log(this.selectedLibrary)
      let cookieid = this.zjcookie + ';b_marketing_subid='
        + this.selectedLibrary.scId

      params.append('targetUserIds', idsString);
      params.append('cookie', cookieid)
      // 使用 axios 发送 GET 请求，将参数以查询字符串的形式附加到 URL 上
      axios.get('https://control.zjwec.cn/api/kaihu/sendShareRequest', {
        params: params,
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      })
        .then(res => {
          console.log(res.data); // 处理返回的数据
        })
        .catch(error => {
          console.error('Error:', error); // 处理错误
        });
    },

    clearShangPing() {
      this.categoryName = ''
      this.beSelectCategory = null
      this.categoryList = []

    },
    async GetPlanId(id, token, key, maxRetries = 3) {
      this.isShow2 = true;
      let lastId = 0;
      let finalLastId = null;
      let retryCount = 0;

      while (retryCount < maxRetries) {
        try {
          const timestamp = Date.now().toString();
          const nonce = Math.round(Math.random() * 1e11);

          const res = await axios.post(
            `api/openapi/v1/ad/campaign/pageInfoByLastId?access_token=${token}&timestamp=${timestamp}&nonce=${nonce}&advertiser_id=${id}`,
            {
              lastId: lastId,
              deleted: 0,
              pageSize: 100
            }
          );

          const list = res.data.data.data;
          // console.log('原始list:', JSON.stringify(list));
          // console.log('目标mediaType原始值:', this.formLabelAlign.mediaType, '类型:', typeof this.formLabelAlign.mediaType);

          if (Array.isArray(list) && list.length > 0) {
            const targetMediaType = Number(this.formLabelAlign.mediaType);
            console.log('转换后targetMediaType:', targetMediaType);
            if (!isNaN(targetMediaType)) {
              const matched = list.filter(item => {
                console.log('遍历项 mediaType:', item.mediaType, '类型:', typeof item.mediaType);
                return Number(item.mediaType) === targetMediaType;
              });
              console.log('matched数组:', JSON.stringify(matched));
              if (matched.length > 0) {
                finalLastId = matched[matched.length - 1].id;
                console.log('找到的 finalLastId:', finalLastId);
              } else {
                console.log('没有匹配的项');
              }
            } else {
              console.log('targetMediaType 不是有效数字');
            }
          } else {
            console.log('list 为空或不是数组');
          }

          break;

        } catch (error) {
          retryCount++;
          console.log(`第${retryCount}次请求失败，${retryCount < maxRetries ? '正在重试...' : '已达到最大重试次数'}`);
          if (retryCount >= maxRetries) {
            console.error('请求失败，已达到最大重试次数');
            throw error;
          }
          await new Promise(resolve => setTimeout(resolve, 1000 * retryCount));
        }
      }

      // console.log('赋值前 finalLastId:', finalLastId);
      // console.log('this.idsList[key]:', this.idsList[key]);
      this.ePlanId = finalLastId || '';
      if (this.idsList[key].campaignId) {
        this.ePlanId = this.idsList[key].campaignId;
      }
      console.log("得到的最新计划id是：" + this.ePlanId);
    },
    async getimgvivolist() {
      console.log(99999);
      // this.$axios.get('https://control.zjwec.cn/api/sucaiku/selectFold', {
      //   params: {
      //     // folderId: this.activeFolder.id,
      //     cookie: this.zjcookie + ";b_marketing_subid=" + this.selectedLibrary.scId,
      //     // pageIndex: this.pageIndex,
      //     // pageSize: this.pageSize,
      //     SearchKey: this.ImgSCName
      //   })
      let res = await axios.get('https://control.zjwec.cn/api/sucaiku/selectFold', {
        params: {
          SearchKey: '162353435',
          cookie: this.zjcookie + ";b_marketing_subid=" + this.selectedLibrary.scId,
          pageIndex: this.pageIndex,
          pageSize: this.pageSize
        }
      })
      console.log(res);
    },
    async getoptionGroup(id, token) {
      let currentLastId = 0;
      const timestamp = Date.now().toString();
      const nonce = Math.floor(Math.random() * 100000000000);
      const response = await axios.post(
        `api/openapi/v1/ad/group/pageInfoByLastId?access_token=${token}&timestamp=${timestamp}&nonce=${nonce}&advertiser_id=${id}`,
        {
          lastId: currentLastId,
          deleted: 0,
          pageSize: 100
        }
      );
      console.log("这里打印的是选择的广告组信息");
      console.log(response);
    },

    async GetGroupPrice(id, token) {
      let allData = []; // 存储所有 data 数据
      let currentLastId = 0; // 初始 lastId
      let lastValidLastId = null; // 记录最后一次有效的 lastId

      while (currentLastId !== undefined && currentLastId !== null) {
        const timestamp = Date.now().toString();
        const nonce = Math.floor(Math.random() * 100000000000);

        try {
          const response = await axios.post(
            `api/openapi/v1/ad/group/pageInfoByLastId?access_token=${token}&timestamp=${timestamp}&nonce=${nonce}&advertiser_id=${id}`,
            {
              lastId: currentLastId,
              deleted: 0,
              pageSize: 100
            }
          );

          const responseData = response.data && response.data.data; // 兼容 ES5 的写法
          if (responseData) {
            // 拼接数据
            if (Array.isArray(responseData.data)) {
              allData = allData.concat(responseData.data);
            }

            // 更新 lastId
            if (responseData.lastId !== undefined && responseData.lastId !== null) {
              lastValidLastId = responseData.lastId;
              currentLastId = responseData.lastId;
            } else {
              currentLastId = null; // 终止循环
            }
          } else {
            currentLastId = null; // 数据异常终止
          }
        } catch (error) {
          console.error("请求失败:", error);
          break;
        }
      }

      console.log("最后获取到的 lastId:", lastValidLastId);

      // 查找目标对象
      const targetObject = allData.find(item => item.id === lastValidLastId);
      console.log("匹配对象:", targetObject);

      // 安全处理 undefined 和属性访问
      if (targetObject && typeof targetObject.ocpxPrice !== 'undefined') {
        this.oldGroupPrice = targetObject.ocpxPrice;
        this.oldGroupscheduleTime = targetObject.scheduleTime
      } else {
        // 备选方案：可以设置默认值/保持原值/抛出警告
        console.warn('未找到匹配对象或 ocpxPrice 不存在');
        this.oldGroupPrice = new Decimal(this.formLabelAlign1.ocpxPrice).mul(100000).toNumber(); // 或保留原值：delete this.oldGroupPrice;
      }

    },

    handleCategoryChange() {
      // 根据选中的分类名称查找完整的对象
      this.selectedCategory = this.categories.find(category => category.categoryName === this.selectedCategoryName);
    },
    // handlesucaiku() {
    //   // 根据选中的分类名称查找完整的对象
    //   this.selectedsucaiku = this.sucaikus.find(sucaiku => sucaiku.uname === this.sucainame);
    //
    // },
    handleQuery() {
      if (this.selectedCategoryName) {
        // 发起请求，传入选中的分类名称
        this.queryCategoryData();
      } else {
        this.$message.warning('请选择一个分类');
      }
    },
    // 监听选择框值变化的方法
    CategorySelectHandle(value) {
      console.log('选中的商品对象:', value);
      // 在此执行任何额外的操作，比如发送请求、处理逻辑等
      // this.$message.info(`你选择了: ${newValue.name}`);
      this.beSelectCategory = this.categoryList.find(item => item.id === value);
      console.log('选中的商品对象是' + JSON.stringify(this.beSelectCategory))
    },
    queryCategoryData() {
      // 发送请求，传入商品库ID
      const timestamp = parseInt(new Date().getTime()) + '';
      const nonce = Math.round(Math.random() * 100000000000);

      console.log(this.selectedCategory)
      this.$axios.post(`api/openapi/v1/ad/product/info/page?access_token=${this.selectedCategory.categoryUtoken}&timestamp=${timestamp}&nonce=${nonce}&advertiser_id=${this.selectedCategory.categoryUid}`, {
        productLibraryId: this.selectedCategory.categoryId,
        pageSize: 1000
      })
        .then(response => {
          this.categoryList = response.data.data.list

          console.log('查询结果:', response.data.data.list);
          // 这里可以处理请求成功后的逻辑
          this.$message.success('查询成功');
        })
        .catch(error => {
          console.error('请求失败:', error);
          this.$message.error('查询失败');
        });
    },
    // 添加新的输入框
    addProduct() {
      this.formLabelAlign3.productNames.push('');
    },
    // 删除指定索引的输入框
    removeProduct(index) {
      if (this.formLabelAlign3.productNames.length > 1) {
        this.formLabelAlign3.productNames.splice(index, 1);
      }
    },
    diYuHandleSelectionChange() {
      this.beSelectMap = this.mapArray.find(item => item.name === this.beSelectDiYu);

      console.log("选中的定向是：" + JSON.stringify(this.beSelectMap))
    },
    shuffle(arr) {
      var l = arr.length
      var index, temp
      while (l > 0) {
        index = Math.floor(Math.random() * l)
        temp = arr[l - 1]
        arr[l - 1] = arr[index]
        arr[index] = temp
        l--
      }
      return arr
    },

    // 获取资质id
    // 发送请求获取数据
    async GetZZData(uid, token) {
      const timestamp = parseInt(new Date().getTime()) + '';
      const nonce = Math.round(Math.random() * 100000000000);

      const url = `api/openapi/v1/advertise/qualification/list?access_token=${token}&timestamp=${timestamp}&nonce=${nonce}&advertiser_id=${uid}`;
      const response = await axios.post(url, {});

      if (response.data.code === 0 && response.data.data) {

        console.log("账户" + uid + "取到的所有行业是" + response.data.data)
        this.zzIdList = response.data.data
      }
      return [];
    },
    async GetZZData2(uid, token) {
      const timestamp = parseInt(new Date().getTime()) + '';
      const nonce = Math.round(Math.random() * 100000000000);

      const url = `api/openapi/v1/advertise/qualification/list?access_token=${token}&timestamp=${timestamp}&nonce=${nonce}&advertiser_id=${uid}`;
      const response = await axios.post(url, {});

      if (response.data.code === 0 && response.data.data) {
        console.log("账户" + uid + "取到的所有行业是", response.data.data);
        console.log("需要匹配的行业ID:", this.erjihangye);

        // ========== 筛选：industry1 和 industry2 都要匹配 ==========
        const targetIndustry1 = String(this.erjihangye[0]);  // "2100024"
        const targetIndustry2 = String(this.erjihangye[1]);  // "2220196"

        const targetIndustry = response.data.data.find(item => {
          return String(item.industry1) === targetIndustry1
            && String(item.industry2) === targetIndustry2;
        });

        if (!targetIndustry) {
          console.warn(`未找到匹配的行业: industry1=${targetIndustry1}, industry2=${targetIndustry2}`);
          return [];
        }

        console.log("匹配到的行业数据:", targetIndustry);
        console.log("该行业下的资质列表:", targetIndustry.advertiseQualificationList);

        return targetIndustry.advertiseQualificationList || [];
      }
      return [];
    },
    clearfile() {

      this.fileList = []
      this.VideofileList = []
    },
    zsclearfile() {

      this.zsfileList = []
      this.zsVideofileList = []
    },
    // frameSave 带重试封装：供线上素材库视频选择复用，失败（retcode==-1 或网络异常）返回 null
    async getFrameSaveWithRetry(videoCode, extraParams = {}) {
      const cookie = this.zjcookie + ";b_marketing_subid=" + this.selectedLibrary.scId;
      const params = Object.assign({ videoCode, cookie }, extraParams);
      const maxRetries = 3; // 每个请求最多重试3次
      const retryDelay = 500; // 每次重试间隔毫秒
      for (let attempt = 1; attempt <= maxRetries; attempt++) {
        try {
          const res = await axios.get(`https://control.zjwec.cn/api/vivo/frameSave`, { params });
          if (res.data.retcode == -1) {
            return null;
          }
          return res;
        } catch (error) {
          if (attempt == maxRetries) {
            return null;
          }
          await new Promise(resolve => setTimeout(resolve, retryDelay));
        }
      }
      return null;
    },
    async getVideoFM() {
      // 公共请求函数封装
      const fetchCodes = async (switchFlag, fileList, cookieName, codeField) => {
        console.log(fileList);
        if (!switchFlag) return false;
        if (fileList.length === 0) {
          // this.$message.info(`请选择${cookieName}素材`);
          return false;
        }

        const cookie = this.zjcookie + ";b_marketing_subid=" + this.selectedLibrary.scId;
        const codes = fileList.map(file => file.code);
        const maxRetries = 3; // 每个请求最多重试3次
        const retryDelay = 500; // 每次重试间隔毫秒

        // 封装一个带重试的请求函数
        const fetchWithRetry = async (videoCode, retries = maxRetries) => {
          for (let attempt = 1; attempt <= retries; attempt++) {
            try {
              const res = await axios.get(`https://control.zjwec.cn/api/vivo/frameSave`, {
                params: { videoCode, cookie }
              });

              console.log(`[${videoCode}] 第${attempt}次请求成功:`, res);

              // 检查 retcode
              if (res.data.retcode == -1) {
                this.videoframeSaveErrorlist = [...this.videoframeSaveErrorlist, videoCode];
                return null
              }

              return res; // 成功返回结果
            } catch (error) {
              console.error(` [${videoCode}] 第${attempt}次请求失败:`, error);

              // 如果是最后一次仍失败
              if (attempt == retries) {
                console.error(` [${videoCode}] 重试${retries}次仍失败`);
                this.videoframeSaveErrorlist = [...this.videoframeSaveErrorlist, videoCode];
                return null; // 返回null标记失败
              }

              // 等待一段时间再重试
              await new Promise(resolve => setTimeout(resolve, retryDelay));
            }
          }
        };

        try {
          // 生成并发请求
          const requests = codes.map(videoCode => fetchWithRetry(videoCode));

          // 等待所有请求完成
          const results = await Promise.all(requests);
          console.log("全部请求结果:", results);

          // 找出失败的索引
          const failedIndexes = [];
          results.forEach((res, index) => {
            if (res == null) {
              failedIndexes.push(index);
            }
          });

          // 如果有失败的请求，删除对应索引的元素
          if (failedIndexes.length > 0) {
            console.log("失败的索引:", failedIndexes);

            // 从 fileList 中删除对应索引的元素（从后往前删除，避免索引变化）
            failedIndexes.sort((a, b) => b - a).forEach(failedIndex => {
              if (fileList && fileList.length > failedIndex) {
                fileList.splice(failedIndex, 1);
                console.log(`删除 fileList 第 ${failedIndex} 个元素`);
              }
            });

            this.$message.warning(`有 ${failedIndexes.length} 个请求失败，已删除对应素材`);
          }

          // 过滤掉失败的请求，只保留成功的
          const validResults = results.filter(res => res != null);
          console.log("有效的请求结果:", validResults);

          // 遍历 fileList 数组，为每个 item 设置 videocovercode
          fileList.forEach((item, index) => {
            if (validResults[index]) {
              item.videocovercode = validResults[index].data.data.code;
              console.log(`设置 fileList[${index}] 的 videocovercode:`, item.videocovercode);
            }
          });

          this[codeField] = fileList
          console.log("处理后的 fileList:", fileList);
          console.log("提取的 videocovercode 数组:", this[codeField]);
          return
        } catch (error) {
          console.error("全局请求错误：", error);
          this.$message.error("请求发生错误");
        }
      };


      // 处理普通视频
      await fetchCodes(
        this.videoFMSwitch,
        this.VideofileList,
        "普通视频",
        "videofileCode"
      );

      // 处理撞审视频
      await fetchCodes(
        this.zsvideoFMSwitch,
        this.zsVideofileList,
        "撞审视频",
        "zsvideofileCode"
      );
    },
    async handleGetPlan() {
      // 加桌转化依赖内置快应用承接：缺这个字段广告组能建出来，但投放跑不了
      // 只有网址分支(ht)会把 builtInRpkDeepLink 带进广告组；快应用(ha)走 rpkDeepLink、应用推广分支不传，不参与校验
      // 使用已存在广告组时不新建组，转化目标不落到组上，同样不校验
      if (String(this.formLabelAlign1.cvType) === '7' && !this.newgroupflag) {
        const missing = this.idsList.filter(item =>
          (item.url || '').substr(0, 2) === 'ht' && !String(item.builtInRpkDeepLink || '').trim()
        )
        if (missing.length) {
          const names = [...new Set(missing.map(item => item.idsname))]
          const h = this.$createElement
          this.$alert(
            h('div', names.map(name => h('div', { style: 'margin-bottom: 4px;' }, name))),
            `${names.length} 个账户未配置内置快应用，搭建后无法起量`,
            { type: 'error', confirmButtonText: '知道了' }
          )
          this.countdialogVisible = false
          return
        }
      }

      const now = Date.now();
      const cooldownTime = 5000; // 5秒冷却时间

      // 检查是否在冷却时间内
      if (now - this.lastGetPlanTime < cooldownTime) {
        const remainingTime = Math.ceil((cooldownTime - (now - this.lastGetPlanTime)) / 1000);
        this.$message.warning(`请等待 ${remainingTime} 秒后再试`);
        return;
      }

      // 如果正在请求中，也直接返回
      if (this.isLoading) {
        this.$message.warning('请求正在进行中，请稍候');
        return;
      }

      this.isLoading = true;
      this.lastGetPlanTime = now;
      this.startCountdown();

      try {
        await this.GetPlan();
        this.$message.success('操作成功');
      } catch (error) {
        console.error('操作失败:', error);
        this.$message.error('操作失败');
      } finally {
        // this.isLoading = false;
      }
    },
    startCountdown() {
      this.countdown = 5;

      // 清除之前的定时器
      if (this.countdownTimer) {
        clearInterval(this.countdownTimer);
      }

      this.countdownTimer = setInterval(() => {
        this.countdown--;

        if (this.countdown <= 0) {
          clearInterval(this.countdownTimer);
          this.isLoading = false
        }
      }, 1000);
    },



    // 组件销毁时清除定时器

    async GetPlan() {
      this.errorMaterialsList = [];
      // if (this.isLoading) return;
      if (this.selectedRegion === '') {
        this.$message.warning('请先选择地域');
        return
      }
      if (!this.selectedLibrary) {
        this.$message.warning('请先选择素材库');
        return
      }
      // this.isLoading = true;
      this.errorfile = []
      let zstitleslist = this.zstitlesString.split('\n').filter(line => line.trim())
      let titleslists = this.titlesString.split('\n').filter(line => line.trim())

      const requests = titleslists.map(item =>
        // axios.get(`/api/data/${item.id}`).catch(error => {
        //   console.error(`请求失败 ${item.id}:`, error);
        //   return null; // 失败时返回 null（可选）
        // }),
        axios.post('https://control.zjwec.cn/api/vivo/TitleSave', {
          cookie: this.zjcookie + ";b_marketing_subid=" + this.selectedLibrary.scId,
          userId: this.selectedLibrary.scId,
          title: item
        }).catch(res => {
          console.log(res);
        })
      );
      const requests2 = zstitleslist.map(item2 =>

        axios.post('https://control.zjwec.cn/api/vivo/TitleSave', {
          cookie: this.zjcookie + ";b_marketing_subid=" + this.selectedLibrary.scId,
          userId: this.selectedLibrary.scId,
          title: item2
        }).catch(res => {
          console.log(res);
        })
      );


      try {
        const responses = await Promise.all(requests, requests2);
        const validResults = responses.filter(res => res !== null); // 过滤失败的请求
        console.log("所有请求完成:", validResults);
        // return validResults;
      } catch (error) {
        console.error("全局捕获错误:", error);
      }


      this.countdialogVisible = false
      this.sckhb()
      this.videoframeSaveErrorlist = []

      // 判断是否自动取封面
      if (this.videoFMSwitch) {
        await this.getVideoFM()
      } else if (this.zsvideoFMSwitch) {
        await this.getVideoFM()
      }


      if (this.videoframeSaveErrorlist.length > 0) {
        try {
          // 使用 await 等待用户选择
          const confirmResult = await this.$confirm(
            `封面上传失败数量：${this.videoframeSaveErrorlist.length}，是否继续搭建？`,
            '提示',
            {
              confirmButtonText: '是',
              cancelButtonText: '否',
              type: 'warning'
            }
          )

          // 用户点击了"是"，返回 true
          if (confirmResult != 'confirm') {
            console.log('用户不选择继续')
            return
          }
        } catch (error) {
          return
        }
      }



      // 直接遍历options4匹配data[0]
      let matchedItem = null;

      this.options4.map(option => {
        if (option.value == this.formLabelAlign3.placeType[0]) {
          console.log("等于了");
          const found = option.children.find(child => child.value == this.formLabelAlign3.placeType[1]);
          if (found) {
            matchedItem = found.label
          }
        }
      });

      // 打印匹配到的完整信息
      console.log('匹配到的完整信息:', matchedItem);
      console.log(this.fileList);

      // 如果不为空，进行正则匹配
      if (matchedItem) {
        // 美工名称列表
        const artistNames = ['朱秉善', '郑棋航', '卓丽聪', '王靓', '范洪时', '高恒'];

        // 判断是否包含"图"或"视频"
        if (matchedItem.includes('图')) {
          // 图片类型，取this.fileList第一个对象
          if (this.fileList && this.fileList.length > 0) {
            console.log('图片列表:', this.fileList);
            // 本地上传的 item 用 name，线上素材库的 item 用 title，需兜底避免 undefined 崩溃
            const fileName = this.fileList[0].name || this.fileList[0].title || '';
            console.log('图片文件名:', fileName);

            // 在文件名中查找是否包含美工名称
            let foundArtist = '';
            artistNames.forEach(name => {
              if (fileName.includes(name)) {
                foundArtist = name;
              }
            });

            if (foundArtist) {
              console.log('图片美工名称:', foundArtist);
              this.artistName = foundArtist;
            } else {
              console.log('图片文件名中未找到匹配的美工名称');
              this.artistName = '';
            }
          } else {
            console.log('图片列表为空');
            this.artistName = '';
          }
        } else if (matchedItem.includes('视频')) {
          // 视频类型，取this.VideofileList第一个对象
          if (this.VideofileList && this.VideofileList.length > 0) {
            const fileName = this.VideofileList[0].title || this.VideofileList[0].name || '';
            console.log('视频文件名:', fileName);

            // 在文件名中查找是否包含美工名称
            let foundArtist = '';
            artistNames.forEach(name => {
              if (fileName.includes(name)) {
                foundArtist = name;
              }
            });

            if (foundArtist) {
              console.log('视频美工名称:', foundArtist);
              this.artistName = foundArtist;
            } else {
              console.log('视频文件名中未找到匹配的美工名称');
              this.artistName = '';
            }
          } else {
            console.log('视频列表为空');
            this.artistName = '';
          }
        } else {
          console.log('匹配到的类型既不是图也不是视频');
          this.artistName = '';
        }
      } else {
        console.log('未匹配到任何信息');
        this.artistName = '';
      }


      // return


      if (!this.customListpc && this.customListpc !== 0) {
        this.flag2 = false;
      } else {
        // 不管你传进来的是数字还是字符串，都先转成字符串
        const str = String(this.customListpc);
        this.customListrqbpc = str
          .split(',')
          .filter(t => t.trim() !== '')
          .map(t => parseInt(t, 10));
        console.log(this.customListrqbpc);
        this.flag2 = true;
      }

      if (this.customList2 === '' || this.customList2 == null) {
        this.flag1 = false
      } else {
        this.customListrqb = []
        // 转成字符串，按逗号分割（单个值也能正常处理）
        const temp = String(this.customList2).split(',')

        for (let i = 0; i < temp.length; i++) {
          const val = temp[i].trim()  // 去空格
          if (val !== '') {
            this.customListrqb.push(parseInt(val))
          }
        }

        console.log(this.customListrqb)
        this.flag1 = true
      }
      this.sexList = [];

      const sexValue = this.isPreset ? this.presetValue.sex : this.sex;
      if (sexValue === '女') {
        this.sexList[0] = 20;
      } else if (sexValue === '男') {
        this.sexList[0] = 19;
      }


      this.ageIdList = []
      this.failedRequests = []
      for (let key in this.age) {
        this.ageIdList[key] = this.ages[this.age[key]].id
      }
      console.log(this.ageIdList)
      this.timeeditlist = []
      this.successhisstory_list = []
      if (this.formLabelAlign3.placeType[1] === '61' || this.formLabelAlign3.placeType[1] === '122' || this.formLabelAlign3.placeType[1] === '142') {
        let t = 0;
        this.isShow2 = true;
        this.totalTasks = this.idsList.length;
        let titlelists = this.formLabelAlign3.title
        for (let key in this.idsList) {
          // if (this.daluan == true) {
          //   titlelists = this.shuffle(this.formLabelAlign3.title)
          // }
          let parms = {
            name: this.idsList[key].planName,
            mediaType: this.formLabelAlign.mediaType,
            dailyBudget: this.formLabelAlign.dailyBudget,
            id: key,
            token: this.idsList[key].token,
            ids: this.idsList[key].ids
          }
          let parms1 = {
            idsname: this.idsList[key].idsname,
            // mediaType: this.formLabelAlign.mediaType,
            // id: key,
            token: this.idsList[key].token,
            ids: this.idsList[key].ids,
            username: this.idsList[key].username
          }
          await this.GetZZData(this.idsList[key].ids, this.idsList[key].token)
          await this.GetPlanId(this.idsList[key].ids, this.idsList[key].token, key)
          // await this.GetGroupPrice(this.idsList[key].ids, this.idsList[key].token)
          if (this.isoldgroupprice) await this.GetGroupPrice(this.idsList[key].ids, this.idsList[key].token)

          if (this.newgroupflag) {
            this.newplanflag = false
          }


          if (this.ePlanId != '' && this.newplanflag == true) {
            let groundData = {
              token: this.idsList[key].token,
              ids: this.idsList[key].ids,
              campaignId: this.ePlanId,
              webSiteUrl: this.idsList[key].url,
              id: key,
              startDate: this.startDate,
              ocpxPrice: this.isoldgroupprice ? this.oldGroupPrice : new Decimal(this.formLabelAlign1.ocpxPrice).mul(100000).toNumber(),
              name: this.idsList[key].planName,
              cvType: this.formLabelAlign1.cvType,
              builtInRpkDeepLink: this.idsList[key].builtInRpkDeepLink,
              channelId: this.idsList[key].channelId,
              apkId: this.idsList[key].apkId
            }
            await this.stopPlan(groundData)

            console.log("虎虎虎虎虎虎uu呼呼呼61");
            // let newgroup = true
            // if (this.newgroupflag) {
            //   if (this.group_optionatus == 1) {
            //     let hdcookile = this.selectedRegion == "浙江" ? this.this.AllCookieList[0].hdcookie : this.this.AllCookieList[1].hdcookie

            //     newgroup = await this.getoptionGroup(this.idsList[key].ids, this.idsList[key].token)
            //   } else if (this.group_optionatus == 2) {
            //     newgroup = await this.getoptionGroup(this.idsList[key].ids, this.idsList[key].token)
            //   } else if (this.group_optionatus == 3) {
            //     newgroup = await this.getoptionGroup(this.idsList[key].ids, this.idsList[key].token)
            //   }
            // }
            // return
            await this.ground(groundData, key)
          } else if (this.newgroupflag) {
            console.log("走新建的计划1");
            if (!this.Eagoptionsvalue) {
              this.$message.warning('已存在广告组查找方式没选！');
              return
            }
            // 按所选区域名精确匹配 cookie，避免固定下标取到别的区域的 cookie
            const hdCookie = this.findCookieByName(this.selectedRegion);
            if (!hdCookie) {
              this.$message.warning(`未找到区域 [${this.selectedRegion}] 对应的 cookie，请检查 hdcookie 列表`);
              return;
            }
            let hdcookile = hdCookie;
            let pageSize = this.orderexistgroup;

            // 使用 FormData
            const formData = new FormData();

            let res = null


            if (this.Eagoptionsvalue == 1) {
              formData.append('cookile', hdcookile);
              formData.append('pageSize', pageSize);
              formData.append('pageIndex', 1);
              formData.append('accountName', this.idsList[key].idsname || '');
              formData.append('startDate', this.vivoexistgroupDateRange[0] || '');
              formData.append('endDate', this.vivoexistgroupDateRange[1] || '');
              formData.append('timeRange', '7'); // 可选的

              res = await this.$axios.post(
                'https://control.zjwec.cn/api/vivo/ad-group/page',
                formData,
                {
                  headers: {
                    'Content-Type': 'multipart/form-data'
                  }
                }
              );
            } else if (this.Eagoptionsvalue == 2) {
              const formData = new FormData();
              formData.append('cookile', hdcookile);
              formData.append('pageSize', pageSize);
              formData.append('pageIndex', 1);
              formData.append('accountName', this.idsList[key].idsname || '');

              res = await this.$axios.post(
                'https://control.zjwec.cn/api/vivo/ad-group/page-by-create-date',
                formData
              );
            }
            console.log(res);
            if (res.data.retcode == 0 && res.data.data.list.length > 0) {
              // 保存查询到的全部广告组(最多 orderexistgroup 条):搭建时每个组各建一批创意
              this.idsList[key].existGroupList = res.data.data.list
              let obj = res.data.data.list[res.data.data.list.length - 1]
              this.idsList[parms.id].groundId = obj.id
              this.ePlanId = obj.campaignId
              // 旧计划名另存,不覆盖 planName(输入名):计划/组/广告三个名字前缀统一用输入名,避免组名、广告名、甚至新计划名把完整旧计划名套娃拼进去
              this.idsList[key].existPlanName = obj.campaignName

              let groundData = {
                token: this.idsList[key].token,
                ids: this.idsList[key].ids,
                campaignId: this.ePlanId,
                webSiteUrl: this.idsList[key].url,
                id: key,
                startDate: this.startDate,
                ocpxPrice: this.isoldgroupprice ? this.oldGroupPrice : new Decimal(this.formLabelAlign1.ocpxPrice).mul(100000).toNumber(),
                name: this.idsList[key].planName,
                cvType: this.formLabelAlign1.cvType,
                builtInRpkDeepLink: this.idsList[key].builtInRpkDeepLink,
                channelId: this.idsList[key].channelId,
                apkId: this.idsList[key].apkId
              }
              await this.stopPlan(groundData)
              console.log("虎虎虎虎虎虎uu呼呼呼62");
            } else {
              console.log("走新建的计划2");
              await this.plan(parms)
              let groundData = {
                token: this.idsList[key].token,
                ids: this.idsList[key].ids,
                campaignId: this.idsList[key].planId,
                webSiteUrl: this.idsList[key].url,
                id: key,
                startDate: this.startDate,
                ocpxPrice: this.isoldgroupprice ? this.oldGroupPrice : new Decimal(this.formLabelAlign1.ocpxPrice).mul(100000).toNumber(),
                name: this.idsList[key].planName,
                cvType: this.formLabelAlign1.cvType,
                builtInRpkDeepLink: this.idsList[key].builtInRpkDeepLink,
                channelId: this.idsList[key].channelId,
                apkId: this.idsList[key].apkId
              }
              await this.stopPlan(groundData)
              console.log("虎虎虎虎虎虎uu呼呼呼63");
              await this.ground(groundData, key)
            }

          } else {
            console.log("else的新建广告计划");
            await this.plan(parms)
            let groundData = {
              token: this.idsList[key].token,
              ids: this.idsList[key].ids,
              campaignId: this.idsList[key].planId,
              webSiteUrl: this.idsList[key].url,
              id: key,
              startDate: this.startDate,
              ocpxPrice: this.isoldgroupprice ? this.oldGroupPrice : new Decimal(this.formLabelAlign1.ocpxPrice).mul(100000).toNumber(),
              name: this.idsList[key].planName,
              cvType: this.formLabelAlign1.cvType,
              builtInRpkDeepLink: this.idsList[key].builtInRpkDeepLink,
              channelId: this.idsList[key].channelId,
              apkId: this.idsList[key].apkId
            }
            await this.stopPlan(groundData)
            console.log("虎虎虎虎虎虎uu呼呼呼64");
            await this.ground(groundData, key)

          }
          // 投放时间段按组记录:使用已存在广告组时每个组各记一条,供 optimizeRequests 批量设置
          const timeGroups = (this.idsList[key].existGroupList && this.idsList[key].existGroupList.length)
            ? this.idsList[key].existGroupList
            : [{ id: this.idsList[key].groundId }];
          for (const g of timeGroups) {
            let data = {
              token: this.idsList[key].token,
              ids: this.idsList[key].ids,
              groupId: g.id,
            }
            this.timeeditlist = [...this.timeeditlist, data]
          }
          // await this.PostGroupTime(data)
          // 获取素材配置参数



          const normalCount = this.countformData.normalCount;
          const reviewCount = this.countformData.reviewCount;

          let imgcode = this.fileCode
          console.log(imgcode);
          let videocode = this.videofileCode
          console.log("cccccccccccccssssssssssssssssss");
          console.log(videocode);
          let textlist = this.titlesString.split('\n').map(line => line.trim()).filter(line => line);
          console.log(textlist);
          if (this.daluan) {
            textlist = this.shuffleArray(textlist)
          }
          // 多组搭建设置(设置指定广告组>1)时,组装段在组循环内每组分批重建:
          // 分配器游标每组自动推进"每组条数",第 i 组素材起点=(基准 + i×每组条数) mod 池长,循环回绕
          const targetGroups = (this.idsList[key].existGroupList && this.idsList[key].existGroupList.length)
            ? this.idsList[key].existGroupList
            : [{ id: this.idsList[key].groundId }];
          if (this.mixminvaluelate == "重复") {
            this.currentIndexvideo = 0
            this.currentIndeximg = 0
            this.currentIndextext = 0
            this.currentIndexzsimg = 0
            this.currentIndexzsvideo = 0
          }
          for (let gi = 0; gi < targetGroups.length; gi++) {
            const g = targetGroups[gi];
            this.creativeList = []
          // let imgindexlist = await this.getBuildIndexes(normalCount)
          let videoIndexelist = await this.getBuildvideoIndexes(normalCount)
          if (normalCount > 0 && !videoIndexelist) {
            this.$message.error('未获取到视频素材，请先到素材上传工作区选择视频后再搭建');
            return;
          }
          let zsimgindexlist = await this.getzsBuildIndexes(reviewCount)
          // 撞审素材按撞审条数独立取段:分配器返回量/游标推进量 = 撞审循环消费量,撞审窗口起点逐组偏移 reviewCount
          let zsvideoIndexelist = await this.getzsBuildvideoIndexes(reviewCount)
          if (reviewCount > 0 && !zsvideoIndexelist) {
            this.$message.error('未获取到撞审视频素材，请先到素材上传工作区选择撞审视频后再搭建');
            return;
          }
          let textIndexelist = await this.getBuildtextIndexes(normalCount)
          console.log("-------------textIndexelist--------------");
          console.log(textIndexelist);
          console.log(videoIndexelist);
          console.log("-------------videoIndexelist--------------");



          if (normalCount > 0) {
            for (let index = 0; index < normalCount; index++) {
              let arr = {}
              let covercode = videocode[videoIndexelist[index]]
              let videoCode = videocode[videoIndexelist[index]]
              arr.avatarCode = this.txfileCode[0],
                arr.title = textlist[textIndexelist[index]]
              // console.log(textlist[textIndexelist[index]]);
              arr.imgsCode = covercode.videocovercode;
              // console.log(imgcode[imgindexlist[index]]);
              arr.videoCode = videoCode.videocode;
              console.log(videocode[videoIndexelist[index]]);
              console.log();

              arr.placeType = this.formLabelAlign3.placeType[0],

                // arr.productName = this.formLabelAlign3.productNames[Math.floor(Math.random() * this.formLabelAlign3.productNames.length)]
                arr.productName = this.formLabelAlign3.productNames.length > 0
                  ? (this.formLabelAlign3.productNames[Math.floor(Math.random() * this.formLabelAlign3.productNames.length)] || '').trim()
                  : '';
              arr.virtualPositionId = this.virtualPositionvalue.join(',');

              if (this.formLabelAlign.mediaType === '2') {
                arr.appName = this.formLabelAlign3.productNames[
                  Math.floor(Math.random() * this.formLabelAlign3.productNames.length)
                ]
                arr.subTitle = arr.title;
              }
              arr.materialNormId = this.formLabelAlign3.placeType[1]

              this.creativeList = [...this.creativeList, arr]
            }
          }

          console.log(this.creativeList);
          if (reviewCount > 0) {
            let zsimgcode = this.zsfileCode
            let zsvideocode = this.zsvideofileCode
            for (let index = 0; index < reviewCount; index++) {
              let arr = {}
              arr.avatarCode = this.txfileCode[0],
                arr.title = textlist[textIndexelist[index % textIndexelist.length]]

              let zscovercode = zsvideocode[zsvideoIndexelist[index]]
              let zsvideoCode = zsvideocode[zsvideoIndexelist[index]]

              arr.imgsCode = zscovercode.videocovercode;
              arr.videoCode = zsvideoCode.videocode;

              arr.placeType = this.formLabelAlign3.placeType[0],

                // arr.productName = this.formLabelAlign3.productNames[Math.floor(Math.random() * this.formLabelAlign3.productNames.length)]
                arr.productName = this.formLabelAlign3.productNames.length > 0 ? (this.formLabelAlign3.productNames[Math.floor(Math.random() * this.formLabelAlign3.productNames.length)] || '').trim() : '';
              arr.virtualPositionId = this.virtualPositionvalue.join(',');

              if (this.formLabelAlign.mediaType === '2') {
                arr.appName = this.formLabelAlign3.productNames[
                  Math.floor(Math.random() * this.formLabelAlign3.productNames.length)
                ]
                arr.subTitle = arr.title;
              }
              arr.materialNormId = this.formLabelAlign3.placeType[1]

              this.creativeList = [...this.creativeList, arr]
            }
          }
          console.log(this.creativeList);
          // continue



















          // // 生成普通素材队列（图片+视频+标题）
          // const normalMaterials = Array.from({ length: normalCount }, (_, i) => {
          //   const pos = (this.currentNormalIndex + i) % this.fileCode.length;
          //   console.log("pos,pos,pos,pospos,pospos,pospos,pospos,pospos,pospos,pospos,pospos,pospos,pospos,pospos,pospos,pospos,pospos,pospos,pospos,pospos,pospos,pospos,pospos,pospos,pospos,pos");
          //   console.log(pos);
          //   return {
          //     img: this.fileCode[pos],
          //     // video: this.videofileCode[pos],
          //     video: this.VideofileList[pos].code,
          //     title: this.formLabelAlign3.title[pos],
          //     type: 'normal'
          //   };
          // });
          // console.log(normalMaterials);
          // console.log(this.zsVideofileList)
          // // 生成撞审素材队列（图片+视频+标题）
          // const reviewMaterials = Array.from({ length: reviewCount }, (_, i) => {
          //   const pos = (this.currentReviewIndex + i) % this.zsfileCode.length;
          //   return {
          //     img: this.zsfileCode[pos],
          //     // video: this.zsvideofileCode[pos],
          //     video: this.zsVideofileList[pos].code,

          //     title: this.zstitleList[pos],
          //     type: 'review'
          //   };
          // });
          // console.log(reviewMaterials);
          // // 合并并随机排序（实现撞审素材随机穿插）
          // console.log();
          // const combinedMaterials = [...normalMaterials, ...reviewMaterials];
          // for (let i = combinedMaterials.length - 1; i > 0; i--) {
          //   // const j = Math.floor(Math.random() * (i + 1));
          //   const j = this.getSecureRandomIndex(i);
          //   [combinedMaterials[i], combinedMaterials[j]] = [combinedMaterials[j], combinedMaterials[i]];
          // }

          // // 构建创意列表
          // this.creativeList = combinedMaterials.map(material => {
          //   const arr = {
          //     avatarCode: this.txfileCode[0],
          //     imgsCode: material.img,
          //     videoCode: material.video,
          //     title: material.title,
          //     placeType: this.formLabelAlign3.placeType[0],
          //     productName: this.formLabelAlign3.productNames[
          //       Math.floor(Math.random() * this.formLabelAlign3.productNames.length)
          //     ],
          //     materialNormId: this.formLabelAlign3.placeType[1]
          //   };

          //   // 根据媒体类型处理特殊字段
          //   if (this.formLabelAlign.mediaType === '2') {
          //     arr.appName = this.formLabelAlign3.productNames[
          //       Math.floor(Math.random() * this.formLabelAlign3.productNames.length)
          //     ];
          //     arr.subTitle = material.title;
          //   }
          //   arr.virtualPositionId =  this.virtualPositionvalue.join(',');;
          //   // arr.virtualPositionId = this.formLabelAlign.mediaType == '1' ? "1,2,13,17" : 12;
          //   // console.log(this.formLabelAlign3.placeType[0]);
          //   // console.log("停止---图像");
          //   // console.log(this.formLabelAlign3.placeType[0]==6);
          //   // if (this.formLabelAlign3.placeType[0] == 6) arr.virtualPositionId = 24

          //   return arr;
          // });

          // // 更新轮转索引（考虑数组循环）
          // this.currentNormalIndex = (this.currentNormalIndex + normalCount) % this.fileCode.length;
          // this.currentReviewIndex = (this.currentReviewIndex + reviewCount) % this.zsfileCode.length;












            const payload = {
              token: this.idsList[key].token,
              ids: this.idsList[key].ids,
              idsname: this.idsList[key].idsname,
              creativeList: this.creativeList,
              groupId: g.id,
              name: this.idsList[key].planName,
              clickMonitorUrl: this.idsList[key].xiaoshuourl,
              viewMonitorUrl: this.idsList[key].baoguangurl,
              adcreativedeeplink: this.idsList[key].adcreativedeeplink,
              username: this.idsList[key].username,
              twoname: this.idsList[key].twoname,
            };
            await this.guanggao(payload, parms1, key);
          }
          this.uploadProgress2 = ((Number(key) + 1) / this.totalTasks) * 100;


        }

        this.uploadProgress2 = 100;
        if (this.percentages === 100) {
          this.isShow2 = false; // 隐藏进度条
          this.$notify({
            title: 'success',
            message: '批量搭建工程全部完成！',
            type: 'success'
          });
          if (this.errorMaterialsList.length > 0) {
            this.showErrorSummary();
          }
          this.fetchAdvRecordTodayTotal();
        }
      } else if (this.formLabelAlign3.placeType[1] === '75' || this.formLabelAlign3.placeType[1] === '242' || this.formLabelAlign3.placeType[1] === '145') {

        let t = 0;
        this.isShow2 = true;
        this.totalTasks = this.idsList.length;
        for (let key in this.idsList) {
          // if (this.daluan === true) {
          //   this.formLabelAlign3.title = this.shuffle(this.formLabelAlign3.title)
          // }

          let parms = {
            name: this.idsList[key].planName,
            mediaType: this.formLabelAlign.mediaType,
            dailyBudget: this.formLabelAlign.dailyBudget,
            id: key,
            token: this.idsList[key].token,
            ids: this.idsList[key].ids
          }

          let parms1 = {
            idsname: this.idsList[key].idsname,
            // mediaType: this.formLabelAlign.mediaType,
            // id: key,
            token: this.idsList[key].token,
            ids: this.idsList[key].ids,
            username: this.idsList[key].username
          }
          // if (this.stopAll == true){
          //   this.stopAll = false
          //   return false
          // }
          await this.GetZZData(this.idsList[key].ids, this.idsList[key].token)
          await this.GetPlanId(this.idsList[key].ids, this.idsList[key].token, key)
          // await this.GetGroupPrice(this.idsList[key].ids, this.idsList[key].token)
          if (this.isoldgroupprice) await this.GetGroupPrice(this.idsList[key].ids, this.idsList[key].token)





          if (this.newgroupflag) {
            this.newplanflag = false
          }


          if (this.ePlanId !== '' && this.newplanflag === true) {
            let groundData = {
              token: this.idsList[key].token,
              ids: this.idsList[key].ids,
              campaignId: this.ePlanId,
              webSiteUrl: this.idsList[key].url,
              id: key,
              startDate: this.startDate,
              ocpxPrice: this.isoldgroupprice ? this.oldGroupPrice : new Decimal(this.formLabelAlign1.ocpxPrice).mul(100000).toNumber(),
              name: this.idsList[key].planName,
              cvType: this.formLabelAlign1.cvType,
              builtInRpkDeepLink: this.idsList[key].builtInRpkDeepLink,
              channelId: this.idsList[key].channelId,
              apkId: this.idsList[key].apkId
            }
            await this.stopPlan(groundData)
            console.log("虎虎虎虎虎虎uu呼呼呼75");
            // let newgroup = true
            // if (this.newgroupflag) {
            //   if (this.group_optionatus == 1) {
            //     let hdcookile = this.selectedRegion == "浙江" ? this.this.AllCookieList[0].hdcookie : this.this.AllCookieList[1].hdcookie

            //     newgroup = await this.getoptionGroup(this.idsList[key].ids, this.idsList[key].token)
            //   } else if (this.group_optionatus == 2) {
            //     newgroup = await this.getoptionGroup(this.idsList[key].ids, this.idsList[key].token)
            //   } else if (this.group_optionatus == 3) {
            //     newgroup = await this.getoptionGroup(this.idsList[key].ids, this.idsList[key].token)
            //   }
            // }
            // return
            await this.ground(groundData, key)
          } else if (this.newgroupflag) {
            if (!this.Eagoptionsvalue) {
              this.$message.warning('已存在广告组查找方式没选！');
              return
            }
            // 按所选区域名精确匹配 cookie，避免固定下标取到别的区域的 cookie
            const hdCookie = this.findCookieByName(this.selectedRegion);
            if (!hdCookie) {
              this.$message.warning(`未找到区域 [${this.selectedRegion}] 对应的 cookie，请检查 hdcookie 列表`);
              return;
            }
            let hdcookile = hdCookie;
            let pageSize = this.orderexistgroup;

            // 使用 FormData
            const formData = new FormData();

            let res = null


            if (this.Eagoptionsvalue == 1) {
              formData.append('cookile', hdcookile);
              formData.append('pageSize', pageSize);
              formData.append('pageIndex', 1);
              formData.append('accountName', this.idsList[key].idsname || '');
              formData.append('startDate', this.vivoexistgroupDateRange[0] || '');
              formData.append('endDate', this.vivoexistgroupDateRange[1] || '');
              formData.append('timeRange', '7'); // 可选的

              res = await this.$axios.post(
                'https://control.zjwec.cn/api/vivo/ad-group/page',
                formData,
                {
                  headers: {
                    'Content-Type': 'multipart/form-data'
                  }
                }
              );
            } else if (this.Eagoptionsvalue == 2) {
              const formData = new FormData();
              formData.append('cookile', hdcookile);
              formData.append('pageSize', pageSize);
              formData.append('pageIndex', 1);
              formData.append('accountName', this.idsList[key].idsname || '');

              res = await this.$axios.post(
                'https://control.zjwec.cn/api/vivo/ad-group/page-by-create-date',
                formData
              );
            }



            console.log(res);
            if (res.data.retcode == 0 && res.data.data.list.length > 0) {
              // 保存查询到的全部广告组(最多 orderexistgroup 条):搭建时每个组各建一批创意
              this.idsList[key].existGroupList = res.data.data.list
              let obj = res.data.data.list[res.data.data.list.length - 1]
              this.idsList[parms.id].groundId = obj.id
              this.ePlanId = obj.campaignId
              // 旧计划名另存,不覆盖 planName(输入名):计划/组/广告三个名字前缀统一用输入名,避免组名、广告名、甚至新计划名把完整旧计划名套娃拼进去
              this.idsList[key].existPlanName = obj.campaignName

              let groundData = {
                token: this.idsList[key].token,
                ids: this.idsList[key].ids,
                campaignId: this.ePlanId,
                webSiteUrl: this.idsList[key].url,
                id: key,
                startDate: this.startDate,
                ocpxPrice: this.isoldgroupprice ? this.oldGroupPrice : new Decimal(this.formLabelAlign1.ocpxPrice).mul(100000).toNumber(),
                name: this.idsList[key].planName,
                cvType: this.formLabelAlign1.cvType,
                builtInRpkDeepLink: this.idsList[key].builtInRpkDeepLink,
                channelId: this.idsList[key].channelId,
                apkId: this.idsList[key].apkId
              }
              await this.stopPlan(groundData)
              console.log("虎虎虎虎虎虎uu呼呼呼76");
            } else {
              await this.plan(parms)
              let groundData = {
                token: this.idsList[key].token,
                ids: this.idsList[key].ids,
                campaignId: this.idsList[key].planId,
                webSiteUrl: this.idsList[key].url,
                id: key,
                startDate: this.startDate,
                ocpxPrice: this.isoldgroupprice ? this.oldGroupPrice : new Decimal(this.formLabelAlign1.ocpxPrice).mul(100000).toNumber(),
                name: this.idsList[key].planName,
                cvType: this.formLabelAlign1.cvType,
                builtInRpkDeepLink: this.idsList[key].builtInRpkDeepLink,
                channelId: this.idsList[key].channelId,
                apkId: this.idsList[key].apkId
              }
              await this.stopPlan(groundData)
              console.log("虎虎虎虎虎虎uu呼呼呼77");
              await this.ground(groundData, key)
            }

          } else {
            await this.plan(parms)
            let groundData = {
              token: this.idsList[key].token,
              ids: this.idsList[key].ids,
              campaignId: this.idsList[key].planId,
              webSiteUrl: this.idsList[key].url,
              id: key,
              startDate: this.startDate,
              ocpxPrice: this.isoldgroupprice ? this.oldGroupPrice : new Decimal(this.formLabelAlign1.ocpxPrice).mul(100000).toNumber(),
              name: this.idsList[key].planName,
              cvType: this.formLabelAlign1.cvType,
              builtInRpkDeepLink: this.idsList[key].builtInRpkDeepLink,
              channelId: this.idsList[key].channelId,
              apkId: this.idsList[key].apkId
            }
            await this.stopPlan(groundData)
            console.log("虎虎虎虎虎虎uu呼呼呼78");
            await this.ground(groundData, key)

          }

          const normalCount = this.countformData.normalCount;
          const reviewCount = this.countformData.reviewCount;

          // console.log(this.countformData)
          // console.log(this.fileCode)
          // console.log(this.zstitleList);
          // console.log(this.formLabelAlign3.title);
          // // 生成普通素材队列（图片+视频+标题）
          // const normalMaterials = Array.from({ length: normalCount }, (_, i) => {
          //   const pos = (this.currentNormalIndex + i) % this.videofileCode.length;
          //   return {
          //     img: this.fileCode[pos],
          //     video: this.videofileCode[pos],
          //     title: this.formLabelAlign3.title[pos],
          //     type: 'normal'
          //   };
          // });

          // // 生成撞审素材队列（图片+视频+标题）
          // const reviewMaterials = Array.from({ length: reviewCount }, (_, i) => {
          //   const pos = (this.currentReviewIndex + i) % this.zsvideofileCode.length;
          //   return {
          //     img: this.zsfileCode[pos],
          //     video: this.zsvideofileCode[pos],
          //     title: this.zstitleList[pos],
          //     type: 'review'
          //   };
          // });

          // // 合并并随机排序（实现撞审素材随机穿插）
          // const combinedMaterials = [...normalMaterials, ...reviewMaterials];
          // for (let i = combinedMaterials.length - 1; i > 0; i--) {
          //   // const j = Math.floor(Math.random() * (i + 1));
          //   const j = this.getSecureRandomIndex(i);
          //   [combinedMaterials[i], combinedMaterials[j]] = [combinedMaterials[j], combinedMaterials[i]];
          // }
          // // console.log();
          // console.log("777777777777777777777777777777777777777777777777777777777777777777777777777777");
          // console.log(combinedMaterials);
          // console.log("777777777777777777777777777777777777777777777777777777777777777777777777777777");


          // // 构建创意列表
          // this.creativeList = combinedMaterials.map(material => {
          //   const arr = {
          //     avatarCode: this.txfileCode[0],
          //     imgsCode: material.img,
          //     videoCode: material.video,
          //     title: material.title,
          //     placeType: this.formLabelAlign3.placeType[0],
          //     productName: this.formLabelAlign3.productNames[
          //       Math.floor(Math.random() * this.formLabelAlign3.productNames.length)
          //     ],
          //     materialNormId: this.formLabelAlign3.placeType[1]
          //   };

          //   // 根据媒体类型处理特殊字段
          //   if (this.formLabelAlign.mediaType === '2') {
          //     arr.appName = this.formLabelAlign3.productNames[
          //       Math.floor(Math.random() * this.formLabelAlign3.productNames.length)
          //     ];
          //     arr.subTitle = material.title;
          //   }
          //   arr.virtualPositionId = this.virtualPositionvalue.join(',');;
          //   // if (this.formLabelAlign.mediaType === '1') {
          //   //   arr.virtualPositionId = "1,2,13";
          //   //   if (this.formLabelAlign3.placeType[0] == 6) arr.virtualPositionId = 24
          //   // } else {
          //   //   const placeTypeSecond = this.formLabelAlign3.placeType[1];
          //   //   const typeIdMap = { '35': 9, '85': 9, '39': 11 };
          //   //   // 用逻辑或 || 替代空值合并运算符 ??
          //   //   arr.virtualPositionId = typeIdMap[placeTypeSecond] || 12; // 当值不存在时 fallback 到 12
          //   // }

          //   return arr;
          // });
          // console.log(this.creativeList);

          // // 更新轮转索引（考虑数组循环）
          // this.currentNormalIndex = (this.currentNormalIndex + normalCount) % this.fileCode.length;
          // this.currentReviewIndex = (this.currentReviewIndex + reviewCount) % this.zsfileCode.length;

          let imgcode = this.fileCode
          console.log(imgcode);
          let videocode = this.videofileCode
          let textlist = this.titlesString.split('\n').map(line => line.trim()).filter(line => line);
          if (this.daluan) {
            textlist = this.shuffleArray(textlist)
          }
          // 多组搭建设置(设置指定广告组>1)时,组装段在组循环内每组分批重建:
          // 分配器游标每组自动推进"每组条数",第 i 组素材起点=(基准 + i×每组条数) mod 池长,循环回绕
          const targetGroups = (this.idsList[key].existGroupList && this.idsList[key].existGroupList.length)
            ? this.idsList[key].existGroupList
            : [{ id: this.idsList[key].groundId }];
          if (this.mixminvaluelate == "重复") {
            this.currentIndexvideo = 0
            this.currentIndeximg = 0
            this.currentIndextext = 0
            this.currentIndexzsimg = 0
            this.currentIndexzsvideo = 0
          }
          for (let gi = 0; gi < targetGroups.length; gi++) {
            const g = targetGroups[gi];
            this.creativeList = []
          // let imgindexlist = await this.getBuildIndexes(normalCount)
          let videoIndexelist = await this.getBuildvideoIndexes(normalCount)
          if (normalCount > 0 && !videoIndexelist) {
            this.$message.error('未获取到视频素材，请先到素材上传工作区选择视频后再搭建');
            return;
          }
          console.log(this.titlesString
            .split('\n')
            .map(line => line.trim())
            .filter(line => line));
          console.log(this.videofileCode);
          let textIndexelist = await this.getBuildtextIndexes(normalCount)
          // let zsimgindexlist = await this.getzsBuildIndexes(normalCount)
          // 撞审素材按撞审条数独立取段:分配器返回量/游标推进量 = 撞审循环消费量,撞审窗口起点逐组偏移 reviewCount
          let zsvideoIndexelist = await this.getzsBuildvideoIndexes(reviewCount)
          if (reviewCount > 0 && !zsvideoIndexelist) {
            this.$message.error('未获取到撞审视频素材，请先到素材上传工作区选择撞审视频后再搭建');
            return;
          }

          console.log("-------------textIndexelist--------------");
          console.log(textIndexelist);
          console.log(videoIndexelist);
          console.log("-------------videoIndexelist--------------");


          if (normalCount > 0) {
            for (let index = 0; index < normalCount; index++) {
              let arr = {}
              let covercode = videocode[videoIndexelist[index]]
              let videoCode = videocode[videoIndexelist[index]]
              arr.avatarCode = this.txfileCode[0],
                arr.title = textlist[textIndexelist[index]]
              // console.log(textlist[textIndexelist[index]]);
              arr.imgsCode = covercode.videocovercode;
              // console.log(imgcode[imgindexlist[index]]);
              arr.videoCode = videoCode.videocode;
              console.log(videocode[videoIndexelist[index]]);

              arr.placeType = this.formLabelAlign3.placeType[0],

                // arr.productName = this.formLabelAlign3.productNames[Math.floor(Math.random() * this.formLabelAlign3.productNames.length)]
                arr.productName = this.formLabelAlign3.productNames.length > 0 ? (this.formLabelAlign3.productNames[Math.floor(Math.random() * this.formLabelAlign3.productNames.length)] || '').trim() : '';
              arr.virtualPositionId = this.virtualPositionvalue.join(',');

              if (this.formLabelAlign.mediaType === '2') {
                arr.appName = this.formLabelAlign3.productNames[
                  Math.floor(Math.random() * this.formLabelAlign3.productNames.length)
                ]
                arr.subTitle = arr.title;
              }
              arr.materialNormId = this.formLabelAlign3.placeType[1]

              this.creativeList = [...this.creativeList, arr]
            }
          }

          console.log(this.creativeList);
          if (reviewCount > 0) {
            // let zsimgcode = this.zsfileCode
            let zsvideocode = this.zsvideofileCode
            for (let index = 0; index < reviewCount; index++) {
              let arr = {}
              arr.avatarCode = this.txfileCode[0],
                arr.title = textlist[textIndexelist[index % textIndexelist.length]]


              let zscovercode = zsvideocode[zsvideoIndexelist[index]]
              let zsvideoCode = zsvideocode[zsvideoIndexelist[index]]

              arr.imgsCode = zscovercode.videocovercode;
              arr.videoCode = zsvideoCode.videocode;
              // arr.imgsCode = zsvideocode[zsvideoIndexelist[index].videocovercode];
              // arr.videoCode = zsvideocode[zsvideoIndexelist[index].videocode];


              arr.placeType = this.formLabelAlign3.placeType[0],

                // arr.productName = this.formLabelAlign3.productNames[Math.floor(Math.random() * this.formLabelAlign3.productNames.length)]
                arr.productName = this.formLabelAlign3.productNames.length > 0 ? (this.formLabelAlign3.productNames[Math.floor(Math.random() * this.formLabelAlign3.productNames.length)] || '').trim() : '';
              arr.virtualPositionId = this.virtualPositionvalue.join(',');

              if (this.formLabelAlign.mediaType === '2') {
                arr.appName = this.formLabelAlign3.productNames[
                  Math.floor(Math.random() * this.formLabelAlign3.productNames.length)
                ]
                arr.subTitle = arr.title;
              }
              arr.materialNormId = this.formLabelAlign3.placeType[1]

              this.creativeList = [...this.creativeList, arr]
            }
          }
          console.log(this.creativeList);







            const payload = {
              token: this.idsList[key].token,
              ids: this.idsList[key].ids,
              idsname: this.idsList[key].idsname,
              creativeList: this.creativeList,
              groupId: g.id,
              name: this.idsList[key].planName,
              clickMonitorUrl: this.idsList[key].xiaoshuourl,
              viewMonitorUrl: this.idsList[key].baoguangurl,
              adcreativedeeplink: this.idsList[key].adcreativedeeplink,
              username: this.idsList[key].username,
              twoname: this.idsList[key].twoname,
            };
            await this.guanggao(payload, parms1, key);
          }


          this.uploadProgress2 = (((Number(key) + 1) / this.totalTasks) * 100).toFixed(2);
        }
        this.uploadProgress2 = 100;
        if (this.uploadProgress2 === 100) {
          this.isShow2 = false; // 隐藏进度条
          this.$notify({
            title: 'success',
            message: '批量搭建工程全部完成！',
            type: 'success'
          });
          if (this.errorMaterialsList.length > 0) {
            this.showErrorSummary();
          }
          this.fetchAdvRecordTodayTotal();
        }

      } else {
        let t = 0;
        this.isShow2 = true;
        this.totalTasks = this.idsList.length;
        for (let key in this.idsList) {
          // if (this.daluan === true) {
          //   this.formLabelAlign3.title = this.shuffle(this.formLabelAlign3.title)
          // }

          let parms = {
            name: this.idsList[key].planName,
            mediaType: this.formLabelAlign.mediaType,
            dailyBudget: this.formLabelAlign.dailyBudget,
            id: key,
            token: this.idsList[key].token,
            ids: this.idsList[key].ids
          }

          let parms1 = {
            idsname: this.idsList[key].idsname,
            // mediaType: this.formLabelAlign.mediaType,
            // id: key,
            token: this.idsList[key].token,
            ids: this.idsList[key].ids,
            username: this.idsList[key].username
          }
          // if (this.stopAll == true){
          //   this.stopAll = false
          //   return false
          // }
          await this.GetZZData(this.idsList[key].ids, this.idsList[key].token)
          await this.GetPlanId(this.idsList[key].ids, this.idsList[key].token, key)
          // await this.GetGroupPrice(this.idsList[key].ids, this.idsList[key].token)
          if (this.isoldgroupprice) await this.GetGroupPrice(this.idsList[key].ids, this.idsList[key].token)


          if (this.newgroupflag) {
            this.newplanflag = false
          }


          if (this.ePlanId !== '' && this.newplanflag === true) {
            let groundData = {
              token: this.idsList[key].token,
              ids: this.idsList[key].ids,
              campaignId: this.ePlanId,
              webSiteUrl: this.idsList[key].url,
              id: key,
              startDate: this.startDate,
              ocpxPrice: this.isoldgroupprice ? this.oldGroupPrice : new Decimal(this.formLabelAlign1.ocpxPrice).mul(100000).toNumber(),
              name: this.idsList[key].planName,
              cvType: this.formLabelAlign1.cvType,
              builtInRpkDeepLink: this.idsList[key].builtInRpkDeepLink,
              channelId: this.idsList[key].channelId,
              apkId: this.idsList[key].apkId
            }
            await this.stopPlan(groundData)
            // let newgroup = true
            // if (this.newgroupflag) {
            //   if (this.group_optionatus == 1) {
            //     let hdcookile = this.selectedRegion == "浙江" ? this.this.AllCookieList[0].hdcookie : this.this.AllCookieList[1].hdcookie

            //     newgroup = await this.getoptionGroup(this.idsList[key].ids, this.idsList[key].token)
            //   } else if (this.group_optionatus == 2) {
            //     newgroup = await this.getoptionGroup(this.idsList[key].ids, this.idsList[key].token)
            //   } else if (this.group_optionatus == 3) {
            //     newgroup = await this.getoptionGroup(this.idsList[key].ids, this.idsList[key].token)
            //   }
            // }
            // return
            await this.ground(groundData, key)
          } else if (this.newgroupflag) {
            if (!this.Eagoptionsvalue) {
              this.$message.warning('已存在广告组查找方式没选！');
              return
            }
            // 按所选区域名精确匹配 cookie，避免固定下标取到别的区域的 cookie
            const hdCookie = this.findCookieByName(this.selectedRegion);
            if (!hdCookie) {
              this.$message.warning(`未找到区域 [${this.selectedRegion}] 对应的 cookie，请检查 hdcookie 列表`);
              return;
            }
            let hdcookile = hdCookie;
            let pageSize = this.orderexistgroup;

            // 使用 FormData
            const formData = new FormData();

            let res = null


            if (this.Eagoptionsvalue == 1) {
              formData.append('cookile', hdcookile);
              formData.append('pageSize', pageSize);
              formData.append('pageIndex', 1);
              formData.append('accountName', this.idsList[key].idsname || '');
              formData.append('startDate', this.vivoexistgroupDateRange[0] || '');
              formData.append('endDate', this.vivoexistgroupDateRange[1] || '');
              formData.append('timeRange', '7'); // 可选的

              res = await this.$axios.post(
                'https://control.zjwec.cn/api/vivo/ad-group/page',
                formData,
                {
                  headers: {
                    'Content-Type': 'multipart/form-data'
                  }
                }
              );
            } else if (this.Eagoptionsvalue == 2) {
              const formData = new FormData();
              formData.append('cookile', hdcookile);
              formData.append('pageSize', pageSize);
              formData.append('pageIndex', 1);
              formData.append('accountName', this.idsList[key].idsname || '');

              res = await this.$axios.post(
                'https://control.zjwec.cn/api/vivo/ad-group/page-by-create-date',
                formData
              );
            }
            console.log(res);
            if (res.data.retcode == 0 && res.data.data.list.length > 0) {
              // 保存查询到的全部广告组(最多 orderexistgroup 条):搭建时每个组各建一批创意
              this.idsList[key].existGroupList = res.data.data.list
              let obj = res.data.data.list[res.data.data.list.length - 1]
              this.idsList[parms.id].groundId = obj.id
              this.ePlanId = obj.campaignId
              // 旧计划名另存,不覆盖 planName(输入名):计划/组/广告三个名字前缀统一用输入名,避免组名、广告名、甚至新计划名把完整旧计划名套娃拼进去
              this.idsList[key].existPlanName = obj.campaignName

              let groundData = {
                token: this.idsList[key].token,
                ids: this.idsList[key].ids,
                campaignId: this.ePlanId,
                webSiteUrl: this.idsList[key].url,
                id: key,
                startDate: this.startDate,
                ocpxPrice: this.isoldgroupprice ? this.oldGroupPrice : new Decimal(this.formLabelAlign1.ocpxPrice).mul(100000).toNumber(),
                name: this.idsList[key].planName,
                cvType: this.formLabelAlign1.cvType,
                builtInRpkDeepLink: this.idsList[key].builtInRpkDeepLink,
                channelId: this.idsList[key].channelId,
                apkId: this.idsList[key].apkId
              }
              await this.stopPlan(groundData)
            } else {
              await this.plan(parms)
              let groundData = {
                token: this.idsList[key].token,
                ids: this.idsList[key].ids,
                campaignId: this.idsList[key].planId,
                webSiteUrl: this.idsList[key].url,
                id: key,
                startDate: this.startDate,
                ocpxPrice: this.isoldgroupprice ? this.oldGroupPrice : new Decimal(this.formLabelAlign1.ocpxPrice).mul(100000).toNumber(),
                name: this.idsList[key].planName,
                cvType: this.formLabelAlign1.cvType,
                builtInRpkDeepLink: this.idsList[key].builtInRpkDeepLink,
                channelId: this.idsList[key].channelId,
                apkId: this.idsList[key].apkId
              }
              await this.stopPlan(groundData)
              await this.ground(groundData, key)
            }

          } else {
            await this.plan(parms)
            let groundData = {
              token: this.idsList[key].token,
              ids: this.idsList[key].ids,
              campaignId: this.idsList[key].planId,
              webSiteUrl: this.idsList[key].url,
              id: key,
              startDate: this.startDate,
              ocpxPrice: this.isoldgroupprice ? this.oldGroupPrice : new Decimal(this.formLabelAlign1.ocpxPrice).mul(100000).toNumber(),
              name: this.idsList[key].planName,
              cvType: this.formLabelAlign1.cvType,
              builtInRpkDeepLink: this.idsList[key].builtInRpkDeepLink,
              channelId: this.idsList[key].channelId,
              apkId: this.idsList[key].apkId
            }
            await this.stopPlan(groundData)
            // console.log("一万万万");
            await this.ground(groundData, key)

          }

          const normalCount = this.countformData.normalCount;
          const reviewCount = this.countformData.reviewCount;

          // console.log(this.countformData)
          // console.log(this.fileCode)
          // console.log(this.zstitleList);
          // console.log(this.formLabelAlign3.title);
          // // 生成普通素材队列（图片+视频+标题）
          // const normalMaterials = Array.from({ length: normalCount }, (_, i) => {
          //   const pos = (this.currentNormalIndex + i) % this.fileCode.length;
          //   return {
          //     img: this.fileCode[pos],

          //     title: this.formLabelAlign3.title[pos],
          //     type: 'normal'
          //   };
          // });

          // console.log('生成普通素材队列（图片+视频+标题）');
          // console.log(normalMaterials);

          // // 生成撞审素材队列（图片+视频+标题）
          // const reviewMaterials = Array.from({ length: reviewCount }, (_, i) => {
          //   const pos = (this.currentReviewIndex + i) % this.zsfileCode.length;
          //   return {
          //     img: this.zsfileCode[pos],

          //     title: this.zstitleList[pos],
          //     type: 'review'
          //   };
          // });

          // console.log('生成撞审素材队列（图片+视频+标题）');

          // // 合并并随机排序（实现撞审素材随机穿插）
          // const combinedMaterials = [...normalMaterials, ...reviewMaterials];
          // for (let i = combinedMaterials.length - 1; i > 0; i--) {
          //   // const j = Math.floor(Math.random() * (i + 1));
          //   const j = this.getSecureRandomIndex(i);
          //   [combinedMaterials[i], combinedMaterials[j]] = [combinedMaterials[j], combinedMaterials[i]];
          // }
          // // console.log();
          // console.log("777777777777777777777777777777777777777777777777777777777777777777777777777777");
          // console.log(combinedMaterials);
          // console.log("777777777777777777777777777777777777777777777777777777777777777777777777777777");


          // // 构建创意列表
          // this.creativeList = combinedMaterials.map(material => {
          //   const arr = {
          //     avatarCode: this.txfileCode[0],
          //     imgsCode: material.img,
          //     videoCode: material.video,
          //     title: material.title,
          //     placeType: this.formLabelAlign3.placeType[0],
          //     productName: this.formLabelAlign3.productNames[
          //       Math.floor(Math.random() * this.formLabelAlign3.productNames.length)
          //     ],
          //     materialNormId: this.formLabelAlign3.placeType[1]
          //   };

          //   // 根据媒体类型处理特殊字段
          //   if (this.formLabelAlign.mediaType === '2') {
          //     arr.appName = this.formLabelAlign3.productNames[
          //       Math.floor(Math.random() * this.formLabelAlign3.productNames.length)
          //     ];
          //     arr.subTitle = material.title;
          //   }
          //   arr.virtualPositionId = this.virtualPositionvalue.join(',');;
          //   // if (this.formLabelAlign.mediaType === '1') {
          //   //   arr.virtualPositionId = "1,2,13";
          //   //   if (this.formLabelAlign3.placeType[0] == 6) arr.virtualPositionId = 24
          //   // } else {
          //   //   const placeTypeSecond = this.formLabelAlign3.placeType[1];
          //   //   const typeIdMap = { '35': 9, '85': 9, '39': 11 };
          //   //   // 用逻辑或 || 替代空值合并运算符 ??
          //   //   arr.virtualPositionId = typeIdMap[placeTypeSecond] || 12; // 当值不存在时 fallback 到 12
          //   // }

          //   return arr;
          // });

          // // 更新轮转索引（考虑数组循环）
          // this.currentNormalIndex = (this.currentNormalIndex + normalCount) % this.fileCode.length;
          // this.currentReviewIndex = (this.currentReviewIndex + reviewCount) % this.zsfileCode.length;

          let imgcode = this.fileCode
          console.log(imgcode);
          // let videocode = this.videofileCode
          let textlist = this.titlesString.split('\n').map(line => line.trim()).filter(line => line);
          if (this.daluan) {
            textlist = this.shuffleArray(textlist)
          }
          // 多组搭建设置(设置指定广告组>1)时,组装段在组循环内每组分批重建:
          // 分配器游标每组自动推进"每组条数",第 i 组素材起点=(基准 + i×每组条数) mod 池长,循环回绕
          const targetGroups = (this.idsList[key].existGroupList && this.idsList[key].existGroupList.length)
            ? this.idsList[key].existGroupList
            : [{ id: this.idsList[key].groundId }];
          if (this.mixminvaluelate == "重复") {
            // this.currentIndexvideo = 0
            this.currentIndeximg = 0
            this.currentIndextext = 0
            this.currentIndexzsimg = 0
          }
          for (let gi = 0; gi < targetGroups.length; gi++) {
            const g = targetGroups[gi];
            this.creativeList = []
          let imgindexlist = await this.getBuildIndexes(normalCount)
          // let videoIndexelist = await this.getBuildvideoIndexes(normalCount)
          let textIndexelist = await this.getBuildtextIndexes(normalCount)
          let zsimgindexlist = await this.getzsBuildIndexes(reviewCount)
          // let zsvideoIndexelist = await this.getzsBuildvideoIndexes(normalCount)
          // 搜索提词版位公共校验：需选到第 3 级模板类型；关键词（撞审标题按行拆分）每词≤15字符、最多1000词
          // 置于需图校验之前：未选模板类型时 placeType[2] 为 undefined，先校验避免图片提示顺序错位
          if (this.isStoreSearchPlacement) {
            if (this.formLabelAlign3.placeType.length < 3) {
              this.$message.error('请选择搜索提词的具体创意模板类型');
              return;
            }
            const wordList = this.storeSearchWordDtoList();
            if (!wordList) {
              return;
            }
          }
          // 搜索提词版位按模板类型判断是否需要图片；其他版位保持原逻辑（placeType[1] != 0 需要图片）
          const needImg = this.isStoreSearchPlacement ? this.storeTemplateNeedsImage(this.formLabelAlign3.placeType[2]) : (this.formLabelAlign3.placeType[1] != 0);
          if (normalCount > 0 && needImg && !imgindexlist) {
            this.$message.error('未获取到图片素材，请先到素材上传工作区选择图片后再搭建');
            return;
          }
          // 搜索提词三图模板（3-搜索三图/8-富媒体大三图）每创意需 3 张不同图：素材不足时轮转取图会重复同一张，平台校验失败，搭建前拦截
          if (normalCount > 0 && this.isStoreSearchPlacement && [3, 8].includes(Number(this.formLabelAlign3.placeType[2]))) {
            const uniqueImgCount = new Set(imgcode).size
            if (uniqueImgCount < 3) {
              this.$message.error(`当前模板需 3 张图片，已有 ${uniqueImgCount} 张，请到素材上传工作区补充后再搭建`);
              return;
            }
          }
          if (normalCount > 0 && !textIndexelist) {
            this.$message.error('请先填写创意标题后再搭建');
            return;
          }
          // 标签气泡（15）专属校验：labelDesc 2-5字、labelColor 必选（doc 269 常见问题）
          if (this.isStoreSearchPlacement && Number(this.formLabelAlign3.placeType[2]) === 15) {
            const labelDesc = (this.formLabelAlign3.labelDesc || '').trim()
            if (labelDesc.length < 2 || labelDesc.length > 5) {
              this.$message.error('标签气泡文案需 2-5 个字，请先填写');
              return;
            }
            if (!this.formLabelAlign3.labelColor) {
              this.$message.error('请选择标签气泡颜色');
              return;
            }
          }
          if (reviewCount > 0 && !zsimgindexlist) {
            this.$message.error('未获取到撞审图片素材，请先选择后再搭建');
            return;
          }
          // 撞审创意同样按模板校验三图素材数量（不足 3 张轮转取图会重复，平台校验失败）
          if (reviewCount > 0 && this.isStoreSearchPlacement && [3, 8].includes(Number(this.formLabelAlign3.placeType[2]))) {
            const uniqueZsImgCount = new Set(this.zsfileCode).size
            if (uniqueZsImgCount < 3) {
              this.$message.error(`撞审创意当前模板需 3 张图片，已有 ${uniqueZsImgCount} 张，请补充后再搭建`);
              return;
            }
          }



          if (normalCount > 0) {

            if (this.isStoreSearchPlacement) {
              // 级联三级的第 3 级才是模板类型（[0]版位21/[1]首位2或列表1/[2]模板类型）
              const templateType = Number(this.formLabelAlign3.placeType[2])
              for (let index = 0; index < normalCount; index++) {
                let arr = {}
                arr.title = textlist[textIndexelist[index]]
                arr.templateType = templateType
                // 需图模板才传图片：14-挂件/19-列表背景 传 imgsUrl；三图模板（3-搜索三图/8-富媒体大三图）每创意传 3 张图数组；其余传单图 imgsCode
                if (this.storeTemplateNeedsImage(templateType)) {
                  if ([14, 19].includes(templateType)) {
                    arr.imgsUrl = this.storeSearchImgUrl(this.fileUrl[imgindexlist[index]])
                  } else if (templateType === 3 || templateType === 8) {
                    // 三图模板：imgsCode 为英文逗号分隔的 string（非数组），每创意 3 张图轮转取
                    arr.imgsCode = [0, 1, 2].map(k => imgcode[(imgindexlist[index] + k) % imgcode.length]).join(',');
                  } else {
                    arr.imgsCode = imgcode[imgindexlist[index]];
                  }
                }
                // 标签气泡（15）传专属字段 labelDesc/labelColor
                if (templateType === 15) {
                  arr.labelDesc = this.formLabelAlign3.labelDesc.trim()
                  arr.labelColor = this.formLabelAlign3.labelColor
                }
                // deepLink 挂创意上而非顶层（doc 269 creativeList 子字段）；2026-09-09 实验放开 templateType=7 限定：商店搜索全模板都带，验证平台兼容性
                if (this.idsList[key].adcreativedeeplink) {
                  arr.deeplink = this.idsList[key].adcreativedeeplink
                }
                arr.adDesc = textlist[textIndexelist[index]]
                // 高亮一句话（16）取 15 字内短文案
                if (templateType === 16 && arr.adDesc.length > 15) {
                  arr.adDesc = arr.adDesc.slice(0, 15)
                }
                // subTitle 与 adDesc 同值（短文案，doc 269 两字段独立校验，值相同合规）
                arr.subTitle = arr.adDesc
                // 关键词列表：撞审标题按行拆分（搭建前已校验）
                // 提词允许为空（2026-09-03 放开）：空时不挂 wordDtoList 字段，避免平台对空数组的未知校验；非空时正常附加
                const wordDtoList = this.storeSearchWordDtoList();
                if (wordDtoList && wordDtoList.length > 0) {
                  arr.wordDtoList = wordDtoList;
                }
                this.creativeList = [...this.creativeList, arr]
              }
            } else if (this.formLabelAlign3.placeType[1] == 0) {
              for (let index = 0; index < normalCount; index++) {
                let arr = {}
                // arr.avatarCode = this.txfileCode[0],
                arr.adDesc = textlist[textIndexelist[index]]




                arr.creativeLabelList = []
                arr.templateType = 0
                arr.recSentences = []
                arr.subLinks = []
                // console.log(textlist[textIndexelist[index]]);
                // arr.imgsCode = imgcode[imgindexlist[index]];
                // console.log(imgcode[imgindexlist[index]]);
                // arr.videoCode = videocode[videoIndexelist[index]];
                // console.log(videocode[videoIndexelist[index]]);

                // arr.placeType = this.formLabelAlign3.placeType[0]

                // arr.productName = this.formLabelAlign3.productNames[Math.floor(Math.random() * this.formLabelAlign3.productNames.length)]
                // arr.productName = this.formLabelAlign3.productNames.length > 0 ? (this.formLabelAlign3.productNames[Math.floor(Math.random() * this.formLabelAlign3.productNames.length)] || '').trim() : '';

                if (this.formLabelAlign.mediaType === '2') {
                  arr.appName = this.formLabelAlign3.productNames[
                    Math.floor(Math.random() * this.formLabelAlign3.productNames.length)
                  ]
                  arr.subTitle = arr.title;
                }


                this.creativeList = [...this.creativeList, arr]
              }
            } else {
              for (let index = 0; index < normalCount; index++) {
                let arr = {}
                arr.avatarCode = this.txfileCode[0],
                  arr.title = textlist[textIndexelist[index]]
                // console.log(textlist[textIndexelist[index]]);
                arr.imgsCode = imgcode[imgindexlist[index]];
                // console.log(imgcode[imgindexlist[index]]);
                // arr.videoCode = videocode[videoIndexelist[index]];
                // console.log(videocode[videoIndexelist[index]]);

                arr.placeType = this.formLabelAlign3.placeType[0],

                  // arr.productName = this.formLabelAlign3.productNames[Math.floor(Math.random() * this.formLabelAlign3.productNames.length)]
                  arr.productName = this.formLabelAlign3.productNames.length > 0 ? (this.formLabelAlign3.productNames[Math.floor(Math.random() * this.formLabelAlign3.productNames.length)] || '').trim() : '';
                arr.virtualPositionId = this.virtualPositionvalue.join(',');

                if (this.formLabelAlign.mediaType === '2') {
                  arr.appName = this.formLabelAlign3.productNames[
                    Math.floor(Math.random() * this.formLabelAlign3.productNames.length)
                  ]
                  arr.subTitle = arr.title;
                }
                arr.materialNormId = this.formLabelAlign3.placeType[1]

                this.creativeList = [...this.creativeList, arr]
              }
            }
          }

          console.log(this.creativeList);
          if (reviewCount > 0) {
            let zsimgcode = this.zsfileCode
            // let zsvideocode = this.zsvideofileCode
            if (this.isStoreSearchPlacement) {
              // 级联三级的第 3 级才是模板类型（[0]版位21/[1]首位2或列表1/[2]模板类型）
              const templateType = Number(this.formLabelAlign3.placeType[2])
              for (let index = 0; index < reviewCount; index++) {
                let arr = {}
                arr.title = textlist[textIndexelist[index % textIndexelist.length]]
                arr.templateType = templateType
                if (this.storeTemplateNeedsImage(templateType)) {
                  // 撞审图片段按 reviewCount 取足,与撞审循环同长;撞审素材少于需求数时池内回绕复用
                  if ([14, 19].includes(templateType)) {
                    arr.imgsUrl = this.storeSearchImgUrl(this.zsfileUrl[zsimgindexlist[index]])
                  } else if (templateType === 3 || templateType === 8) {
                    // 三图模板：imgsCode 为英文逗号分隔的 string（非数组），每创意 3 张图轮转取
                    const base = zsimgindexlist[index];
                    arr.imgsCode = [0, 1, 2].map(k => zsimgcode[(base + k) % zsimgcode.length]).join(',');
                  } else {
                    arr.imgsCode = zsimgcode[zsimgindexlist[index]];
                  }
                }
                // 标签气泡（15）传专属字段 labelDesc/labelColor
                if (templateType === 15) {
                  arr.labelDesc = this.formLabelAlign3.labelDesc.trim()
                  arr.labelColor = this.formLabelAlign3.labelColor
                }
                // deepLink 挂创意上而非顶层（doc 269 creativeList 子字段）；2026-09-09 实验放开 templateType=7 限定：商店搜索全模板都带，验证平台兼容性
                if (this.idsList[key].adcreativedeeplink) {
                  arr.deeplink = this.idsList[key].adcreativedeeplink
                }
                arr.adDesc = textlist[textIndexelist[index % textIndexelist.length]]
                // 高亮一句话（16）取 15 字内短文案
                if (templateType === 16 && arr.adDesc.length > 15) {
                  arr.adDesc = arr.adDesc.slice(0, 15)
                }
                // subTitle 与 adDesc 同值（短文案，doc 269 两字段独立校验，值相同合规）
                arr.subTitle = arr.adDesc
                // 提词允许为空（2026-09-03 放开）：空时不挂 wordDtoList 字段，避免平台对空数组的未知校验；非空时正常附加
                const wordDtoList = this.storeSearchWordDtoList();
                if (wordDtoList && wordDtoList.length > 0) {
                  arr.wordDtoList = wordDtoList;
                }
                this.creativeList = [...this.creativeList, arr]
              }
            } else {
            for (let index = 0; index < reviewCount; index++) {
              let arr = {}
              arr.avatarCode = this.txfileCode[0],
                arr.title = textlist[textIndexelist[index % textIndexelist.length]]
              arr.imgsCode = zsimgcode[zsimgindexlist[index]];
              // arr.videoCode = zsvideocode[videoIndexelist[index]];

              arr.placeType = this.formLabelAlign3.placeType[0],

                // arr.productName = this.formLabelAlign3.productNames[Math.floor(Math.random() * this.formLabelAlign3.productNames.length)]
                arr.productName = this.formLabelAlign3.productNames.length > 0 ? (this.formLabelAlign3.productNames[Math.floor(Math.random() * this.formLabelAlign3.productNames.length)] || '').trim() : '';
              arr.virtualPositionId = this.virtualPositionvalue.join(',');

              if (this.formLabelAlign.mediaType === '2') {
                arr.appName = this.formLabelAlign3.productNames[
                  Math.floor(Math.random() * this.formLabelAlign3.productNames.length)
                ]
                arr.subTitle = arr.title;
              }
              arr.materialNormId = this.formLabelAlign3.placeType[1]

              this.creativeList = [...this.creativeList, arr]
            }
            }
          }
          console.log(this.creativeList);









            let payload = {
              token: this.idsList[key].token,
              ids: this.idsList[key].ids,
              idsname: this.idsList[key].idsname,
              creativeList: this.creativeList,
              groupId: g.id,
              name: this.idsList[key].planName,
              clickMonitorUrl: this.idsList[key].xiaoshuourl,
              viewMonitorUrl: this.idsList[key].baoguangurl,
              adcreativedeeplink: this.idsList[key].adcreativedeeplink,
              username: this.idsList[key].username,
              twoname: this.idsList[key].twoname,
            };
            console.log("打印一下payload");
            console.log(payload);
            console.log(this.formLabelAlign3.placeType[1]);
            console.log(this.formLabelAlign3.placeType[0]);
            if (this.formLabelAlign3.placeType[1] == 0) {
              payload = { ...payload, placeType: this.formLabelAlign3.placeType[0] }
            }
            console.log(payload);
            await this.guanggao(payload, parms1, key);
          }


          this.uploadProgress2 = (((Number(key) + 1) / this.totalTasks) * 100).toFixed(2);
        }
        this.uploadProgress2 = 100;
        if (this.percentages === 100) {
          this.isShow2 = false; // 隐藏进度条
          this.$notify({
            title: 'success',
            message: '批量搭建工程全部完成！',
            type: 'success'
          });
          if (this.errorMaterialsList.length > 0) {
            this.showErrorSummary();
          }
          this.fetchAdvRecordTodayTotal();
        }


      }

      const successCount = this.successhisstory_list.filter(item => item == '请求成功').length;
      console.log(successCount);

      if (successCount == this.idsList.length) {
        let arr = {
          idsList: this.username,
          industry: this.erjihangye,
          productLibrary: this.selectedCategoryName,
          planName: this.formLabelAlign.name,
          planBudget: this.formLabelAlign.dailyBudget,
          material: {
            // 素材只保留素材库选项，图片/视频创意及编码均不保存
            material: this.selectedLibrary
          },
          promotionGoal: this.beSelectAdType,
          deliveryChannel: this.formLabelAlign.mediaType,
          planSwitch: this.flag,
          latestPlan: this.newplanflag,
          wechatFollow: this.isguanz,
          conversionGoal: this.formLabelAlign1.cvType,
          secondBid: this.formLabelAlign1.ocpxPrice,
          audiencePackage: this.customList2,
          excludeAudiencePackage: this.customListpc,
          deliveryTime: this.timeRanges,
          deliveryDate: this.placement_time,
          installedApp: this.installedApp,
          geoTargeting: {
            geoTargeting: this.beSelectDiYu,
            isstat: this.isPreset,
            presetValue: this.presetValue,
            sex: this.sex,
            age: this.age,
            selectedVersions: this.selectedVersions,
            selectedPrices: this.selectedPrices,
            phoneseriesList: this.phoneSeriesSSelect


          },
          displayForm: this.formLabelAlign3.placeType,
          wordChoiceModel: this.formLabelAlign3.wordChoiceModel,
          generalSwitch: this.formLabelAlign3.generalSwitch,
          productName: this.formLabelAlign3.productNames,
          titleShuffle: this.daluan,
          title: this.titlesString,
          subtitle: this.zstitlesString,
          createDate: this.getCurrentDate()

        }
        // 深度优化：仅开启且填写完整时才保存，避免空值/默认值导致后端校验失败
        if (this.canDeepOpt && this.isDeepOpt && this.formLabelAlign1.secondCvType !== '' && this.formLabelAlign1.secondOcpxPrice !== '') {
          arr.secondCvType = this.formLabelAlign1.secondCvType;
          arr.secondOcpxPrice = this.formLabelAlign1.secondOcpxPrice;
          arr.isDeepOpt = true;
        }

        this.$confirm('搭建全部成功，是否保存模板？', '提示', {
          confirmButtonText: '是',
          cancelButtonText: '否',
          type: 'success'
        }).then(() => {
          // 第二步：输入模板名字
          // this.$prompt('请输入模板名称', '保存模板', {
          //   confirmButtonText: '确定',
          //   cancelButtonText: '取消',
          //   // inputPattern: /.+/,
          //   inputErrorMessage: '模板名称不能为空'
          // }).then(async({ value }) => {
          //   console.log(value);
          //   arr={...arr,templateName:value}
          //   // 第三步：调用保存接口
          //   console.log(arr);
          //   const res = await ax.post('https://control.zjwec.cn/vivoAdModel/add', arr)
          //   console.log(res);
          //   this.$message.success('保存成功')
          // }).catch(() => {
          //   console.log('取消输入模板名');
          // });
          this.$prompt('请输入模板名称', '保存模板', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            inputValidator: (value) => {
              if (!value || value.trim() === '') {
                return false; // 返回false会阻止提交
              }
              return true;
            },
            inputErrorMessage: '模板名称不能为空'
          }).then(async ({ value }) => {
            let loading = null;
            try {
              // 确保arr已定义并包含需要保存的数据
              let templateData = {
                ...arr, // 替换为您的实际数据源
                templateName: value.trim()
              };
              templateData = this.shallowStringifyAll(templateData)
              console.log(templateData);


              // 显示加载中状态
              loading = this.$loading({
                lock: true,
                text: '正在保存模板...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
              });

              // 调用接口 - 确保ax是正确配置的axios实例
              const res = await this.$axios.post('https://control.zjwec.cn/vivoAdModel/add', templateData);

              // 检查接口返回是否成功
              if (res.data.code == 0) { // 根据您的接口实际返回修改
                this.$message.success('保存成功');
              } else {
                this.$message.error(res.data.msg || '保存失败');
              }
            } catch (error) {
              console.error('保存出错:', error);
              this.$message.error('保存过程中出错');
            } finally {
              loading.close();
            }
          }).catch(err => {
            // 这里只会捕获prompt自身的取消操作
            if (err !== 'cancel') {
              console.log('输入验证失败:', err);
            } else {
              console.log('用户取消输入');
            }
          });
        }).catch(() => {
          console.log('用户选择不保存模板');
        });
      }

      this.optimizeRequests()

      // this.isLoading = false;
    },
    /**
 * 保存模板（独立函数 - Vue2写法）
 * 直接使用组件内的 data 数据
 */
    saveTemplate() {
      this.$prompt('请输入模板名称', '保存模板', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputValidator: (value) => {
          if (!value || value.trim() === '') {
            return false;
          }
          return true;
        },
        inputErrorMessage: '模板名称不能为空'
      }).then(async ({ value }) => {
        let loading = null;
        try {
          // 构建模板数据 - 直接使用组件 data 中的数据
          let templateData = {
            idsList: this.username,
            industry: this.erjihangye,
            productLibrary: this.selectedCategoryName,
            planName: this.formLabelAlign.name,
            planBudget: this.formLabelAlign.dailyBudget,
            material: {
              // 素材只保留素材库选项，图片/视频创意及编码均不保存
              material: this.selectedLibrary
            },
            promotionGoal: this.beSelectAdType,
            deliveryChannel: this.formLabelAlign.mediaType,
            planSwitch: this.flag,
            latestPlan: this.newplanflag,
            wechatFollow: this.isguanz,
            conversionGoal: this.formLabelAlign1.cvType,
            secondBid: this.formLabelAlign1.ocpxPrice,
            audiencePackage: this.customList2,
            excludeAudiencePackage: this.customListpc,
            deliveryTime: this.timeRanges,
            deliveryDate: this.placement_time,
            installedApp: this.installedApp,
            geoTargeting: {
              geoTargeting: this.beSelectDiYu,
              isstat: this.isPreset,
              presetValue: this.presetValue,
              sex: this.sex,
              age: this.age,
              selectedVersions: this.selectedVersions,
              selectedPrices: this.selectedPrices,
              phoneseriesList: this.phoneSeriesSSelect
            },
            displayForm: this.formLabelAlign3.placeType,
            wordChoiceModel: this.formLabelAlign3.wordChoiceModel,
            generalSwitch: this.formLabelAlign3.generalSwitch,
            productName: this.formLabelAlign3.productNames,
            titleShuffle: this.daluan,
            title: this.titlesString,
            subtitle: this.zstitlesString,
            createDate: this.getCurrentDate(),
            templateName: value.trim()
          };

          // 深度优化：仅开启且填写完整时才保存，避免空值/默认值导致后端校验失败
          if (this.canDeepOpt && this.isDeepOpt && this.formLabelAlign1.secondCvType !== '' && this.formLabelAlign1.secondOcpxPrice !== '') {
            templateData.secondCvType = this.formLabelAlign1.secondCvType;
            templateData.secondOcpxPrice = this.formLabelAlign1.secondOcpxPrice;
            templateData.isDeepOpt = true;
          }

          // 将对象中的所有值转换为字符串（用于存储）
          templateData = this.shallowStringifyAll(templateData);
          console.log('保存模板数据:', templateData);

          // 显示加载中状态
          loading = this.$loading({
            lock: true,
            text: '正在保存模板...',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          });

          // 调用接口
          const res = await this.$axios.post('https://control.zjwec.cn/vivoAdModel/add', templateData);

          // 检查接口返回
          if (res.data.code == 0) {
            this.$message.success('保存成功');
          } else {
            this.$message.error(res.data.msg || '保存失败');
          }
        } catch (error) {
          console.error('保存出错:', error);
          this.$message.error('保存过程中出错');
        } finally {
          if (loading) {
            loading.close();
          }
        }
      }).catch(err => {
        // 用户取消输入
        if (err !== 'cancel') {
          console.log('输入验证失败:', err);
        } else {
          console.log('用户取消保存模板');
        }
      });
    },
    shuffleArray(array) {
      const newArray = [...array]; // 创建副本，不影响原数组
      for (let i = newArray.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [newArray[i], newArray[j]] = [newArray[j], newArray[i]]; // 交换元素
      }
      return newArray;
    },
    getBuildvideoIndexes(countPerBuild) {
      if (!this.videofileCode.length) return
      const indexes = [];

      for (let i = 0; i < countPerBuild; i++) {
        // console.log(this.tpfileListcode.length);
        const index = (this.currentIndexvideo + i) % this.videofileCode.length;
        indexes.push(index);
      }

      this.currentIndexvideo = (this.currentIndexvideo + countPerBuild) % this.videofileCode.length;

      return indexes;
    },
    getBuildIndexes(countPerBuild) {
      if (!this.fileCode.length) return
      const indexes = [];

      for (let i = 0; i < countPerBuild; i++) {
        // console.log(this.tpfileListcode.length);
        const index = (this.currentIndeximg + i) % this.fileCode.length;
        indexes.push(index);
      }

      this.currentIndeximg = (this.currentIndeximg + countPerBuild) % this.fileCode.length;

      return indexes;
    },
    getzsBuildIndexes(countPerBuild) {
      if (!this.zsfileCode.length) return
      const indexes = [];
      // this.zsVideofileList

      for (let i = 0; i < countPerBuild; i++) {
        // console.log(this.tpfileListcode.length);
        const index = (this.currentIndexzsimg + i) % this.zsfileCode.length;
        indexes.push(index);
      }

      this.currentIndexzsimg = (this.currentIndexzsimg + countPerBuild) % this.zsfileCode.length;

      return indexes;
    },
    getzsBuildvideoIndexes(countPerBuild) {
      if (!this.zsvideofileCode.length) return
      const indexes = [];

      for (let i = 0; i < countPerBuild; i++) {
        // console.log(this.tpfileListcode.length);
        const index = (this.currentIndexzsvideo + i) % this.zsvideofileCode.length;
        indexes.push(index);
      }

      this.currentIndexzsvideo = (this.currentIndexzsvideo + countPerBuild) % this.zsvideofileCode.length;

      return indexes;
    },
    getBuildtextIndexes(countPerBuild) {
      let res = this.titlesString
        .split('\n')
        .map(line => line.trim())
        .filter(line => line); // 去除空行
      if (!res.length) return
      const indexes = [];

      for (let i = 0; i < countPerBuild; i++) {
        // console.log(this.tpfileListcode.length);
        const index = (this.currentIndextext + i) % res.length;
        indexes.push(index);
      }

      this.currentIndextext = (this.currentIndextext + countPerBuild) % res.length;

      return indexes;
    },
    getSecureRandomIndex(max) {
      const array = new Uint32Array(1);
      window.crypto.getRandomValues(array);
      return array[0] % (max + 1);
    },

    deduplicateById(list) {
      const seen = new Set();
      return list.filter(item => {
        if (!seen.has(item.id)) {
          seen.add(item.id);
          return true;
        }
        return false;
      });
    },

    async findIds() {
      this.erroridslist = []
      let list = this.username.split('\n').map(line => line.trim()).filter(line => line);
      this.idsList = []; // 清空数组

      if (!list.length) {
        return
      }

      try {
        // 批量查询最新账户数据：一次请求查所有账户名，返回顺序与传入一致，查不到的不会出现在 data 里
        const res = await axios.post('https://control.zjwec.cn/api/batchuser/queryByNames', list)
        if (res.data.code !== '0') {
          console.error('查询失败:', res.data.msg)
          return
        }

        // 按原始输入顺序展开：重复账户名生成多条（重复搭建需求），查不到的跳过
        const dataMap = new Map((res.data.data || []).map(item => [item.idsname, item]))
        this.idsList = list.map(name => dataMap.get(name)).filter(item => item)
        const newList = this.deduplicateById(this.idsList);
        const requests = newList.map(item => {
          return axios.get('https://control.zjwec.cn/api/bindzh/checkUuid', {
            params: { uuid: item.ids }
          }).then(response => {
            console.log(response);
            // 判断 code 是否为 "0"，不是就保留
            if (response.data.code == "0") {
              return item; // 返回原始 item
            } else {
              this.erroridslist = [...this.erroridslist, item]
              return null; // 成功的忽略
            }
          }).catch(() => {
            // 请求失败也保留
            return item;
          });
        });

        const results2 = await Promise.all(requests);
        console.log(this.erroridslist);


        console.log("最终结果:", this.idsList); // 正确打印结果
      } catch (error) {
        console.error("请求失败:", error);
      }
    }
    ,
    ro() {
      this.formLabelAlign3.title = []

    },
    //刷新信息
    async GetRo() {

      let time1 = parseInt(new Date().getTime()) + '';
      console.log(time1)

      await axios.post('https://test.nbweiou.cn/api/get_vivo_user', {
        'username': this.username
      }).then(
        res => {
          this.two = res.data
          // for (let key in res.data){
          //   this.twoName[key]=res.data[key].twoname
          //   this.towToken[key]=res.data[key].token
          // }
        }
      )
    },
    //停止计划api
    async stopPlan(parms) {
      let flag1 = 0;
      if (this.flag === false) {
        flag1 = 1
      } else {
        flag1 = 0;
      }

      let time1 = parseInt(new Date().getTime()) + '';
      let nonce = Math.round(Math.random() * 100000000000)
      await axios.post('api/openapi/v1/ad/campaign/pause/toggle?access_token=' + parms.token + '&timestamp=' + time1 + '&nonce=' + nonce + '&advertiser_id=' + parms.ids + '',
        {
          "ids": parms.campaignId,
          "startAndStop": flag1
        }).then(res => {

          //推广计划id id
        })
    },
    // 搭建计划api1
    async plan(parms) {
      let time1 = parseInt(new Date().getTime()) + '';
      let nonce = Math.round(Math.random() * 100000000000)
      let adtypes = 1;
      let names = '';
      const url = this.idsList[parms.id].url || ''; // 取 url，如果不存在则为 ''
      if (url.substring(0, 2) === "ht") {
        adtypes = this.beSelectAdType;
        names = parms.name + '_' + time1 + '_' + 'https_' + this.formLabelAlign.name;
      } else if (url.substring(0, 2) === "ha") {
        adtypes = this.beSelectAdType;
        names = parms.name + '_' + time1 + '_' + 'hap_' + this.formLabelAlign.name;
      } else {
        adtypes = this.beSelectAdType;
        names = parms.name + '_' + time1 + '_' + 'hap_' + this.formLabelAlign.name;
      }

      if (parms.dailyBudget === '') {
        parms.dailyBudget = -1
      } else {
        parms.dailyBudget = parms.dailyBudget * 100000
      }

      if (this.artistName) {
        names = names + '_' + this.artistName
      }

      const planAccInfo = this.idsList[parms.id] || {};
      const planAname = planAccInfo.idsname || '';
      const planAid = planAccInfo.ids || '';

      await axios.post('api/openapi/v1/ad/campaign/add?access_token=' + parms.token + '&timestamp=' + time1 + '&nonce=' + nonce + '&advertiser_id=' + parms.ids + '',

        {
          name: names,
          adType: adtypes,
          mediaType: parms.mediaType,
          dailyBudget: parms.dailyBudget,
          optimizeFlag: 0,
          campaignType: 0,
          conversionMonitorType: this.formLabelAlign.conversionMonitorType

        }).then(res => {

          if (res.data.code !== 0) {
            this.$notify({
              title: '创建失败',
              message: res.data.message,
              type: 'error'
            });
            this.addBuildLog(planAname, planAid, '计划搭建', '失败', names, res.data.message);
          } else {
            this.addBuildLog(planAname, planAid, '计划搭建', '成功', names, '计划ID: ' + res.data.data.id);
          }
          console.log(res.data.data.id);
          this.idsList[parms.id].planId = res.data.data.id
          if (this.newplanflag == true) {
            // this.ePlanId= res.data.data.id
            const targetIdsName = this.idsList[parms.id].idsname;
            // 遍历并更新符合条件的项
            this.idsList.forEach(item => {
              if (item.idsname == targetIdsName) {
                item.campaignId = res.data.data.id;
              }
            });

          }
          console.log(res.data);

          //推广计划id id
        })

    },
    // 搭建广告组api
    async ground(parms, index) {


      let price = 0;
      // let price1=30000;
      if (this.formLabelAlign.mediaType === '1') {
        price = 999000
      } else {
        price = 10000
      }
      // 当前转化目标是否为 oCPD（100-131 系列）：是则走按转化目标出价形态（chargeType=5、价格走 price、ocpxPrice 置 0），否则原样上报 oCPC（chargeType=3）
      const isOcpdCvType = OCPD_CV_TYPES.includes(String(this.formLabelAlign1.cvType || ''));
      let map = {};
      if (this.flag1 === true) {
        map["customList"] = this.customListrqb;

      }
      if (this.flag2 === true) {
        map["excludeCustomList"] = this.customListrqbpc;

      }

      // this.erjihangye[0] this.erjihangye[1]
      // this.zzIdList中的子对象industry1和 industry2值
      // 配对后根据adType的值去：快应用选英文的产品名 否则就选网址
      // this.beSelectAdType 被选中的广告类型
      this.zjerji = this.erjihangye

      if (this.zjerji[0] && typeof this.zjerji[0] === 'string') {
        this.zjerji[0] = this.zjerji[0].replace(/["']/g, ''); // 去除双引号或单引号
      }

      if (this.zjerji[1] && typeof this.zjerji[1] === 'string') {
        this.zjerji[1] = this.zjerji[1].replace(/["']/g, ''); // 去除双引号或单引号
      }
      console.log(this.zzIdList)
      console.log(this.beSelectAdType)
      console.log(this.zjerji)
      // 1. 找到符合条件的对象
      let targetObject = this.zzIdList.find(obj => obj.industry1 === Number(this.zjerji[0]) && obj.industry2 === Number(this.zjerji[1]));


      console.log(targetObject);
      // 2. 如果找到了目标对象
      if (targetObject) {
        console.log("测试测试测试测试从999999999999999999999");
        console.log(targetObject);
        let advertiseQualificationList = targetObject.advertiseQualificationList;

        // 获取上面选中的值（假设是 selectedProductName）
        // 这个变量名请根据您的实际代码调整
        const selectedProductName = this.selectedOption; // 请替换为实际的变量名
        console.log(selectedProductName);

        // 3. 根据beSelectAdType的值判断
        // this.advertiseQualificationId = advertiseQualificationList.filter(item => {
        //   console.log(item)
        //   console.log(this.beSelectAdType);


        //   console.log(item.productName);

        //   // 先检查是否匹配选中的productName（如果selectedProductName存在）
        //   console.log("selectedProductName && item.productName != selectedProductName && this.isChecked打印！！！");
        //   console.log(selectedProductName);
        //   console.log(item.productName);
        //   console.log(this.isChecked);
        //   if (selectedProductName && item.productName != selectedProductName && this.isChecked) {
        //     console.log("false");
        //     return false; // 如果不匹配选中的值，直接过滤掉
        //   }
        //   console.log("selectedProductName匹配上了");

        //   if (this.beSelectAdType == 8 || this.beSelectAdType == 2) {
        //     // 匹配：com/shou/package/cn 开头，或 mp.qk.mqjc，或全中文
        //     const result = /^(com|shou|package|cn)/.test(item.productName)
        //       || item.productName === 'mp.qk.mqjc'
        //       || /^[\u4e00-\u9fa5]+$/.test(item.productName);
        //     console.log(result);
        //     return result;
        //   } else if (this.beSelectAdType == 11) {
        //     // 当 beSelectAdType 为 11 时
        //     return /小程序/.test(item.productDescription);
        //   } else {
        //     // 其他情况
        //     // 不匹配以 com/shou/package 开头 且 不等于 "mp.qk.mqjc"，并且 productType 为 1
        //     const result = !/^(com|shou|package)/.test(item.productName) &&
        //       item.productName !== 'mp.qk.mqjc' &&
        //       item.productType === 1;
        //     console.log(result);
        //     return result;
        //   }
        // }).map(item => item.advertiseQualificationId); // 获取advertiseQualificationId



        this.advertiseQualificationId = advertiseQualificationList.filter(item => {
          console.log(item);
          console.log(item.productName);

          // 先检查是否匹配选中的productName（如果selectedProductName存在）
          console.log("selectedProductName && item.productName != selectedProductName && this.isChecked打印！！！");
          console.log(selectedProductName);
          console.log(item.productName);
          console.log(this.isChecked);

          if (selectedProductName && item.productName != selectedProductName && this.isChecked) {
            console.log("false");
            return false; // 如果不匹配选中的值，直接过滤掉
          }
          console.log("selectedProductName匹配上了");

          // ========== 简化后的逻辑：只要 productType 为 1 或 3 就返回 true ==========
          // 根据您的数据，productType: 1 是网址推广，productType: 3 是应用推广
          console.log(item.productType);
          const result = item.productType === 1 || item.productType === 2 || item.productType === 3 || item.productType === 4;
          console.log('productType:', item.productType, '结果:', result);
          return result;

        }).map(item => item.advertiseQualificationId);

        console.log("输出结果:", this.advertiseQualificationId); // 输出结果
      } else {
        console.log("没有找到符合条件的对象");
      }
      // if(this.beSelectAdType == 11){
      //   this.advertiseQualificationId=targetObject.advertiseQualificationList[this.erjihangyenumber]
      // }
      // console.log(this.advertiseQualificationId);

      // return
      const isPreset = this.isPreset === true;
      const regionCodeList = isPreset
        ? this.presetValue.regionList
        : (this.regionStatus === 1 && this.beSelectMap && this.beSelectMap.map)
          ? this.beSelectMap.map.region.regionCodeList
          : [];
      const ageList = isPreset ? this.presetValue.ageList : this.ageIdList;
      const phonePriceSet = isPreset ? this.presetValue.phonepriceList : this.selectedPrices;
      const androidVersionSet = isPreset ? this.presetValue.androidList : this.selectedVersions;


      map["sexList"] = this.sexList;
      // 地域定向：不限时不传，设置时传入选中的值
      if (regionCodeList.length > 0 && (isPreset || this.regionStatus === 1)) {
        map["region"] = { regionCodeList, stayType: 1 };
      }
      map["ageList"] = ageList;

      // 购机价格：不限时不传，设置时传入选中的值
      if (this.phonePriceStatus === 1 && phonePriceSet.length > 0) {
        map["phonePriceSet"] = phonePriceSet;
      }

      // 安卓版本：不限时不传，设置时传入选中的值
      if (this.androidVersionStatus === 1 && androidVersionSet.length > 0) {
        map["androidVersionSet"] = androidVersionSet;
      }

      // 手机系列：不限时不传，设置时传入选中的值
      if (this.phoneSeriesstatus === 1 && this.phoneSeriesSSelect.length > 0) {
        map["phoneSeriesSet"] = this.phoneSeriesSSelect;
      }
      if (this.installedApp) {
        map["installedApp"] = this.installedApp;
      }


      let time1 = parseInt(new Date().getTime()) + '';
      let nonce = Math.round(Math.random() * 100000000000)

      // return

      const account = this.idsList[parms.id] || {};
      const url = account.url || '';  // 防止 url 为 null/undefined
      if (url.substr(0, 2) === 'ht') {

        // 判断this.beSelectCategory是否为空数组来决定是否添加属性
        let data = {
          // wechatFollow:1,
          audienceInfo: map,

          campaignId: parms.campaignId,
          webSiteUrl: parms.webSiteUrl,
          startDate: this.startDate,
          endDate: this.endDate,
          h5Type: 2,
          scheduleTime: '111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111',
          chargeType: 3,
          price: price,
          cvType: this.formLabelAlign1.cvType,
          ocpxPrice: parms.ocpxPrice,
          name: parms.name + '_' + time1 + '_' + this.formLabelAlign.name + '_' + this.artistName,
          dailyBudget: -1,
          spentType: 1,
          biddingStrategy: 0,
          // builtInRpkDeepLink: parms.builtInRpkDeepLink,
        }
        // 渠道号/渠道包id：账户有值才传，为 null 不传
        if (parms.channelId !== null && parms.channelId !== undefined) {
          data.channelId = parms.channelId
        }
        if (parms.apkId !== null && parms.apkId !== undefined) {
          data.apkId = parms.apkId
        }
        // 深度优化转化目标：仅自定义激活/注册/拉活且开启且填写后传入
        if (this.canDeepOpt && this.isDeepOpt && this.formLabelAlign1.secondCvType !== '' && this.formLabelAlign1.secondOcpxPrice !== '') {
          data = { ...data, secondCvType: this.formLabelAlign1.secondCvType, secondOcpxPrice: new Decimal(this.formLabelAlign1.secondOcpxPrice).mul(100000).toNumber() }
        }
        // oCPD 转化目标：按转化目标出价（chargeType=5、价格走 price、ocpxPrice 置 0）；oCPC 目标原样上报，不再强制改写为 102
        if (isOcpdCvType) {
          data = { ...data, chargeType: 5, price: Math.round(this.formLabelAlign1.ocpxPrice * 100000), ocpxPrice: 0 }
        }
        if (this.isoldgroupscheduleTime) {
          if (this.oldGroupscheduleTime) {
            data = { ...data, scheduleTime: this.oldGroupscheduleTime }
          }
        }
        if (this.beSelectAdType != 11) {
          data = { ...data, builtInRpkDeepLink: parms.builtInRpkDeepLink, }

        }

        if (this.isguanz) {
          data.wechatFollow = 1
        } else {
          data.wechatFollow = 0
        }

        if (this.beSelectAdType == 11) {
          data = {
            ...data, appletPath: this.idsList[index].adcreativedeeplink,
            appletOriginId: this.idsList[index].builtInRpkDeepLink
          }
        }
        // 周期稳投
        if (this.isdeliveryScene) {
          data.groupSteadyDeliverySwitch = true
          data.deliveryScene = 0
        }

        if (this.advertiseQualificationId === '' || this.advertiseQualificationId === undefined) {
          data.industry1 = this.zjerji[0]
          data.industry2 = this.zjerji[1]
        } else {
          data.advertiseQualificationId = this.advertiseQualificationId[0]
        }
        // 如果 this.beSelectCategory 不是空数组，添加 categoryId 属性
        if (this.beSelectCategory && Object.keys(this.beSelectCategory).length > 0) {
          data.productSDpa = {
            productId: this.beSelectCategory.id,
            productName: this.beSelectCategory.name
          }
          data.dpaGoodsConfig = {
            cpId: this.beSelectCategory.productLibraryId,
            categories: [
              {
                categoryId: this.beSelectCategory.thirdCategoryId,
                categoryLevel: 3
              }
            ]
          }
          // 将 beSelectCategory 作为 categoryId 添加
        }
        console.log("this.formLabelAlign1.nobidBiddingStrategy");
        console.log(this.formLabelAlign1.nobidBiddingStrategy);
        // if (this.formLabelAlign1.nobidBiddingStrategy == 1) {

        //   // data.dailyBudget = this.formLabelAlign1.dailyBudget;
        //   data.dailyBudget = this.yuanToMills(this.formLabelAlign1.dailyBudget);
        //   data.nobidBiddingStrategy = Number(this.formLabelAlign1.nobidBiddingStrategy)
        //   data.biddingStrategy = null
        //   data.chargeType = 3
        //   data.cvType = 12,
        //     data.ocpxPrice = "";
        //   data.price = "";


        // }
        await axios.post('api/openapi/v1/ad/group/add?access_token=' + parms.token + '&timestamp=' + time1 + '&nonce=' + nonce + '&advertiser_id=' + parms.ids,
          data).then(res => {
            if (res.data.code !== 0) {
              this.$notify({
                title: '创建失败',
                message: res.data.message,
                type: 'error'
              });
              this.addBuildLog((this.idsList[parms.id] || {}).idsname || '', (this.idsList[parms.id] || {}).ids || '', '广告组搭建', '失败', parms.name, res.data.message);
            } else {
              console.log(res);
              this.idsList[parms.id].groundId = res.data.data
              this.addBuildLog((this.idsList[parms.id] || {}).idsname || '', (this.idsList[parms.id] || {}).ids || '', '广告组搭建', '成功', parms.name, '广告组ID: ' + res.data.data);
            }
            //广告组ID

          })
      } else if (url.substr(0, 2) === 'ha') {
        const gdInfoHa = this.idsList[parms.id] || {};
        let data = {
          audienceInfo: map,
          // industry1:2100023,
          // industry2:2220187,
          // advertiseQualificationId: this.advertiseQualificationId[0],
          campaignId: parms.campaignId,
          rpkDeepLink: parms.webSiteUrl,
          startDate: this.startDate,
          endDate: this.endDate,
          scheduleTime: '111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111',
          chargeType: 3,
          price: price,

          cvType: this.formLabelAlign1.cvType,
          ocpxPrice: parms.ocpxPrice,
          name: parms.name + '_' + time1 + '_' + this.formLabelAlign.name + '_' + this.artistName,
          dailyBudget: -1,
          spentType: 1,
          biddingStrategy: 0
        }
        // 渠道号/渠道包id：账户有值才传，为 null 不传
        if (parms.channelId !== null && parms.channelId !== undefined) {
          data.channelId = parms.channelId
        }
        if (parms.apkId !== null && parms.apkId !== undefined) {
          data.apkId = parms.apkId
        }
        // 深度优化转化目标：仅自定义激活/注册/拉活且开启且填写后传入
        if (this.canDeepOpt && this.isDeepOpt && this.formLabelAlign1.secondCvType !== '' && this.formLabelAlign1.secondOcpxPrice !== '') {
          data = { ...data, secondCvType: this.formLabelAlign1.secondCvType, secondOcpxPrice: new Decimal(this.formLabelAlign1.secondOcpxPrice).mul(100000).toNumber() }
        }
        // oCPD 转化目标：按转化目标出价（chargeType=5、价格走 price、ocpxPrice 置 0）；oCPC 目标原样上报，不再强制改写为 102
        if (isOcpdCvType) {
          data = { ...data, chargeType: 5, price: Math.round(this.formLabelAlign1.ocpxPrice * 100000), ocpxPrice: 0 }
        }
        if (this.isoldgroupscheduleTime) {
          if (this.oldGroupscheduleTime) {
            data = { ...data, scheduleTime: this.oldGroupscheduleTime }
          }
        }
        if (this.beSelectAdType == 11) {
          data = {
            ...data, appletPath: this.idsList[index].adcreativedeeplink,
            appletOriginId: this.idsList[index].builtInRpkDeepLink
          }
        }

        if (this.isguanz) {
          data.wechatFollow = 1
        } else {
          data.wechatFollow = 0
        }

        // 周期稳投
        if (this.isdeliveryScene) {
          data.groupSteadyDeliverySwitch = true
          data.deliveryScene = 0
        }

        if (this.advertiseQualificationId === '' || this.advertiseQualificationId === undefined) {
          data.industry1 = this.zjerji[0]
          data.industry2 = this.zjerji[1]
        } else {
          data.advertiseQualificationId = this.advertiseQualificationId[0]
        }
        if (this.beSelectCategory && Object.keys(this.beSelectCategory).length > 0) {
          data.productSDpa = {
            productId: this.beSelectCategory.id,
            productName: this.beSelectCategory.name
          }
          data.dpaGoodsConfig = {
            cpId: this.beSelectCategory.productLibraryId,
            categories: [
              {
                categoryId: this.beSelectCategory.thirdCategoryId,
                categoryLevel: 3
              }
            ]
          }
          // 将 beSelectCategory 作为 categoryId 添加
        }
        console.log("this.formLabelAlign1.nobidBiddingStrategy");
        console.log(this.formLabelAlign1.nobidBiddingStrategy);
        // if(this.formLabelAlign1.nobidBiddingStrategy==1){
        //   data.chargeType= 3
        //   data.cvType= 12,
        //   // "": 12,
        //   data.nobidBiddingStrategy=this.formLabelAlign1.nobidBiddingStrategy
        //   data.dailyBudget=this.formLabelAlign1.dailyBudget
        //   data.biddingStrategy=null
        // }
        // if(this.formLabelAlign1.nobidBiddingStrategy==1){
        //   data.chargeType= 3
        //   data.cvType= 12,
        //   // "": 12,
        //   data.nobidBiddingStrategy=this.formLabelAlign1.nobidBiddingStrategy
        //   data.dailyBudget = this.formLabelAlign1.dailyBudget;
        //   data.biddingStrategy=null
        //   data.ocpxPrice = null;
        //   data.price = "";
        // }
        // if (this.formLabelAlign1.nobidBiddingStrategy == 1) {

        //   // data.dailyBudget = this.formLabelAlign1.dailyBudget;
        //   data.dailyBudget = this.yuanToMills(this.formLabelAlign1.dailyBudget);
        //   data.nobidBiddingStrategy = Number(this.formLabelAlign1.nobidBiddingStrategy)
        //   data.biddingStrategy = null
        //   data.chargeType = 3
        //   data.cvType = 12,
        //   data.ocpxPrice = "";
        //   data.price = "";


        // }

        await axios.post('api/openapi/v1/ad/group/add?access_token=' + parms.token + '&timestamp=' + time1 + '&nonce=' + nonce + '&advertiser_id=' + parms.ids,
          data).then(res => {
            if (res.data.code !== 0) {
              this.$notify({
                title: '创建失败',
                message: res.data.message,
                type: 'error'
              });
              this.addBuildLog((this.idsList[parms.id] || {}).idsname || '', (this.idsList[parms.id] || {}).ids || '', '广告组搭建', '失败', parms.name, res.data.message);
            } else {
              console.log(res);
              this.idsList[parms.id].groundId = res.data.data
              this.addBuildLog((this.idsList[parms.id] || {}).idsname || '', (this.idsList[parms.id] || {}).ids || '', '广告组搭建', '成功', parms.name, '广告组ID: ' + res.data.data);
            }
            //广告组ID

          })
      } else if (this.beSelectAdType == 2) {

        let data = {
          audienceInfo: map,
          // industry1:2100023,
          // industry2:2220187,
          // advertiseQualificationId: this.advertiseQualificationId[0],
          campaignId: parms.campaignId,
          startDate: this.startDate,
          endDate: this.endDate,
          scheduleTime: '111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111',
          chargeType: 3,
          price: price,

          cvType: this.formLabelAlign1.cvType,
          ocpxPrice: parms.ocpxPrice,
          name: parms.name + '_' + time1 + '_' + this.formLabelAlign.name + '_' + this.artistName,
          dailyBudget: -1,
          spentType: 1,
          biddingStrategy: 0
        }
        // 渠道号/渠道包id：账户有值才传，为 null 不传
        if (parms.channelId !== null && parms.channelId !== undefined) {
          data.channelId = parms.channelId
        }
        if (parms.apkId !== null && parms.apkId !== undefined) {
          data.apkId = parms.apkId
        }
        // 深度优化转化目标：仅自定义激活/注册/拉活且开启且填写后传入
        if (this.canDeepOpt && this.isDeepOpt && this.formLabelAlign1.secondCvType !== '' && this.formLabelAlign1.secondOcpxPrice !== '') {
          data = { ...data, secondCvType: this.formLabelAlign1.secondCvType, secondOcpxPrice: new Decimal(this.formLabelAlign1.secondOcpxPrice).mul(100000).toNumber() }
        }
        if (this.beSelectAdType == 2 && this.formLabelAlign.mediaType == 0) {
          let time1 = parseInt(new Date().getTime()) + '';
          let nonce = Math.round(Math.random() * 100000000000);
          let res = await axios.post(
            'api/openapi/v1/app/list?access_token=' + parms.token + '&timestamp=' + time1 + '&nonce=' + nonce + '&advertiser_id=' + parms.ids,
            { mediaType: this.formLabelAlign.mediaType }
          );
          console.log(res);

          // 安全取值：先取数组，再取第一个元素（可能为空）
          const appList = res.data.data || [];
          const appInfo = appList[0] || {};

          // data = {
          //   ...data,
          //   audienceInfo: { ...map, region: null, androidVersionSet: [] },
          //   appId: appInfo.appId,
          //   appPackage: appInfo.appPackage,
          //   appPackageName: appInfo.appPackage,
          //   chargeType: 4,
          //   cvType: null,
          //   price: Math.round(this.formLabelAlign1.ocpxPrice * 100000),
          //   ocpxPrice: 0
          // };
          if (this.formLabelAlign1.cvType) {
            const appFields = {
              audienceInfo: { ...map, region: null, androidVersionSet: [] },
              appId: appInfo.appId,
              appPackage: appInfo.appPackage,
              appPackageName: appInfo.appPackage,
            };
            if (isOcpdCvType) {
              // oCPD 转化目标：按转化目标出价（商店），价格走 price、ocpxPrice 置 0
              data = {
                ...data, ...appFields,
                chargeType: 5,
                cvType: this.formLabelAlign1.cvType,
                price: Math.round(this.formLabelAlign1.ocpxPrice * 100000),
                ocpxPrice: 0
              }
            } else {
              // oCPC 转化目标：按转化出价原样上报，不再强制改写为 102
              data = {
                ...data, ...appFields,
                chargeType: 3,
                cvType: this.formLabelAlign1.cvType
              }
            }

          } else {
            data = {
              ...data,
              audienceInfo: { ...map, region: null, androidVersionSet: [] },
              appId: appInfo.appId,
              appPackage: appInfo.appPackage,
              appPackageName: appInfo.appPackage,
              chargeType: 4,
              cvType: null,
              price: Math.round(this.formLabelAlign1.ocpxPrice * 100000),
              ocpxPrice: 0
            }
          }
        }


        if (this.isoldgroupscheduleTime) {
          if (this.oldGroupscheduleTime) {
            data = { ...data, scheduleTime: this.oldGroupscheduleTime }
          }
        }

        // 周期稳投
        if (this.isdeliveryScene) {
          data.groupSteadyDeliverySwitch = true
          data.deliveryScene = 0
        }
        if (this.beSelectAdType == 2 && this.formLabelAlign.mediaType == 0) { } else {
          if (this.advertiseQualificationId === '' || this.advertiseQualificationId === undefined) {
            data.industry1 = this.zjerji[0]
            data.industry2 = this.zjerji[1]
          } else {
            data.advertiseQualificationId = this.advertiseQualificationId[0]
          }
        }

        if (this.beSelectCategory && Object.keys(this.beSelectCategory).length > 0) {
          data.productSDpa = {
            productId: this.beSelectCategory.id,
            productName: this.beSelectCategory.name
          }
          data.dpaGoodsConfig = {
            cpId: this.beSelectCategory.productLibraryId,
            categories: [
              {
                categoryId: this.beSelectCategory.thirdCategoryId,
                categoryLevel: 3
              }
            ]
          }
          // 将 beSelectCategory 作为 categoryId 添加
        }
        console.log("this.formLabelAlign1.nobidBiddingStrategy");
        console.log(this.formLabelAlign1.nobidBiddingStrategy);
        // if(this.formLabelAlign1.nobidBiddingStrategy==1){
        //   data.chargeType= 3
        //   data.cvType= 12,
        //   // "": 12,
        //   data.nobidBiddingStrategy=this.formLabelAlign1.nobidBiddingStrategy
        //   data.dailyBudget=this.formLabelAlign1.dailyBudget
        //   data.biddingStrategy=null
        // }
        // if(this.formLabelAlign1.nobidBiddingStrategy==1){
        //   data.chargeType= 3
        //   data.cvType= 12,
        //   // "": 12,
        //   data.nobidBiddingStrategy=this.formLabelAlign1.nobidBiddingStrategy
        //   data.dailyBudget = this.formLabelAlign1.dailyBudget;
        //   data.biddingStrategy=null
        //   data.ocpxPrice = null;
        //   data.price = "";
        // }
        // if (this.formLabelAlign1.nobidBiddingStrategy == 1) {

        //   // data.dailyBudget = this.formLabelAlign1.dailyBudget;
        //   data.dailyBudget = this.yuanToMills(this.formLabelAlign1.dailyBudget);
        //   data.nobidBiddingStrategy = Number(this.formLabelAlign1.nobidBiddingStrategy)
        //   data.biddingStrategy = null
        //   data.chargeType = 3
        //   data.cvType = 12,
        //   data.ocpxPrice = "";
        //   data.price = "";


        // }

        await axios.post('api/openapi/v1/ad/group/add?access_token=' + parms.token + '&timestamp=' + time1 + '&nonce=' + nonce + '&advertiser_id=' + parms.ids,
          data).then(res => {
            if (res.data.code !== 0) {
              this.$notify({
                title: '创建失败',
                message: res.data.message,
                type: 'error'
              });
              this.addBuildLog((this.idsList[parms.id] || {}).idsname || '', (this.idsList[parms.id] || {}).ids || '', '广告组搭建', '失败', parms.name, res.data.message);
            } else {
              console.log(res);
              this.idsList[parms.id].groundId = res.data.data
              this.addBuildLog((this.idsList[parms.id] || {}).idsname || '', (this.idsList[parms.id] || {}).ids || '', '广告组搭建', '成功', parms.name, '广告组ID: ' + res.data.data);
            }
            //广告组ID

          })
      }
    },
    yuanToMills(yuan) {
      return (Number(yuan) * 100000).toString();
    },
    // shuffleArray(array) {
    //   // 复制原数组，避免对其进行修改
    //   const newArray = [...array];
    //   const length = newArray.length;

    //   // 从数组末尾开始，向前遍历每个元素
    //   for (let i = length - 1; i > 0; i--) {
    //     // 生成一个范围在 0 到 i 之间（包含 0 和 i）的随机整数
    //     const j = Math.floor(Math.random() * (i + 1));

    //     // 交换当前元素（索引为 i）和随机选中元素（索引为 j）的位置
    //     [newArray[i], newArray[j]] = [newArray[j], newArray[i]];
    //   }

    //   return newArray;
    // },
    async placeTypeChange(data) {
      console.log(this.fileList);
      console.log(this.VideofileList);
      if (!this.formLabelAlign.mediaType) {
        this.$message.warning('请选择投放渠道后重选');
        return;
      }
      if (!this.beSelectAdType) {
        this.$message.warning('请选择推广目标后重选');
        return;
      }

      // 搜索提词版位（placeType=21）无虚拟位置（投放位置），直接跳过位置查询
      if (Array.isArray(data) && String(data[0]) === '21') {
        this.virtualPositionoptions = [];
        this.virtualPositionvalue = [];
        return;
      }

      console.log('data:', data);
      console.log(this.idsList);

      // 账户校验：没有有效账户时直接提示，避免用空/占位 token（如 "1"）发起无效请求
      if (!this.idsList || !this.idsList.length || !this.idsList[0].token || !this.idsList[0].ids) {
        this.$message.error('未查询到有效账户，请先在“账户名”中查询账户后再试');
        this.virtualPositionoptions = [];
        this.virtualPositionvalue = [];
        return;
      }

      let time1 = parseInt(new Date().getTime()) + '';
      let nonce = Math.round(Math.random() * 100000000000);
      let data1 = {
        normId: parseInt(data[1]) || 0,
        mediaType: parseInt(this.formLabelAlign.mediaType) || 0,
        adType: parseInt(this.beSelectAdType) || 0,
        displayType: parseInt(data[0]) || 0
      };

      try {
        const res = await axios.post('api/openapi/v1/ad/positionList/virtualPositionList?access_token=' + this.idsList[0].token + '&timestamp=' + time1 + '&nonce=' + nonce + '&advertiser_id=' + this.idsList[0].ids + '', data1);
        console.log(res);
        // 接口返回业务错误（如 access_token 不合法）时，提示具体原因并清空，避免直接卡在加载中
        if (res.data.code !== 0 && res.data.code !== '0') {
          this.$message.error('虚拟投放位置获取失败：' + (res.data.message || res.data.msg || '未知错误'));
          this.virtualPositionoptions = [];
          this.virtualPositionvalue = [];
          return;
        }
        const list = res.data.data || [];
        this.virtualPositionoptions = list;
        this.virtualPositionvalue = list.map(item => item.virtualPositionUuid);
        console.log(this.virtualPositionvalue);
      } catch (e) {
        console.error(e);
        this.$message.error('虚拟投放位置获取失败，请稍后重试');
        this.virtualPositionoptions = [];
        this.virtualPositionvalue = [];
      }
    },
    // 搜索提词版位：撞审标题按行拆分为关键词（每行一个词，单词≤15字符，最多1000词）
    // 2026-09-03 放开必填：允许不填（返回空数组，由调用处决定是否挂字段）；有内容时数量/长度校验照旧
    storeSearchWordDtoList() {
      const lines = this.zstitlesString.split('\n').map(line => line.trim()).filter(line => line);
      if (lines.length === 0) {
        return [];
      }
      if (lines.length > 1000) {
        this.$message.error('搜索提词最多支持 1000 个关键词，请精简后再搭建');
        return null;
      }
      for (const line of lines) {
        if (line.length > 15) {
          this.$message.error('搜索提词单条最长 15 个字符，请检查："' + line + '"');
          return null;
        }
      }
      // 按转化目标出价（商店）：广告组走 ground 11821 分支（chargeType=5），平台要求搜索提词出价必须为空（实测报错 70111"按转化目标出价（商店）搜索提词出价必须为空"），词传 price:null；
      // 其余场景每词出价 2 元（200000 毫分，1元=100000毫分），精准匹配（matchType=2）
      // 词对象必须带完整字段（state/source/suggestedBid/statusText）：实测裸 {word, matchType} 缺失 state/source 报通用 70111"操作失败"，补齐后成功（2026-08-26 二分验证）
      const useConversionPrice = this.beSelectAdType == 2 && this.formLabelAlign.mediaType == 0 && this.formLabelAlign1.cvType
      return lines.map(line => useConversionPrice
        ? { word: line, matchType: 2, state: 0, source: 1, suggestedBid: null, price: null, statusText: false }
        : { word: line, matchType: 2, state: 0, source: 1, suggestedBid: null, price: 200000, statusText: false });
    },
    // 搜索提词版位：模板类型是否需要图片素材（0-无/6-基础样式-无图/15-标签气泡/16-高亮一句话 无需图片；14-挂件/19-列表背景 需图但传 imgsUrl）
    storeTemplateNeedsImage(templateType) {
      return ![0, 2, 6, 15, 16].includes(Number(templateType));
    },
    // 搜索提词版位：挂件（14）/列表背景（19）的图片字段为 imgsUrl（doc 269 常见问题），复用 getImageUrl2 的域名拼接
    storeSearchImgUrl(filePath) {
      return filePath ? this.getImageUrl2({ filePath }) : ''
    },
    // 创建广告api
    async guanggao(parms, parms1, indexs) {
      console.log(parms);
      console.log(parms.creativeList);
      console.log(parms1);

      // 广告名带毫秒时间戳：与计划/组名同款，避免同账户重复搭建广告重名（time1 同时供下方请求 timestamp 使用）
      let time1 = parseInt(new Date().getTime()) + '';

      let data = {
        creativeList: parms.creativeList,
        groupId: parms.groupId,
        name: parms.name + '_' + time1 + '_' + this.formLabelAlign.name + indexs + '_' + this.artistName,
        clickMonitorUrl: parms.clickMonitorUrl,
        viewMonitorUrl: parms.viewMonitorUrl
      }
      if (this.formLabelAlign3.placeType[1] == 0) {
        data = { ...data, placeType: Number(this.formLabelAlign3.placeType[0]) }
      }
      // deepLink 分版位处理：搜索提词版位按 doc 269 顶层无此参数，只挂在 creativeList 的 templateType=7 创意上；
      // 其他版位恢复历史行为（与提交前 guanggao 一致）：非 H5 版位发顶层 deepLink（大写，与全库一致），单级版位（placeType[1]==0）按历史置 null
      if (this.beSelectAdType == 11) {
        data.h5Type = 2
        data.pageUrl = this.idsList[indexs].url
      } else if (!this.isStoreSearchPlacement) {
        data.deepLink = parms.adcreativedeeplink
        if (this.formLabelAlign3.placeType[1] == 0) {
          data = { ...data, deepLink: null }
        }
      }
      // 搜索提词版位：透传搜索位置/选词模式/流量优选（无虚拟位置概念）
      // 级联三级取值：placeType=[0]版位21、[1]displayPosition（1-搜索列表/2-搜索首位）、[2]模板类型（构造创意时用）
      if (this.isStoreSearchPlacement) {
        data = {
          ...data,
          placeType: Number(this.formLabelAlign3.placeType[0]),
          displayPosition: Number(this.formLabelAlign3.placeType[1]),
          wordChoiceModel: Number(this.formLabelAlign3.wordChoiceModel),
          generalSwitch: Number(this.formLabelAlign3.generalSwitch),
        }
      }

      // 获取当前时间
      const today = new Date();
      const year = today.getFullYear();
      const month = String(today.getMonth() + 1).padStart(2, '0');
      const day = String(today.getDate()).padStart(2, '0');
      const formattedDate = `${year}-${month}-${day}`;

      let nonce = Math.round(Math.random() * 100000000000)


      if (this.formLabelAlign.mediaType == 0) {
        await axios.post('api/openapi/v1/ad/advertisement/add?access_token=' + parms.token + '&timestamp=' + time1 + '&nonce=' + nonce + '&advertiser_id=' + parms.ids + '', data).then(async res => {
          if (res.data.code == 0) {
            this.successhisstory_list = [...this.successhisstory_list, res.data.message]
            // 该接口成功响应仅含 id（无 creativeIdList/adId，见 doc 269），以提交创意条数统计
            const createdCnt = (parms.creativeList || []).length;
            this.addBuildLog((parms1 || {}).idsname || '', (parms1 || {}).ids || '', '广告创建', '成功', parms.name, '创建' + createdCnt + '条创意');
            console.log("查看素材库名称");
            console.log(this.selectedLibrary.scName)
            await this.updateMaterialStat(this.selectedLibrary.scName, createdCnt);
          }

          if (res.data.code !== 0 && res.data.code != "0") {
            this.addBuildLog((parms1 || {}).idsname || '', (parms1 || {}).ids || '', '广告创建', '失败', parms.name, res.data.message);
            const str = res.data.message;
            const startIndex = str.indexOf("[") + 1;
            const endIndex = str.indexOf("]");
            const code = str.substring(startIndex, endIndex);  // 如 "266773769"

            // 查找图片索引
            let idx = this.fileCode.indexOf(code);
            let target = null;
            let type = '';

            if (idx !== -1) {
              target = this.fileList[idx];
              type = '图片';
            } else {
              // 查找视频
              const vidx = this.videofileCode.findIndex(v => v.videocode == code);
              if (vidx !== -1) {
                target = this.VideofileList[vidx];
                type = '视频';
              }
            }

            if (target) {
              this.errorMaterialsList.push({
                name: target.name || target.title || '未命名',
                type: type,
                code: code,
                message: res.data.message
              });
            } else {
              this.errorMaterialsList.push({
                name: `未知素材(${code})`,
                type: '未知',
                code: code,
                message: res.data.message
              });
            }
            // ========== 修改结束 ==========
          }

          console.log(res.data);
          console.log(this.zsfileCode);
          console.log(this.zsvideofileCode);

          let currentElement
          let indexInArray1

          if (this.zsfileCode.length > 0 && res.data.data && Array.isArray(res.data.data.creativeIdList)) {
            const requests = [];
            for (let i = 0; i < this.zsfileCode.length; i++) {
              const currentElement = this.zsfileCode[i];
              const targetId = currentElement;

              const indexInArray1 = parms.creativeList.findIndex(item => item.imgsCode === targetId);
              const reverseIndexInArray2 = res.data.data.creativeIdList.length - 1 - indexInArray1;

              if (reverseIndexInArray2 >= 0 && reverseIndexInArray2 < res.data.data.creativeIdList.length) {
                const elementInArray2 = res.data.data.creativeIdList[reverseIndexInArray2];
                console.log(`array1 中 id 为 ${targetId} 的元素，对应 array2 中倒序下标 ${reverseIndexInArray2} 的元素是: ${elementInArray2}`);
                let obj = { ...parms1, cyid: elementInArray2, adid: res.data.data.adId, adtag: "撞审图片" }

                requests.push(
                  axios.post('https://control.zjwec.cn/creativeRecord/add', obj).then(ress => {
                    console.log(ress.data);
                    return ress.data;
                  }).catch(error => {
                    console.error(`请求出错: ${error}`);
                    return null;
                  })
                );
              } else {
                console.log(`array1 中 id 为 ${targetId} 的元素，在 array2 中没有对应的倒序元素。`);
              }
            }
            Promise.all(requests).then(results => {
              console.log('所有请求已完成', results);
            });
          }

          if (this.zsvideofileCode.length > 0 && res.data.data && Array.isArray(res.data.data.creativeIdList)) {
            const requests = [];
            for (let i = 0; i < this.zsvideofileCode.length; i++) {
              const currentElement = this.zsvideofileCode[i];
              const targetId = currentElement;

              const indexInArray1 = parms.creativeList.findIndex(item => item.videoCode === targetId);
              const reverseIndexInArray2 = res.data.data.creativeIdList.length - 1 - indexInArray1;

              if (reverseIndexInArray2 >= 0 && reverseIndexInArray2 < res.data.data.creativeIdList.length) {
                const elementInArray2 = res.data.data.creativeIdList[reverseIndexInArray2];
                console.log(`array1 中 id 为 ${targetId} 的元素，对应 array2 中倒序下标 ${reverseIndexInArray2} 的元素是: ${elementInArray2}`);
                let obj = { ...parms1, cyid: elementInArray2, adid: res.data.data.adId, adtag: "撞审视频" }

                requests.push(
                  axios.post('https://control.zjwec.cn/creativeRecord/add', obj).then(ress => {
                    console.log(ress.data);
                    return ress.data;
                  }).catch(error => {
                    console.error(`请求出错: ${error}`);
                    return null;
                  })
                );
              } else {
                console.log(`array1 中 id 为 ${targetId} 的元素，在 array2 中没有对应的倒序元素。`);
              }
            }
            Promise.all(requests).then(results => {
              console.log('所有请求已完成', results);
            });
          }
        })
      } else {
        await axios.post('api/openapi/v1/ad/advertisement/add/customize/adCreative?access_token=' + parms.token + '&timestamp=' + time1 + '&nonce=' + nonce + '&advertiser_id=' + parms.ids + '', data).then(async res => {
          if (res.data.code == 0) {
            this.successhisstory_list = [...this.successhisstory_list, res.data.message]
            const createdCnt = (res.data.data && res.data.data.creativeIdList) ? res.data.data.creativeIdList.length : 0;
            this.addBuildLog((parms1 || {}).idsname || '', (parms1 || {}).ids || '', '广告创建', '成功', parms.name, '创建' + createdCnt + '条创意');
            console.log("查看素材库名称");
            console.log(this.selectedLibrary.scName)
            await this.updateMaterialStat(this.selectedLibrary.scName, res.data.data.creativeIdList.length);
          }

          if (res.data.code !== 0 && res.data.code != "0") {
            this.addBuildLog((parms1 || {}).idsname || '', (parms1 || {}).ids || '', '广告创建', '失败', parms.name, res.data.message);
            const str = res.data.message;
            const startIndex = str.indexOf("[") + 1;
            const endIndex = str.indexOf("]");
            const code = str.substring(startIndex, endIndex);  // 如 "266773769"

            // 查找图片索引
            let idx = this.fileCode.indexOf(code);
            let target = null;
            let type = '';

            if (idx !== -1) {
              target = this.fileList[idx];
              type = '图片';
            } else {
              // 查找视频
              const vidx = this.videofileCode.findIndex(v => v.videocode == code);
              if (vidx !== -1) {
                target = this.VideofileList[vidx];
                type = '视频';
              } else {
                target = this.VideofileList[vidx];
                type = '封面';
              }
            }

            if (target) {
              this.errorMaterialsList.push({
                name: target.name || target.title || '未命名',
                type: type,
                code: code,
                message: res.data.message
              });
            } else {
              this.errorMaterialsList.push({
                name: `未知素材(${code})`,
                type: '未知',
                code: code,
                message: res.data.message
              });
            }
            // ========== 修改结束 ==========
          }

          console.log(res.data);
          console.log(this.zsfileCode);
          console.log(this.zsvideofileCode);

          let currentElement
          let indexInArray1

          if (this.zsfileCode.length > 0) {
            const requests = [];
            for (let i = 0; i < this.zsfileCode.length; i++) {
              const currentElement = this.zsfileCode[i];
              const targetId = currentElement;

              const indexInArray1 = parms.creativeList.findIndex(item => item.imgsCode === targetId);
              const reverseIndexInArray2 = res.data.data.creativeIdList.length - 1 - indexInArray1;

              if (reverseIndexInArray2 >= 0 && reverseIndexInArray2 < res.data.data.creativeIdList.length) {
                const elementInArray2 = res.data.data.creativeIdList[reverseIndexInArray2];
                console.log(`array1 中 id 为 ${targetId} 的元素，对应 array2 中倒序下标 ${reverseIndexInArray2} 的元素是: ${elementInArray2}`);
                let obj = { ...parms1, cyid: elementInArray2, adid: res.data.data.adId, adtag: "撞审图片" }

                requests.push(
                  axios.post('https://control.zjwec.cn/creativeRecord/add', obj).then(ress => {
                    console.log(ress.data);
                    return ress.data;
                  }).catch(error => {
                    console.error(`请求出错: ${error}`);
                    return null;
                  })
                );
              } else {
                console.log(`array1 中 id 为 ${targetId} 的元素，在 array2 中没有对应的倒序元素。`);
              }
            }
            Promise.all(requests).then(results => {
              console.log('所有请求已完成', results);
            });
          }

          if (this.zsvideofileCode.length > 0) {
            const requests = [];
            for (let i = 0; i < this.zsvideofileCode.length; i++) {
              const currentElement = this.zsvideofileCode[i];
              const targetId = currentElement;

              const indexInArray1 = parms.creativeList.findIndex(item => item.videoCode === targetId);
              const reverseIndexInArray2 = res.data.data.creativeIdList.length - 1 - indexInArray1;

              if (reverseIndexInArray2 >= 0 && reverseIndexInArray2 < res.data.data.creativeIdList.length) {
                const elementInArray2 = res.data.data.creativeIdList[reverseIndexInArray2];
                console.log(`array1 中 id 为 ${targetId} 的元素，对应 array2 中倒序下标 ${reverseIndexInArray2} 的元素是: ${elementInArray2}`);
                let obj = { ...parms1, cyid: elementInArray2, adid: res.data.data.adId, adtag: "撞审视频" }

                requests.push(
                  axios.post('https://control.zjwec.cn/creativeRecord/add', obj).then(ress => {
                    console.log(ress.data);
                    return ress.data;
                  }).catch(error => {
                    console.error(`请求出错: ${error}`);
                    return null;
                  })
                );
              } else {
                console.log(`array1 中 id 为 ${targetId} 的元素，在 array2 中没有对应的倒序元素。`);
              }
            }
            Promise.all(requests).then(results => {
              console.log('所有请求已完成', results);
            });
          }
        })
      }
      console.log(this.zsfileCode);
      console.log(this.zsvideofileCode);
    },
    //更新素材统计数据
    /**
     * 调用后端接口，增加广告创意统计数量（支持幂等性）
     * @param {String} accountName - 广告主账号
     * @param {Number} createdCount - 新增的创意数量
     */
    async updateMaterialStat(accountName, createdCount) {
      // 获取当天日期（格式 yyyy-MM-dd）
      const today = new Date().toISOString().slice(0, 10);

      // 生成幂等性 Key：账号 + 日期 + 时间戳（保证唯一性）
      // 如果是批量任务，前端应该生成一个固定的 key 并传入，这里仅做示例
      const idempotencyKey = `${accountName}-${today}-${Date.now()}`;

      try {
        await axios.post("https://control.zjwec.cn/api/creative-counts/increment", {
          accountName: accountName,       // 广告主账号
          increment: createdCount,        // 新增数量
          // 统计日期
          region: this.selectedRegion,
          idempotencyKey: idempotencyKey  // 幂等 Key，避免重复累计
        });
        this.$message.success("统计数据已更新");
      } catch (e) {
        this.$message.error("更新统计数据失败");
      }
    },
    formatTimestamp(timestamp) {
      // 创建Date对象（注意时间戳是毫秒级）
      const date = new Date(timestamp);

      // 获取各时间组件
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0'); // 月份从0开始
      const day = String(date.getDate()).padStart(2, '0');

      // 组合成YYYY-MM-DD格式
      return `${year}-${month}-${day}`;
    },
    //获取时间方法
    //获取当前日期函数
    getNowFormatDate() {
      let date = new Date(),
        year = date.getFullYear(), //获取完整的年份(4位)
        month = date.getMonth() + 1, //获取当前月份(0-11,0代表1月)
        strDate = date.getDate() // 获取当前日(1-31)
      if (month < 10) month = `0${month}` // 如果月份是个位数，在前面补0
      if (strDate < 10) strDate = `0${strDate}` // 如果日是个位数，在前面补0

      return `${year}-${month}-${strDate}`
    },
    async optimizeRequests() {
      const groupedMap = new Map();
      this.timeeditlist.forEach(item => {
        const key = item.ids;
        if (!groupedMap.has(key)) {
          groupedMap.set(key, {
            token: item.token,
            ids: item.ids,
            groupIds: [item.groupId]
          });
        } else {
          groupedMap.get(key).groupIds.push(item.groupId);
        }
      });

      // 转换成最终形式
      const mergedList = Array.from(groupedMap.values()).map(item => ({
        token: item.token,
        ids: item.ids,
        groupIds: item.groupIds.join(',')
      }));
      console.log(mergedList);
      const results = mergedList.map(req => this.PostGroupTime(req))
      // );

      return results;
    },
    //图片上传api

    //修改日期Api
    async PostGroupTime2(pams) {
      let time = parseInt(new Date().getTime()) + '';
      let nonce2 = Math.round(Math.random() * 100000000000)

      await this.$axios.post('api/openapi/v1/ad/group/batchEditTime?access_token=' + pams.token + '&timestamp=' + time + '&nonce=' + nonce2 + '&advertiser_id=' + pams.ids,
        {
          "ids": pams.groupIds,
          "scheduleTime": this.time_list,
        }).then(resp => {
          if (resp.data.code === 70111) {
            this.$notify.error({
              title: '错误',
              message: '修改投放时段失败，请检查时段是否错误'
            });
          } else {
            this.$notify({
              title: '成功',
              message: '修改投放时段成功',
              type: 'success',
              position: 'bottom-left'
            });
            this.dialog = false
          }

        })


    },
    async PostGroupTime(pams) {
      let time = parseInt(new Date().getTime()) + '';
      let nonce2 = Math.round(Math.random() * 100000000000)
      try {
        await this.$axios.post('api/openapi/v1/ad/group/batchEditTime?access_token=' + pams.token + '&timestamp=' + time + '&nonce=' + nonce2 + '&advertiser_id=' + pams.ids,
          {
            "ids": pams.groupIds,
            "scheduleTime": this.time_list,
          }).then(resp => {
            if (resp.data.code === 70111) {
              this.$notify.error({
                title: '错误',
                message: '修改投放时段失败，请检查时段是否错误'
              });
            } else {
              this.$notify({
                title: '成功',
                message: '修改投放时段成功',
                type: 'success',
                position: 'bottom-left'
              });
              this.dialog = false
            }

          })
      } catch (error) {
        this.failedRequests = [...this.failedRequests, pams]
        this.$notify.error({
          title: '错误',
          message: '修改投放时段失败，请检查时段是否错误'
        });
      }

    },
    // 执行清理操作


    async confimuuid() {
      // 获取原始UUID字符串并拆行
      var raw = this.cleanForm.customUuids;
      var lines = raw.split('\n');

      // 预处理UUID并去空行
      var uuids = [];
      for (var i = 0; i < lines.length; i++) {
        var line = lines[i].trim();
        if (line.length > 0) {
          uuids.push(line);
        }
      }

      if (uuids.length === 0) {
        return;
      }

      // 获取cookie
      var cookie = this.findCookieByName(this.cleanForm.hdname);

      // 创建请求数组
      var requests = uuids.map(u =>
        axios.get('https://control.zjwec.cn/api/bindzh/getUUid', {
          params: {
            keyword: u,
            cookie: cookie
          }
        })
      );

      try {
        var responses = await Promise.all(requests);
        var uuidList = [];

        for (var k = 0; k < responses.length; k++) {
          var res = responses[k];
          var targetUuid = uuids[k]; // 当前请求对应的 uuid

          if (res && res.data && Array.isArray(res.data.data)) {
            // 在返回的数组里查找 text === targetUuid 的对象
            var match = res.data.data.find(item => item.text === targetUuid);
            if (match && match.id) {
              uuidList.push(match.id);
            }
          }
        }

        console.log('最终UUID列表:', uuidList);
        return uuidList;
      } catch (error) {
        console.error('批量请求出错:', error);
      }
    },
    async handleClean() {
      const hdname = this.cleanForm.hdname
      const cltime = this.cleanForm.cltime
      const source = this.cleanForm.source

      if (!hdname) {
        this.$message.warning('请选择区域')
        return
      }
      if (!cltime) {
        this.$message.warning('请选择保留日期')
        return
      }

      let effectiveIds = []
      if (source === 'account') {
        await this.findIds()
        if (!this.idsList || !this.idsList.length || !this.idsList[0].id) {
          this.$message.warning('请输入有效的账号')
          return
        }
        for (let i = 0; i < this.idsList.length; i++) {
          const val = this.idsList[i].ids
          if (val && val.trim()) {
            effectiveIds.push(val.trim())
          }
        }
      } else {
        // const lines = this.cleanForm.customUuids.split('\n')
        // for (let i = 0; i < lines.length; i++) {
        //   const id = lines[i].trim()
        //   if (id) {
        //     effectiveIds.push(id)
        //   }
        // }
        effectiveIds = await this.confimuuid()
      }

      if (!effectiveIds.length) {
        this.$message.warning('请输入有效UUID')
        return
      }

      this.cleanLoading = true
      try {
        const url = `/vivoAccount/clean?ids=${encodeURIComponent(effectiveIds.join(','))}&hdname=${encodeURIComponent(hdname)}&cltime=${encodeURIComponent(cltime)}`;

        const response = await get(url);
        this.$message.success(response || '清理成功')
        this.cleanDialogVisible = false
      } catch (e) {
        this.$message.error(e.message || '清理失败')
      } finally {
        this.cleanLoading = false
      }
    },
    // 显示清理弹窗
    showCleanDialog() {
      this.cleanDialogVisible = true;
    },
    // 重置清理表单
    resetCleanForm() {
      this.cleanForm = {
        hdname: '',
        accountIds: '',
      };
    },
    failedRequestsclaerfrom() {
      this.failedRequestsDialogVisible = false
    },
    async handlefailedRequestsDialogVisible() {
      const results = await Promise.all(
        failedRequests.map(req => this.PostGroupTime2(req))
      );
      this.failedRequestsDialogVisible = false
    },
    failedRequestserrorIdslDlogFun() {
      this.failedRequestsDialogVisible = true
    },
    // resetCleanForm() {
    //   this.cleanForm = {
    //     hdname: '',
    //     accountIds: '',
    //   };
    // },
    change() {
      console.log(this.towName)
    },
    onChange(a, fileList) {
      console.log("11111");
      if (!this.selectedLibrary) {
        this.$message({
          message: '请选择素材!',
          type: 'warning'
        });
        return
      }
      if (!this.username) {
        this.$message({
          message: '请选择姓名!',
          type: 'warning'
        });
        return
      }
      this.tpchange = true
      if (this.localselection) {

        this.uploadDialogVisible = true
        return
      } else {
        this.showVue2 = true
        this.$store.commit('updateselectedLibrary', this.selectedLibrary);
      }

    },
    txonChange(a, fileList) {
      this.txchange = true
      console.log("执行了txchange");
      if (!this.selectedLibrary) {
        this.$message({
          message: '请选择素材!',
          type: 'warning'
        });
        return
      }
      if (!this.username) {
        this.$message({
          message: '请选择姓名!',
          type: 'warning'
        });
        return
      }
      console.log(this.selectedLibrary);
      if (this.localselection) {
        this.uploadDialogVisible = true
        return
      } else {
        this.showVue2 = true
        console.log(this.selectedLibrary.scId);
        this.$store.commit('updateselectedLibrary', this.selectedLibrary);
      }


    },
    zsonChange() {
      this.zstpchange = true
      if (this.localselection) {

        this.uploadDialogVisible = true
        return
      } else {
        this.showVue2 = true
      }
    },
    onChange2() {
      if (!this.selectedLibrary) {
        this.$message({
          message: '请选择素材!',
          type: 'warning'
        });
        return
      }
      if (!this.username) {
        this.$message({
          message: '请选择姓名!',
          type: 'warning'
        });
        return
      }
      this.spchange = true
      if (this.localselection) {

        this.videouploadDialogVisible = true
        return
      } else {
        this.showVue2 = true
        this.$store.commit('updateselectedLibrary', this.selectedLibrary);
      }
    },
    zsonChange2() {
      this.zsspchange = true
      if (this.localselection) {

        this.videouploadDialogVisible = true
        return
      } else {
        this.showVue2 = true
      }
    },
    // 处理删除
    handleRemove: function (file) {
      const tp = this.fileList.findIndex(function (item) {
        return item.uid === file.uid;
      });
      if (tp !== -1) {
        this.fileList.splice(tp, 1);
        this.fileCode.splice(tp, 1);  // 使用 splice 而不是 slice
      }
    },

    zshandleRemove: function (file) {
      var zstp = this.zsfileList.findIndex(function (item) {
        return item.uid === file.uid;
      });
      if (zstp !== -1) {
        this.zsfileList.splice(zstp, 1);
        this.zsfileCode.slice(zstp, 1)
      }
    },

    txhandleRemove(file, fileList) {
      // console.log(file, fileList);
    },

    // 处理预览
    handlePictureCardPreview: function (file) {
      console.log();
      this.dialogImageUrl = 'https://ads-marketing-vivofs.vivo.com.cn/' + file.filePath;
      this.dialogVisible = true;
    },
    zshandlePictureCardPreview: function (file) {
      this.dialogImageUrl = 'https://ads-marketing-vivofs.vivo.com.cn/' + file.filePath;
      this.dialogVisible = true;
    },

    txhandlePictureCardPreview(file) {
      console.log(file)
      // this.dialogImageUrl = file.url;
      // this.dialogVisible = true;
    },
    handleRemove2(targetCode) {
      console.log('要删除的code:', targetCode);
      console.log('删除前的列表:', this.VideofileList);

      // ✅ 使用数组变异方法确保响应式更新
      for (let i = this.VideofileList.length - 1; i >= 0; i--) {
        if (this.VideofileList[i].code === targetCode) {
          this.VideofileList.splice(i, 1);
          break; // 如果code唯一，找到后就退出
        }
      }

      console.log('删除后的列表:', this.VideofileList);
    },

    zshandleRemove2(targetCode) {
      this.zsVideofileList = this.zsVideofileList.filter(
        item => item.code !== targetCode
      );
    },
    handlePictureCardPreview2(file) {


    },
    zshandlePictureCardPreview2(file) {


    },
    clearFiles1(file, fileList) {
      this.$refs.upload.clearFiles()
      this.$refs.upload12.clearFiles()

    },
    /** 搭建记录 - 添加记录（计划搭建设置整条新记录，后两步更新最近一条匹配记录） */
    addBuildLog(accountName, accountId, step, status, planName, message) {
      const key = accountName + '_' + accountId;
      if (step === '计划搭建') {
        // 计划搭建：始终创建新记录（每次搭建都新增一行）
        const log = {
          key: key,
          accountName: accountName || '',
          accountId: accountId || '',
          planStatus: status,
          planMsg: message,
          groundStatus: '-',
          groundMsg: '',
          guanggaoStatus: '-',
          guanggaoMsg: '',
          timestamp: Date.now()
        };
        this.buildLogs.push(log);
        this.buildLogs.sort((a, b) => b.timestamp - a.timestamp);
      } else {
        // 广告组/广告创建：更新最近一条（按 key 匹配且对应步骤还未填充的记录）
        const fromEnd = [...this.buildLogs].reverse();
        const target = fromEnd.find(l => {
          if (l.key !== key) return false;
          if (step === '广告组搭建') return l.groundStatus === '-';
          if (step === '广告创建') return l.guanggaoStatus === '-';
          return false;
        });
        if (target) {
          if (step === '广告组搭建') {
            target.groundStatus = status;
            target.groundMsg = message;
          } else if (step === '广告创建') {
            target.guanggaoStatus = status;
            target.guanggaoMsg = message;
          }
          target.timestamp = Date.now();
          this.buildLogs.sort((a, b) => b.timestamp - a.timestamp);
        } else {
          // 找不到匹配的记录（异常情况），创建新记录
          const log = {
            key: key,
            accountName: accountName || '',
            accountId: accountId || '',
            planStatus: '-',
            planMsg: '',
            groundStatus: (step === '广告组搭建') ? status : '-',
            groundMsg: (step === '广告组搭建') ? message : '',
            guanggaoStatus: (step === '广告创建') ? status : '-',
            guanggaoMsg: (step === '广告创建') ? message : '',
            timestamp: Date.now()
          };
          this.buildLogs.push(log);
          this.buildLogs.sort((a, b) => b.timestamp - a.timestamp);
        }
      }
    },
    /** 搭建记录 - 时间格式化 */
    formatBuildLogTime(timestamp) {
      if (!timestamp) return '';
      const date = new Date(timestamp);
      const y = date.getFullYear();
      const m = String(date.getMonth() + 1).padStart(2, '0');
      const d = String(date.getDate()).padStart(2, '0');
      const h = String(date.getHours()).padStart(2, '0');
      const min = String(date.getMinutes()).padStart(2, '0');
      const s = String(date.getSeconds()).padStart(2, '0');
      return `${y}-${m}-${d} ${h}:${min}:${s}`;
    },
    /** 搭建记录 - 清空全部记录 */
    clearBuildLogs() {
      this.$confirm('确定清空所有搭建记录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.buildLogs = [];
        this.$message.success('已清空搭建记录');
      }).catch(() => { });
    },
  },
  created() {
    this.showLibrarySelector();
    this.fetchHdCookieData()
    this.fetchAdvRecordTodayTotal();
    //自动加载indexs方法
    axios.get('https://test.nbweiou.cn/api/find_list_name', {}).then(
      res => {
        this.listname = res.data
        console.log(this.listname)
      }
    )

    // 获取定向包列表
    axios.get('https://control.zjwec.cn/api/directpkgs/list', {}).then(res => {
      this.presetOptions = res.data

    }
    )


  }
}
</script>
<style>
.text {
  font-size: 14px;
}

.item {
  margin-bottom: 18px;
}

.el-form-item {
  margin-bottom: 7px;
  margin-top: 20px;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}

.clearfix:after {
  clear: both
}


.box-card1 {
  position: absolute;
  ;
  top: 0px;
  bottom: 0;
  left: 0;
  right: 0;
  margin: 0 auto;
  width: 50%;
}

.box-card2 {
  position: absolute;
  top: 550px;
  bottom: 0;
  left: 0;
  right: 0;
  margin: 0 auto;
  width: 40%;
}

.box-cardf1s {
  position: absolute;
  top: 1550px;
  bottom: 0;
  left: 0px;
  right: 0px;
  margin: 0 auto;
  width: 40%;
}

.box-card {
  /*position: absolute;*/
  /*top: 1000px;*/
  /*bottom: 0;*/
  /*!*left: 1000px;*!*/
  /*right: 50px;*/
  /*!*margin:0 auto;*!*/
  position: fixed;
  bottom: 35px;
  right: 30px;
  width: 40%;
}

.box-cards {
  /*position: absolute;*/
  /*top: 1000px;*/
  /*bottom: 0;*/
  /*!*left: 1000px;*!*/
  /*right: 50px;*/
  /*!*margin:0 auto;*!*/
  position: fixed;
  top: 20px;
  left: 30px;
  width: 20%;
}

.jdt {
  margin: 0 auto;
}

.el-icon-plus {
  width: 20px;
  height: 20px;
}

.test {
  width: 20px;
  height: 20px;
}

/* ===== 标签气泡颜色下拉（labelColor 四选一，色点+高亮行样式）===== */
/* 触发框：常态 1px 浅灰边框、圆角 8px；展开时 2px 蓝紫边框 */
.label-color-select .el-input__inner {
  border-radius: 8px;
  border: 1px solid #DCDFE6;
}

.label-color-select .el-input.is-focus .el-input__inner {
  border: 2px solid #5B5BD6;
}

/* 下拉面板：挂 body，圆角 8px + 柔和阴影 + 顶部中央三角 */
.label-color-popper.el-select-dropdown {
  border: none;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
}

.label-color-popper::before {
  content: '';
  position: absolute;
  top: -6px;
  left: 50%;
  margin-left: -6px;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-bottom: 6px solid #fff;
}

/* popper 向上展开时三角翻转到下方（x-placement 由 popper.js 写入） */
.label-color-popper[x-placement^="top"]::before {
  top: auto;
  bottom: -6px;
  border-bottom: none;
  border-top: 6px solid #fff;
}

/* 列表项：色点 + 色名 flex 布局，行内 12px 上下内边距 */
.label-color-popper .el-select-dropdown__item {
  display: flex;
  align-items: center;
  height: auto;
  padding: 12px 16px;
  line-height: 1.5;
  color: #333;
}

/* 悬停/选中行：浅灰背景（Element UI 的 hover 由 JS 控制 class） */
.label-color-popper .el-select-dropdown__item.hover,
.label-color-popper .el-select-dropdown__item:hover,
.label-color-popper .el-select-dropdown__item.selected {
  background: #F0F2F5;
  color: #333;
  font-weight: normal;
}

/* 色点：16px 实心圆 */
.label-color-dot {
  display: inline-block;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  margin-right: 8px;
  flex-shrink: 0;
}

.label-color-name {
  font-size: 14px;
}
</style>


<style scoped>
.time-range-container {}

.time-range-item {
  margin-bottom: 10px;
  display: flex;
  align-items: center;
}

.separator {
  margin: 0 10px;
}

.el-time-select {
  width: 120px;
}

.result {
  margin-top: 20px;
  font-family: monospace;
  word-break: break-all;
}
</style>


<style scoped>
.switch-group {
  display: flex;
  align-items: center;
  gap: 24px;
  /* 控制开关之间的间距 */
}

.switch-item {
  display: flex;
  align-items: center;
  gap: 8px;
  /* 控制开关与文字的间距 */
}

.switch-label {
  font-size: 14px;
  color: #606266;
  white-space: nowrap;
}

/* 可选：添加鼠标悬停效果 */
.switch-item:hover .switch-label {
  color: #409EFF;
}

/* 自定义样式 */
.upload-trigger {
  display: inline-block;
  padding: 8px;
  cursor: pointer;
}

/* 隐藏默认的上传按钮 */
.el-upload--picture-card {
  display: none !important;
}

.file-item {
  position: relative;
  width: 100%;
  height: 100%;
}

.el-upload-list__item-thumbnail {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.progress-container {
  position: fixed;
  top: 5%;
  left: 20%;
  transform: translate(-50%, -50%);
  width: 300px;
  /* 可根据需要调整进度条的宽度 */
  z-index: 9999999;
}

.progress-container2 {
  position: fixed;
  top: 5%;
  left: 40%;
  transform: translate(-50%, -50%);
  width: 300px;
  /* 可根据需要调整进度条的宽度 */
  z-index: 9999999;
}

.video-list {
  /* padding: 20px; */
}

.el-card {

  overflow: auto !important;
  /* 将 overflow 设置为 auto，内容超出时显示滚动条 */

}

.dd_img {
  width: 150px;
  height: 150px;
}

.dd_img img {
  width: 100%;
  height: 100%;
}

.video-list {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  /* 项目之间的间距 */
  margin: -8px;
  /* 抵消第一个和最后一个项目的边距 */
}

.video-item {
  flex: 0 0 calc(50% - 8px);
  /* 每行两个，减去一半的gap */
  box-sizing: border-box;
  margin-bottom: 16px;
}

.video-content {
  position: relative;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  padding: 12px;
  height: 100%;
  transition: all 0.3s;
}

.video-content:hover {
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.video-title {
  display: block;
  margin-bottom: 8px;
  font-size: 14px;
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.video-thumbnail {
  width: 100%;
  height: 0;
  padding-bottom: 56.25%;
  /* 16:9 比例 */
  position: relative;
  overflow: hidden;
  background: #f5f7fa;
}

.video-thumbnail video {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.delete-btn {
  position: absolute;
  top: 8px;
  right: 8px;
  color: #f56c6c;
}


.checkbox-section {
  margin-top: 10px;
  border: 1px solid #e4e7ed;
  border-radius: 4px;
  padding: 15px;
  background-color: #fafafa;
}

.select-all-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
  padding-bottom: 10px;
  border-bottom: 1px solid #f0f0f0;
}

.select-all-row .el-checkbox {
  font-weight: bold;
}

.select-count {
  font-size: 12px;
  color: #909399;
  background-color: #ecf5ff;
  padding: 2px 8px;
  border-radius: 10px;
}

.el-alert--warning {
  margin: 8px 0;
}

/* 优化机型复选框布局 */
.el-checkbox-group {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.el-checkbox-group .el-checkbox {
  margin-right: 0;
}
</style>


<!-- 在 Vue2 组件内部需要添加如下样式 -->
<!-- Vue2.vue -->



// WEBPACK FOOTER //
// src/components/login/vivopidaces.vue